/* eslint-disable max-len */
import {API_ENDPOINT_JSON} from '../../../../../config';
import {calculateSum} from '../../../../../pages/esgManager/constants/commonFunctions';
import {
  conditionType,
  inputType
} from '../../../../../pages/esgManager/interface/inputType';
import {FieldConditions} from '../../../interface/form-conditions';
import {fixRowDependency} from '../../../Utils/CDP/corporate/questionDependency';
import {COUNTRY_OPTIONS, PROTOCOL_OPTIONS} from '../SME/smeQuestions';

import {
  ABS_OPTIONS,
  ACTIVITY_OPTIONS,
  AGGREGATION_WEIGHTING_USED_OPTIONS,
  ALLOCATION_CHALLENGES_OPTIONS,
  ALLOCATION_LEVEL_OPTIONS,
  ALLOCATION_METHOD_OPTIONS,
  APPROACHES_BY_WHICH_THE_SELECTED_PROGRAM_REQUIRES_THIS_PROJECT_TO_ADDRESS_REVERSAL_RISK_OPTIONS,
  ARE_YOU_PROVIDING_PRODUCT_LEVEL_DATA_FOR_YOUR_ORGANIZATION_S_GOODS_OR_SERVICES_OPTIONS,
  ASSESSMENT_OF_LIFE_CYCLE_EMISSIONS_OPTIONS,
  ASSESSMENT_OF_LIFE_CYCLE_EMISSIONS_OPTIONS_2,
  ASSET_CLASSES_COVERED_BY_THE_TARGET_OPTIONS,
  CARBON_CREDITING_PROGRAM_BY_WHICH_THE_CREDITS_WERE_ISSUED_OPTIONS,
  CATEGORY_OF_PRODUCT_OR_SERVICE_OPTIONS,
  CERTIFICATION_SCHEME_OPTIONS,
  CHALLENGES_TO_SOURCING_RENEWABLE_ELECTRICITY_OPTIONS,
  CHANGE_FROM_LAST_REPORTING_YEAR_OPTIONS,
  COMPLETED_OR_PLANNED_OPTIONS,
  DEFINITION_OF_NET_ZERO_CARBON_OPTIONS,
  DENOMINATOR_OPTIONS,
  DENOMINATOR_UNIT_OPTIONS,
  DESCRIPTION_OPTIONS,
  DEVELOPMENT_TYPE_OPTIONS,
  DIRECTION_OF_CHANGE_OPTIONS,
  DIRECTION_OF_CHANGE_OPTIONS_2,
  EARLIEST_PROJECT_PHASE_THAT_MOST_COMMONLY_INCLUDES_AN_ASSESSMENT_OPTIONS,
  ECOLABEL_ASSOCIATED_WITH_PURCHASED_RENEWABLE_ELECTRICITY_OPTIONS,
  EMISSIONS_CALCULATION_METHODOLOGY_OPTIONS,
  EMISSIONS_CATEGORY_MECHANICAL_OPTIONS,
  EMISSIONS_CATEGORY_OPTIONS,
  EMISSIONS_SCOPES_OF_PORTFOLIO_COMPANIES_COVERED_BY_THE_TARGET_OPTIONS,
  ENERGY_ATTRIBUTE_CERTIFICATE_TYPE_OPTIONS,
  ENERGY_CARRIER_2_OPTIONS,
  ENERGY_CARRIER_OPTIONS,
  EVALUATION_STATUS_OPTIONS,
  FEEDSTOCKS_STEEL,
  FREQUENCY_OF_TARGET_REVIEWS_OPTIONS,
  FUELS_USED_AS_FEEDSTOCKS_OPTIONS,
  FURTURE_PLANS_OPTIONS,
  GHG_EMISSIONS_FOR_COMMODITY_OPTIONS,
  GLOBAL_EMISSIONS_COMPARISON_OPTIONS,
  GREENHOUSE_GAS_COVERED_BY_TARGET_OPTIONS,
  GREENHOUSE_GAS_TYPE_OPTIONS,
  GWP_REFERENCE_OPTIONS,
  HEATING_VALUE_OPTIONS,
  HYDROCARBON_OPTIONS,
  IDENTIFIED_FINANCING_MODEL_OPTIONS,
  IMPACTED_ASPECTS_OPTIONS,
  INITIATIVE_CATEGORY_AND_INITIATIVE_TYPE_OPTIONS,
  INITIATIVE_ID_OPTIONS,
  INJECTION_AND_STORAGE_PATHWAY_OPTIONS,
  INT_METRIC_OPTIONS,
  INT_OPTIONS,
  LAND_RELATED_EMISSIONS_COVERED_BY_TARGET_OPTIONS,
  LEVEL_OF_AGGREGATION_OPTIONS,
  LIFE_CYCLE_STAGES_COVERED_OPTIONS,
  LIFECYCLE_STAGE_OPTIONS,
  LOW_CARBON_TECHNOLOGY_TYPE_2_OPTIONS,
  LOW_CARBON_TECHNOLOGY_TYPE_OPTIONS,
  LOW_OPTIONS,
  MANAGEMENT_PRACTICE_OPTIONS,
  MEASUREMENT_OF_PRODUCT_SERVICE_EFFICIENCY_OPTIONS,
  METHOD_OPTIONS,
  METHOD_USED_TO_CALCULATE_AVOIDED_EMISSIONS_OPTIONS,
  METHODOLOGIES_STANDARDS_TOOLS_APPLIED_OPTIONS,
  METHODOLOGIES_STANDARDS_TOOLS_APPLIED_OPTIONS_2,
  METHODOLOGY_APPLIED_OPTIONS,
  METHODOLOGY_OPTIONS,
  METHODOLOGY_USED_WHEN_SETTING_THE_TARGET_OPTIONS,
  METHODS_THE_PROGRAM_USES_TO_ASSESS_ADDITIONALITY_FOR_THIS_PROJECT_OPTIONS,
  METRIC_DENOMINATOR_OPTIONS,
  METRIC_DENOMINATOR_OPTIONS_2,
  METRIC_DENOMINATOR_OPTIONS_3,
  METRIC_NUMERATOR_GROUPED_OPTIONS,
  METRIC_NUMERATOR_OPTIONS,
  METRIC_OPTIONS,
  METRIC_OR_TARGET_NUMERATOR_IF_INTENSITY_OPTIONS,
  METRIC_UNIT_OPTIONS,
  MP_OPTIONS,
  NORMALIZATION_FACTOR_DENOMINATOR_OPTIONS,
  NZ_OPTIONS,
  OBSERVATIONAL_DATA_OPTIONS,
  OIL_AND_GAS_BUSINESS_DIVISION_OPTIONS,
  OTH_OPTIONS,
  OTHER_INITIATIVE_LIFETIME_OPTIONS,
  OUTPUT_PRODUCT_OPTIONS,
  OUTPUT_PRODUCT_OPTIONS_2,
  OUTPUT_PRODUCT_OPTIONS_3,
  OUTPUT_PRODUCT_OPTIONS_4,
  OVERALL_EFFECT_OPTIONS,
  PAYBACK_PERIOD_OPTIONS,
  PERCENTAGE_OF_TOTAL_OPERATIONAL_SPEND_ON_ENERGY_OPTIONS,
  PLAN_TO_MITIGATE_EMISSIONS_BEYOND_VALUE_CHAIN_OPTIONS,
  PLAN_TO_PURCHASE_AND_CANCEL_CARBON_CREDITS_FOR_NEUTRALIZATION_AND_OR_BEYOND_VALUE_CHAIN_MITIGATION_OPTIONS,
  POR_OPTIONS,
  PORTFOLIOS_COVERED_BY_THE_TARGET_OPTIONS,
  POTENTIAL_SOURCES_OF_LEAKAGE_THE_SELECTED_PROGRAM_REQUIRES_THIS_PROJECT_TO_HAVE_ASSESSED_OPTIONS,
  POWER_GENERATION_TECHNOLOGY_OPTIONS,
  PRIMARY_CLIMATE_CHANGE_RELATED_BENEFIT_OPTIONS,
  PRIMARY_REASON_FOR_CHANGE_OPTIONS,
  PRIMARY_REASON_FOR_NO_PLANS_TO_DEVELOP_CAPABILITIES_TO_ALLOCATE_EMISSIONS_TO_CUSTOMERS_OPTIONS,
  PRIMARY_REASON_FOR_NOT_HAVING_TECHNIQUE_OPTIONS,
  PRIMARY_REASON_OPTIONS,
  PRIMARY_REASONS_OPTIONS,
  PROCESS_ROUTE_OPTIONS,
  PRODUCT_OPTIONS,
  PRODUCT_OPTIONS_2,
  PRODUCT_OR_SERVICE_OPTIONS,
  PRODUCT_PRODUCED_OPTIONS,
  PROJECT_AREA_OPTIONS,
  PROJECT_TYPE_OPTIONS,
  PROJECTS_ASSESSED_OPTIONS,
  PROPERTY_SECTOR_OPTIONS,
  PURCHASED_FEEDSTOCK_OPTIONS,
  PURPOSE_OF_RETIREMENT_OPTIONS,
  REASONS_FOR_CHANGE_OPTIONS,
  REASONS_WHY_IT_WAS_CHALLENGING_TO_SOURCING_RENEWABLE_ELECTRICITY_OPTIONS,
  RELEVANCE_OF_SCOPE_OPTIONS,
  RELEVANT_STANDARD_OPTIONS,
  RENEWABLE_ELECTRICITY_TECHNOLOGY_TYPE_OPTIONS,
  SCIENCE_BASED_TARGET_OPTIONS,
  SCIENCE_BASED_TARGET_OPTIONS_2,
  SCOPE_2_EMISSIONS_APPROACH_OPTIONS,
  SCOPE_2_EMISSIONS_COMPARISON_OPTIONS,
  SCOPE_3_CATEGORIES_OPTIONS,
  SCOPE_3_CATEGORY_OPTIONS,
  SCOPE_3_CATEGORY_OPTIONS_2,
  SCOPE_3_EMISSIONS_COMPARISON_OPTIONS,
  SCOPE_EMISSIONS_BREAKDOWN_OPTIONS,
  SCOPE_OF_EMISSIONS_OPTIONS,
  SCOPE_OPTIONS,
  SCOPE_OR_SCOPE_3_CATEGORY_OPTIONS,
  SCOPE_RECALCULATED_OPTIONS,
  SCOPES_COVERED_OPTIONS,
  SCOPES_OPTIONS,
  SECTOR_OPTIONS,
  SECTOR_PRODUCTION_ACTIVITY_OPTIONS,
  SOURCING_METHOD_2_OPTIONS,
  SOURCING_METHOD_3_OPTIONS,
  SOURCING_METHOD_OPTIONS,
  STAGE_OF_PROJECT_DEVELOPMENT_OPTIONS,
  STATUS_IN_CURRENT_REPORTING_YEAR_OPTIONS,
  STATUS_OF_FINANCING_OPTIONS,
  TARGET_AMBITION_OPTIONS,
  TARGET_COVERAGE_OPTIONS,
  TARGET_COVERAGE_OPTIONS_2,
  TARGET_DENOMINATOR_INTENSITY_TARGETS_ONLY_OPTIONS,
  TARGET_DENOMINATOR_OPTIONS,
  TARGET_IS_PART_OF_AN_OVERARCHING_INITIATIVE_OPTIONS,
  TARGET_IS_PART_OF_AN_OVERARCHING_INITIATIVE_OPTIONS_2,
  TARGET_IS_SET_AND_PROGRESS_AGAINST_IT_IS_TRACKED_AT_OPTIONS,
  TARGET_STATUS_IN_REPORTING_YEAR_OPTIONS,
  TARGET_TYPE_ABSOLUTE_OR_INTENSITY_OPTIONS,
  TARGET_TYPE_ACTIVITY_OPTIONS,
  TARGET_TYPE_CATEGORY_METRIC_OPTIONS,
  TARGET_TYPE_ENERGY_CARRIER_OPTIONS,
  TARGET_TYPE_ENERGY_SOURCE_OPTIONS,
  TARGET_TYPE_OPTIONS,
  TARGETS_LINKED_TO_THIS_NET_ZERO_TARGET_OPTIONS,
  TAXONOMY_OR_FRAMEWORK_USED_TO_DEFINE_GREEN_FINANCE_OPTIONS,
  TAXONOMY_USED_TO_CLASSIFY_PRODUCTS_OR_SERVICES_AS_LOW_CARBON_OPTIONS,
  TECHNOLOGY_OPTIONS,
  TOTAL_CONSUMPTION_UNIT_OPTIONS,
  TRACKING_INSTRUMENT_USED_2_OPTIONS,
  TRACKING_INSTRUMENT_USED_OPTIONS,
  TRANSPORT_MODE_OPTIONS,
  TYPE_OF_DATA_USED_OPTIONS,
  TYPE_OF_MITIGATION_ACTIVITY_OPTIONS,
  TYPE_OF_PRODUCT_OPTIONS,
  TYPE_OF_PROJECT_OPTIONS,
  TYPES_OF_CO2_TRANSFER_OPTIONS,
  TYPES_OF_PRODUCTS_OR_SERVICES_OPTIONS,
  UNIT_FOR_MARKET_VALUE_OR_QUANTITY_OF_GOODS_SERVICES_SUPPLIED_OPTIONS,
  VALUE_CHAIN_OPTIONS,
  VERIFICATION_ASSURANCE_CYCLE_OPTIONS,
  VERIFICATION_ASSURANCE_STATUS,
  VERIFICATION_ASSURANCE_TYPE_OPTIONS,
  VINTAGE_OF_RENEWABLE_ENERGY_ATTRIBUTE_OPTIONS,
  WERE_THESE_CREDITS_ISSUED_OR_PURCHASED_BY_YOUR_ORGANIZATION_OPTIONS,
  YOUR_ROLE_IN_THE_IMPLEMENTATION_OPTIONS
} from './corporateOptions';
import {CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES} from './corporateQuestionsKeys';

export const corporatePerformanceClimateChangeQuestions = [
  {
    key: '1',
    showIndex: false,
    items: [
      {
        field: [
          {
            fieldType: inputType.RADIOGROUP,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q1_VALUE,
            fieldLabel:
              '7.1 Is this your first year of reporting emissions data to CDP?',
            tooltip:
              'Data users wish to understand year-on-year changes in emissions and this question allows organizations to indicate if they have previously reported emissions data to CDP. It drives followup questions on the details of changes to corporate structure, emissions accounting boundary or methodology, or reporting year.',
            heading: inputType.HEADING,
            colSpan: true,
            options: ['Yes', 'No']
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.1.1 Has your organization undergone any structural changes in the reporting year, or are any previous structural changes being accounted for in this disclosure of emissions data?',
            tooltip:
              'Structural changes such as acquisitions, divestments, and mergers may have a significant impact on base year emissions due to the transfer of ownership or control of emitting activities from one organization to another. While a single structural change might not have a significant impact, the cumulative effect of a number of minor structural changes can result in a significant impact. This question provides data users with important context to any changes in emissions that may trigger base year emissions recalculation.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q1_VALUE,
              showWhen: ['No'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q1_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q2_VALUE,
            allowMultipleRows: false,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q1_VALUE,
            showWhen: ['No'],
            formList: {
              formFields: [
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q2_1_VALUE,
                  fieldLabel: 'Has there been a structural change?',
                  options: [
                    {
                      value: 'Yes, an acquisition',
                      label: 'Yes, an acquisition'
                    },
                    {value: 'Yes, a divestment', label: 'Yes, a divestment'},
                    {value: 'Yes, a merger', label: 'Yes, a merger'},
                    {
                      value: 'Yes, other structural change, please specify',
                      label: 'Yes, other structural change, please specify'
                    },
                    {value: 'No', label: 'No'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q2_2_VALUE,
                  fieldLabel:
                    'Name of organization(s) acquired, divested from, or merged with',
                  colSpan: true,
                  textLimit: 500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q2_1_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: [
                      'Yes, an acquisition',
                      'Yes, a divestment',
                      'Yes, a merger',
                      'Yes, other structural change, please specify'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q2_1_VALUE,
                    condition: conditionType.INCLUDES,
                    values: [
                      'Yes, an acquisition',
                      'Yes, a divestment',
                      'Yes, a merger',
                      'Yes, other structural change, please specify'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q2_1_VALUE
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q2_3_VALUE,
                  fieldLabel:
                    'Details of structural change(s), including completion dates',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q2_1_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: [
                      'Yes, an acquisition',
                      'Yes, a divestment',
                      'Yes, a merger',
                      'Yes, other structural change, please specify'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q2_1_VALUE,
                    condition: conditionType.INCLUDES,
                    values: [
                      'Yes, an acquisition',
                      'Yes, a divestment',
                      'Yes, a merger',
                      'Yes, other structural change, please specify'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q2_1_VALUE
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.1.2 Has your emissions accounting methodology, boundary, and/or reporting year definition changed in the reporting year?',
            tooltip: `Changes in emissions calculation methodology, reporting boundary approach, and/or reporting
year could result in a significant impact on the base year emissions and compromise the consistency and relevance of a company’s 
GHG emissions inventory. This question provides data users with important context to any changes in emissions that may trigger base year emissions recalculation.`,
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q1_VALUE,
              showWhen: ['No'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q1_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q3_VALUE,
            allowMultipleRows: false,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q1_VALUE,
            showWhen: ['No'],
            formList: {
              formFields: [
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q3_1_VALUE,
                  fieldLabel:
                    'Change(s) in methodology, boundary, and/or reporting year definition?',
                  options: [
                    {
                      value: 'Yes, a change in methodology',
                      label: 'Yes, a change in methodology'
                    },
                    {
                      value: 'Yes, a change in boundary',
                      label: 'Yes, a change in boundary'
                    },
                    {
                      value: 'Yes, a change in reporting year definition',
                      label: 'Yes, a change in reporting year definition'
                    },
                    {
                      value:
                        'No, but we have discovered significant errors in our previous response(s)',
                      label:
                        'No, but we have discovered significant errors in our previous response(s)'
                    },
                    {value: 'No', label: 'No'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q3_2_VALUE,
                  fieldLabel:
                    'Details of methodology, boundary, and/or reporting year definition change(s)',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q3_1_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: [
                      'Yes, a change in methodology',
                      'Yes, a change in boundary',
                      'Yes, a change in reporting year definition'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q3_1_VALUE,
                    condition: conditionType.INCLUDES,
                    values: [
                      'Yes, a change in methodology',
                      'Yes, a change in boundary',
                      'Yes, a change in reporting year definition'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q3_1_VALUE
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.1.3 Have your organization’s base year emissions and past years’ emissions been recalculated as a result',
            tooltip:
              'Significant changes (structural, methodological, boundary etc.) can alter a company’s emissions profile, making meaningful historical comparisons difficult. To maintain consistency over time, base year emissions must be retroactively recalculated to reflect changes in the company that would otherwise compromise the consistency and relevance of a company’s GHG emissions inventory. This question allows data users to understand whether the company has recalculated their base year emissions as a result of the changes or errors disclosed in 7.1.1 and 7.1.2. Ambition Companies recalculate base year emissions, and emissions from previous years to reflect changes that would otherwise compromise the consistency and relevance of the reported GHG emissions information.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q2_VALUE,
              showWhen: [
                'Yes, an acquisition',
                'Yes, a divestment',
                'Yes, a merger',
                'Yes, other structural change, please specify'
              ],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q2_1_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q4_VALUE,
            allowMultipleRows: false,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q2_1_VALUE,
            showWhen: [
              'Yes, an acquisition',
              'Yes, a divestment',
              'Yes, a merger',
              'Yes, other structural change, please specify'
            ],
            relatedTableKey:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q2_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q4_1_VALUE,
                  fieldLabel: 'Base year recalculation',
                  options: SCOPE_RECALCULATED_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q4_2_VALUE,
                  fieldLabel: 'Scope(s) recalculated',
                  options: SCOPE_RECALCULATED_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q4_1_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Yes']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q4_1_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Yes'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q4_1_VALUE
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q4_3_VALUE,
                  fieldLabel:
                    'Base year emissions recalculation policy, including significance threshold',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q4_1_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Yes']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q4_1_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Yes'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q4_1_VALUE
                  }
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q4_4_VALUE,
                  fieldLabel: 'Past years’ recalculation',
                  options: ['Yes', 'No'],
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.MULTISELECT,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q11_VALUE,
            fieldLabel:
              '7.2 Select the name of the standard, protocol, or methodology you have used to collect activity data and calculate emissions.',
            tooltip:
              'CDP data users need to understand what methods have been used to calculate emissions.',
            heading: inputType.HEADING,
            colSpan: true,
            options: PROTOCOL_OPTIONS
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.3 Describe your organization’s approach to reporting Scope 2 emissions.',
            tooltip:
              'The purpose of this question is to allow companies to disclose their approach to calculating their Scope 2 emissions. This is particularly relevant when considering market-based Scope 2 emissions, as it is important to differentiate between companies that have not reported a market-based figure as they do not have operations where there are those contractual instruments, and those companies that do have operations where there are contractual instruments but have chosen not to disclose a market-based figure. CDP asks this question to enable accurate comparability across companies.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_1_VALUE,
                  fieldLabel: 'Scope 2, location-based',
                  options: [
                    {
                      value:
                        'We are reporting a Scope 2, location-based figure',
                      label: 'We are reporting a Scope 2, location-based figure'
                    },
                    {
                      value:
                        'We are not reporting a Scope 2, location-based figure',
                      label:
                        'We are not reporting a Scope 2, location-based figure'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_2_VALUE,
                  fieldLabel: 'Scope 2, market-based',
                  options: [
                    {
                      value: 'We are reporting a Scope 2, market-based figure',
                      label: 'We are reporting a Scope 2, market-based figure'
                    },
                    {
                      value:
                        'We have no operations where we are able to access electricity supplier emission factors or residual emission factors and are unable to report a Scope 2, market-based figure',
                      label:
                        'We have no operations where we are able to access electricity supplier emission factors or residual emission factors and are unable to report a Scope 2, market-based figure'
                    },
                    {
                      value:
                        'We have operations where we are able to access electricity supplier emission factors or residual emissions factors, but are unable to report a Scope 2, market-based figure',
                      label:
                        'We have operations where we are able to access electricity supplier emission factors or residual emissions factors, but are unable to report a Scope 2, market-based figure'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_3_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.RADIOGROUP,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q12_VALUE,
            fieldLabel:
              '7.4 Are there any sources (e.g. facilities, specific GHGs, activities, geographies, etc.) of Scope 1, Scope 2 or Scope 3 emissions that are within your selected reporting boundary which are not included in your disclosure?',
            tooltip:
              'In some cases it can be difficult to gather data for all sources. Circumstances where this might be the case include sources in countries/areas or small facilities where data acquisition is difficult or unreliable. Structural changes to the organization including mergers, acquisitions and divestments can also be reasons where emissions data are not included in your disclosure. This question enables companies to report where these sources are not included in the disclosure and thus provides data users transparency into reported emissions inventories.',
            heading: inputType.HEADING,
            colSpan: true,
            options: ['Yes', 'No']
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.4.1 Provide details of the sources of Scope 1, Scope 2, or Scope 3 emissions that are within your selected reporting boundary which are not included in your disclosure. ',
            tooltip: `In some cases it can be difficult to gather data for all sources. Circumstances where this might
                        be the case include sources in countries/areas or small facilities where data acquisition is
                        difficult or unreliable. Structural changes to the organization including mergers, acquisitions and
                        divestments can also be reasons where emissions data are not included in your disclosure. This
                        question enables companies to report where these sources are not included in the disclosure
                        and thus provides data users transparency into reported emissions inventories. `,
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q12_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q12_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_VALUE,
            allowMultipleRows: false,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q12_VALUE,
            showWhen: ['Yes'],
            formList: {
              formFields: [
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_1_VALUE,
                  fieldLabel: 'Source of excluded emissions',
                  colSpan: true,
                  textLimit: 2500
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_2_VALUE,
                  fieldLabel: 'Scope(s) or Scope 3 category(ies)',
                  options: SCOPE_OR_SCOPE_3_CATEGORY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_3_VALUE,
                  fieldLabel: 'Relevance of Scope 1 emissions from this source',
                  options: RELEVANCE_OF_SCOPE_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_2_VALUE,
                    condition: conditionType.NOT,
                    values: ['Scope 1']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_2_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Scope 1'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_2_VALUE
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_4_VALUE,
                  fieldLabel:
                    'Relevance of location-based Scope 2 emissions from this source',
                  options: RELEVANCE_OF_SCOPE_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_2_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Scope 2 (location-based)',
                      'Scope 2 (market-based)'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_2_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Scope 2 (location-based)',
                      'Scope 2 (market-based)'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_2_VALUE
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_5_VALUE,
                  fieldLabel:
                    'Relevance of market-based Scope 2 emissions from this source',
                  options: RELEVANCE_OF_SCOPE_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_2_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Scope 2 (location-based)',
                      'Scope 2 (market-based)'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_2_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Scope 2 (location-based)',
                      'Scope 2 (market-based)'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_2_VALUE
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_6_VALUE,
                  fieldLabel: 'Relevance of Scope 3 emissions from this source',
                  options: RELEVANCE_OF_SCOPE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_7_VALUE,
                  fieldLabel: 'Date of completion of acquisition or merger',
                  dateFormat: 'DD-MM-YYYY',
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_3_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Emissions excluded due to a recent acquisition or merger'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_3_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Emissions excluded due to a recent acquisition or merger'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_3_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_8_VALUE,
                  fieldLabel:
                    'Estimated percentage of total Scope 1+2 emissions this excluded source represents',
                  colSpan: true,
                  roundTo: 1,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_3_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Emissions are not relevant',
                      'Emissions are relevant but not yet calculated',
                      'Emissions are relevant and calculated, but not disclosed'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_3_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Emissions are not relevant',
                      'Emissions are relevant but not yet calculated',
                      'Emissions are relevant and calculated, but not disclosed'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_3_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_9_VALUE,
                  fieldLabel:
                    'Estimated percentage of total Scope 3 emissions this excluded source represents',
                  colSpan: true,
                  roundTo: 1
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_10_VALUE,
                  fieldLabel: 'Explain why this source is excluded',
                  colSpan: true,
                  textLimit: 2500
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_11_VALUE,
                  fieldLabel:
                    'Explain how you estimated the percentage of emissions this excluded source represents',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_3_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Emissions are not relevant',
                      'Emissions are relevant but not yet calculated',
                      'Emissions are relevant and calculated, but not disclosed'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_3_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Emissions are not relevant',
                      'Emissions are relevant but not yet calculated',
                      'Emissions are relevant and calculated, but not disclosed'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q6_3_VALUE
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading: '7.5 Provide your base year and base year emissions.',
            tooltip:
              'A meaningful and consistent comparison of emissions over time requires that organizations set a performance datum with which to compare current emissions.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q7_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q7_1_VALUE,
                  fieldLabel: 'Scope',
                  options: SCOPE_OR_SCOPE_3_CATEGORY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q7_2_VALUE,
                  fieldLabel: 'Base year end',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q7_3_VALUE,
                  fieldLabel: 'Base year emissions (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q7_4_VALUE,
                  fieldLabel: 'Methodological details',
                  colSpan: true,
                  textLimit: 2500
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.6 What were your organization’s gross global Scope 1 emissions in metric tons CO2e?',
            tooltip: `Reporting emissions is a prerequisite to understanding
                      and reducing negative environmental impacts. This
                      question aims to ensure organizations are measuring
                      their carbon footprints from direct emissions.`
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q8_VALUE,
            scopeColumnTitle: 'Year',
            fixedRows: [
              {
                id: 'year0',
                label: 'Reporting year'
              },
              {
                id: 'year1',
                label: 'Past year 1'
              },
              {
                id: 'year2',
                label: 'Past year 2'
              },
              {
                id: 'year3',
                label: 'Past year 3'
              },
              {
                id: 'year4',
                label: 'Past year 4'
              },
              {
                id: 'year5',
                label: 'Past year 5'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q8_1_VALUE,
                  fieldLabel:
                    'Gross global Scope 1 emissions (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q8_2_VALUE,
                  fieldLabel: 'End date',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q8_3_VALUE,
                  fieldLabel: 'Methodological details',
                  colSpan: true,
                  textLimit: 2500
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.7 What were your organization’s gross global Scope 2 emissions in metric tons CO2e?',
            tooltip: `Reporting emissions is a pre-requisite to understanding
                        and reducing negative environmental impacts. This
                        question ensures organizations are measuring emissions from purchased or acquired electricity, steam, heat, and cooling.`
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q9_VALUE,
            scopeColumnTitle: 'Year',
            fixedRows: [
              {
                id: 'year0',
                label: 'Reporting year'
              },
              {
                id: 'year1',
                label: 'Past year 1'
              },
              {
                id: 'year2',
                label: 'Past year 2'
              },
              {
                id: 'year3',
                label: 'Past year 3'
              },
              {
                id: 'year4',
                label: 'Past year 4'
              },
              {
                id: 'year5',
                label: 'Past year 5'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q9_1_VALUE,
                  fieldLabel:
                    'Gross global Scope 1 emissions (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q9_2_VALUE,
                  fieldLabel: 'End date',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q9_3_VALUE,
                  fieldLabel: 'Methodological details',
                  colSpan: true,
                  textLimit: 2500
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.8 Account for your organization’s gross global Scope 3 emissions, disclosing and explaining any',
            tooltip:
              'For most organizations, the majority of emissions occur in stages of the value chain beyond their direct operations. This question allows data users to gauge the thoroughness of organizations’ accounting processes and to understand how organizations are analyzing their emissions footprints. 0 1 2 3 4 5 Scope 3 category Evaluation status Emissions in reporting year (metric tons CO2e) Emissions calculation methodology Percentage of emissions calculated using data obtained from suppliers or value chain partners Please explain Purchased goods and services'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q10_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q10_1_VALUE,
                  fieldLabel: 'Scope 3 category',
                  options: SCOPE_3_CATEGORY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q10_2_VALUE,
                  fieldLabel: 'Evaluation status',
                  options: EVALUATION_STATUS_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q10_3_VALUE,
                  fieldLabel: 'Emissions in reporting year (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q10_2_VALUE,
                    condition: conditionType.NOT,
                    values: ['Relevant, calculated', 'Not relevant, calculated']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q10_2_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Relevant, calculated',
                      'Not relevant, calculated'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q10_2_VALUE
                  }
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q10_4_VALUE,
                  fieldLabel: 'Emissions calculation methodology',
                  options: EMISSIONS_CALCULATION_METHODOLOGY_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q10_2_VALUE,
                    condition: conditionType.NOT,
                    values: ['Relevant, calculated', 'Not relevant, calculated']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q10_2_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Relevant, calculated',
                      'Not relevant, calculated'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q10_2_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q10_5_VALUE,
                  fieldLabel:
                    'Percentage of emissions calculated using data obtained from suppliers or value chain partners',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q10_2_VALUE,
                    condition: conditionType.NOT,
                    values: ['Relevant, calculated', 'Not relevant, calculated']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q10_2_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Relevant, calculated',
                      'Not relevant, calculated'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q10_2_VALUE
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q10_6_VALUE,
                  fieldLabel: 'Please explain',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.8.1 Disclose or restate your Scope 3 emissions data for previous years.',
            tooltip:
              'A prerequisite for a meaningful emissions data comparison is a consistent data set over time. This question enables companies to restate Scope 3 emissions data previously supplied to CDP, for example to ensure that their historical data reflects their current organizational boundary. It also enables first-time responders to provide Scope 3 emissions data for the five years prior to the reporting year'
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_VALUE,
            scopeColumnTitle: 'Year',
            fixedRows: [
              {
                id: 'year1',
                label: 'Past year 1'
              },
              {
                id: 'year2',
                label: 'Past year 2'
              },
              {
                id: 'year3',
                label: 'Past year 3'
              },
              {
                id: 'year4',
                label: 'Past year 4'
              },
              {
                id: 'year5',
                label: 'Past year 5'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_1_VALUE,
                  fieldLabel: 'End date',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_2_VALUE,
                  fieldLabel:
                    'Scope 3: Purchased goods and services (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_3_VALUE,
                  fieldLabel: 'Scope 3: Capital goods (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_4_VALUE,
                  fieldLabel:
                    'Scope 3: Fuel and energy-related activities (not included in Scopes 1 or 2) (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_5_VALUE,
                  fieldLabel:
                    'Scope 3: Upstream transportation and distribution (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_6_VALUE,
                  fieldLabel:
                    'Scope 3: Waste generated in operations (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_7_VALUE,
                  fieldLabel: 'Scope 3: Business travel (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_8_VALUE,
                  fieldLabel: 'Scope 3: Employee commuting (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_9_VALUE,
                  fieldLabel:
                    'Scope 3: Upstream leased assets (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_10_VALUE,
                  fieldLabel:
                    'Scope 3: Downstream transportation and distribution (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_11_VALUE,
                  fieldLabel:
                    'Scope 3: Processing of sold products (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_12_VALUE,
                  fieldLabel:
                    'Scope 3: Use of sold products (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_13_VALUE,
                  fieldLabel:
                    'Scope 3: End of life treatment of sold products (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_14_VALUE,
                  fieldLabel:
                    'Scope 3: Downstream leased assets (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_15_VALUE,
                  fieldLabel: 'Scope 3: Franchises (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_16_VALUE,
                  fieldLabel: 'Scope 3: Investments (metric tons CO2e) ',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_17_VALUE,
                  fieldLabel: 'Scope 3: Other (upstream) (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_18_VALUE,
                  fieldLabel: 'Scope 3: Other (downstream) (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q13_19_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2500
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.9 Indicate the verification/assurance status that applies to your reported emissions.',
            tooltip:
              'CDP supports verification and assurance as good practice in environmental reporting. This question gives data users further confidence in the accuracy of the data reported. '
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q14_VALUE,
            scopeColumnTitle: 'Scope',
            fixedRows: [
              {
                id: 'scope1',
                label: 'Scope 1'
              },
              {
                id: 'scope2',
                label: 'Scope 2 (location-based or market-based)'
              },
              {
                id: 'scope3',
                label: 'Scope 3'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q14_1_VALUE,
                  fieldLabel: 'Verification/assurance status',
                  options: VERIFICATION_ASSURANCE_STATUS,
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.9.1 Provide further details of the verification/assurance undertaken for your Scope 1 emissions, and',
            tooltip:
              'CDP supports verification and assurance as good practice in environmental reporting. This question gives data users further confidence in the accuracy of the data reported. 1 2 3 4 5 6 7 47 Verification or assurance cycle in place Status in the current reporting year Type of verification or assurance Attach the statement Page/section reference Relevant standard Proportion of reported emissions verified (%)',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q14_VALUE,
              showWhen: [
                'Third-party verification or assurance process in place'
              ],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q14_1_VALUE_SCOPE1
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q15_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q14_1_VALUE_SCOPE1,
            showWhen: [
              'Third-party verification or assurance process in place'
            ],
            relatedTableKey:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q14_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q15_1_VALUE,
                  fieldLabel: 'Verification or assurance cycle in place',
                  options: VERIFICATION_ASSURANCE_CYCLE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q15_2_VALUE,
                  fieldLabel: 'Status in the current reporting year',
                  options: STATUS_IN_CURRENT_REPORTING_YEAR_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q15_3_VALUE,
                  fieldLabel: 'Type of verification or assurance',
                  options: VERIFICATION_ASSURANCE_TYPE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.FILEUPLOAD,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q15_4_VALUE,
                  fieldLabel: 'Attach the statement',
                  colSpan: true,
                  fileUploadAction:
                    API_ENDPOINT_JSON.ESG.CDP_CORPORATE.documentUpload
                      .climateChange,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q15_2_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Underway but not complete for current reporting year - first year it has taken place',
                      'Complete'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q15_2_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Underway but not complete for current reporting year - first year it has taken place',
                      'Complete'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q15_2_VALUE
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q15_5_VALUE,
                  fieldLabel: 'Page/section reference',
                  colSpan: true,
                  textLimit: 500
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q15_6_VALUE,
                  fieldLabel: 'Relevant standard',
                  options: RELEVANT_STANDARD_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q15_7_VALUE,
                  fieldLabel: 'Proportion of reported emissions verified (%)',
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.9.2 Provide further details of the verification/assurance undertaken for your Scope 2 emissions and',
            tooltip:
              'CDP supports verification and assurance as good practice in environmental reporting. This question gives data users further confidence in the accuracy of the data reported. 1 2 3 4 5 6 7 8 Scope 2 approach Verification or assurance cycle in place Status in the current reporting year Type of verification or assurance Attach the statement Page/ section reference Relevant standard Proportion of reported emissions verified (%)',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q14_VALUE,
              showWhen: [
                'Third-party verification or assurance process in place'
              ],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q14_1_VALUE_SCOPE2
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q16_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q14_1_VALUE_SCOPE2,
            showWhen: [
              'Third-party verification or assurance process in place'
            ],
            relatedTableKey:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q14_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q16_1_VALUE,
                  fieldLabel: 'Scope 2 approach',
                  options: [
                    {
                      value: 'Scope 2 location-based',
                      label: 'Scope 2 location-based'
                    },
                    {
                      value: 'Scope 2 market-based',
                      label: 'Scope 2 market-based'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q16_2_VALUE,
                  fieldLabel: 'Verification or assurance cycle in place',
                  options: VERIFICATION_ASSURANCE_CYCLE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q16_3_VALUE,
                  fieldLabel: 'Status in the current reporting year',
                  options: STATUS_IN_CURRENT_REPORTING_YEAR_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q16_4_VALUE,
                  fieldLabel: 'Type of verification or assurance',
                  options: VERIFICATION_ASSURANCE_TYPE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.FILEUPLOAD,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q16_5_VALUE,
                  fieldLabel: 'Attach the statement',
                  colSpan: true,
                  fileUploadAction:
                    API_ENDPOINT_JSON.ESG.CDP_CORPORATE.documentUpload
                      .climateChange,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q16_3_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Underway but not complete for current reporting year - first year it has taken place',
                      'Complete'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q16_3_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Underway but not complete for current reporting year - first year it has taken place',
                      'Complete'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q16_3_VALUE
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q16_6_VALUE,
                  fieldLabel: 'Page/section reference',
                  colSpan: true,
                  textLimit: 500
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q16_7_VALUE,
                  fieldLabel: 'Relevant standard',
                  options: RELEVANT_STANDARD_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q16_8_VALUE,
                  fieldLabel: 'Proportion of reported emissions verified (%)',
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.9.3 Provide further details of the verification/assurance undertaken for your Scope 3 emissions and',
            tooltip:
              'CDP supports verification and assurance as good practice in environmental reporting. This question gives data users further confidence in the accuracy of the data reported. 1 2 3 4 Scope 3 category Verification or assurance cycle in place Status in the current reporting year Type of verification or assurance Attach the statement Page/ section reference Relevant standard Proportion of reported emissions verified (%) Select all that apply:',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q14_VALUE,
              showWhen: [
                'Third-party verification or assurance process in place'
              ],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q14_1_VALUE_SCOPE3
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q17_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q14_1_VALUE_SCOPE3,
            showWhen: [
              'Third-party verification or assurance process in place'
            ],
            relatedTableKey:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q14_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q17_1_VALUE,
                  fieldLabel: 'Scope 3 category',
                  options: SCOPE_3_CATEGORY_OPTIONS_2,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q17_2_VALUE,
                  fieldLabel: 'Verification or assurance cycle in place',
                  options: VERIFICATION_ASSURANCE_CYCLE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q17_3_VALUE,
                  fieldLabel: 'Status in the current reporting year',
                  options: STATUS_IN_CURRENT_REPORTING_YEAR_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q17_4_VALUE,
                  fieldLabel: 'Type of verification or assurance',
                  options: VERIFICATION_ASSURANCE_TYPE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.FILEUPLOAD,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q17_5_VALUE,
                  fieldLabel: 'Attach the statement',
                  colSpan: true,
                  fileUploadAction:
                    API_ENDPOINT_JSON.ESG.CDP_CORPORATE.documentUpload
                      .climateChange,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q17_3_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Underway but not complete for current reporting year - first year it has taken place',
                      'Complete'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q17_3_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Underway but not complete for current reporting year - first year it has taken place',
                      'Complete'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q17_3_VALUE
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q17_6_VALUE,
                  fieldLabel: 'Page/section reference',
                  colSpan: true,
                  textLimit: 500
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q17_7_VALUE,
                  fieldLabel: 'Relevant standard',
                  options: RELEVANT_STANDARD_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q17_8_VALUE,
                  fieldLabel: 'Proportion of reported emissions verified (%)',
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.SELECT,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q18_VALUE,
            fieldLabel:
              '7.10 How do your gross global emissions (Scope 1 and 2 combined) for the reporting year compare to',
            tooltip:
              'Investors and data users are interested in understanding whether companies are successfully reducing their emissions year over year.',
            heading: inputType.HEADING,
            colSpan: true,
            options: GLOBAL_EMISSIONS_COMPARISON_OPTIONS
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.10.1 Identify the reasons for any change in your gross global emissions (Scope 1 and 2 combined), and for each of them specify how your emissions compare to the previous year.',
            tooltip:
              'When investigating how year-on-year gross global emissions (Scope 1 + 2 combined) have changed, CDP and its investors are interested in changes at a granular level; thus allowing CDP’s data users to gain an insight into factors than have contributed to these changes.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q18_VALUE,
              showWhen: ['Increased', 'Decreased', 'Remained the same overall'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q18_VALUE
            }
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q19_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q18_VALUE,
            showWhen: ['Increased', 'Decreased', 'Remained the same overall'],
            relatedTableKey:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q18_VALUE,

            scopeColumnTitle: 'Reason',
            fixedRows: [
              {
                id: 'reason1',
                label: 'Change in renewable energy consumption'
              },
              {
                id: 'reason2',
                label: 'Other emissions reduction activities'
              },
              {
                id: 'reason3',
                label: 'Divestment'
              },
              {
                id: 'reason4',
                label: 'Acquisitions'
              },
              {
                id: 'reason5',
                label: 'Mergers'
              },
              {
                id: 'reason6',
                label: 'Change in output'
              },
              {
                id: 'reason7',
                label: 'Change in methodology'
              },
              {
                id: 'reason8',
                label: 'Change in boundary'
              },
              {
                id: 'reason9',
                label: 'Change in physical operating conditions'
              },
              {
                id: 'reason10',
                label: 'Unidentified'
              },
              {
                id: 'reason11',
                label: 'Other'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q19_1_VALUE,
                  fieldLabel: 'Change in emissions (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q19_2_VALUE,
                  fieldLabel: 'Direction of change in emissions',
                  options: [
                    {value: 'Increased', label: 'Increased'},
                    {value: 'Decreased', label: 'Decreased'},
                    {value: 'No change', label: 'No change'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q19_3_VALUE,
                  fieldLabel: 'Emissions value (percentage)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q19_4_VALUE,
                  fieldLabel: 'Please explain calculation',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.SELECT,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q20_VALUE,
            fieldLabel:
              '7.10.2 Are your emissions performance calculations in 7.10 and 7.10.1 based on a location-based Scope 2 emissions figure or a market-based Scope 2 emissions figure?',
            tooltip:
              'This question provides more transparency on how your organization’s emissions performance figures are derived.',
            heading: inputType.HEADING,
            colSpan: true,
            options: SCOPE_2_EMISSIONS_COMPARISON_OPTIONS
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.SELECT,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q21_VALUE,
            fieldLabel:
              '7.11 How do your total Scope 3 emissions for the reporting year compare to those of the previous reporting year?',
            tooltip:
              'Indirect emissions in the value chain are key for this sector. Data users are therefore interested in understanding whether companies are successfully reducing their Scope 3 emissions year on year.',
            heading: inputType.HEADING,
            colSpan: true,
            options: SCOPE_3_EMISSIONS_COMPARISON_OPTIONS
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.11.1 For each Scope 3 category calculated in 7.8, specify how your emissions compare to the previous year and identify the reason for any change.',
            tooltip:
              'This question asks how emissions from specific Scope 3 categories have changed. This level of granularity allows data users to gain insight into the factors that have contributed to these changes.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q21_VALUE,
              showWhen: ['Increased', 'Decreased', 'Remained the same overall'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q21_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q22_VALUE,
            allowMultipleRows: false,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q21_VALUE,
            showWhen: ['Increased', 'Decreased', 'Remained the same overall'],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q22_1_VALUE,
                  fieldLabel: 'Scope 3 category',
                  options: SCOPE_3_CATEGORY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q22_2_VALUE,
                  fieldLabel: 'Direction of change',
                  options: DIRECTION_OF_CHANGE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q22_3_VALUE,
                  fieldLabel: 'Primary reason for change',
                  options: PRIMARY_REASON_FOR_CHANGE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q22_4_VALUE,
                  fieldLabel:
                    'Change in emissions in this category (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q22_5_VALUE,
                  fieldLabel: '% change in emissions in this category',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q22_6_VALUE,
                  fieldLabel: 'Please explain',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.RADIOGROUP,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q23_VALUE,
            fieldLabel:
              '7.12 Are carbon dioxide emissions from biogenic carbon relevant to your organization?',
            tooltip:
              'The GHG Protocol’s Corporate Accounting and Reporting Standard outlines that carbon dioxide emissions from biogenic carbon shall be reported separately from the Scopes. ',
            heading: inputType.HEADING,
            colSpan: true,
            options: ['Yes', 'No']
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.12.1 Provide the emissions from biogenic carbon relevant to your organization in metric tons CO2.',
            tooltip:
              'This question provides data users insight into the CO2 emissions from biogenic carbon. Reporting these emissions separately aligns with best practice environmental reporting and the GHG Protocol’s Corporate Accounting and Reporting Standard. ',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q23_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q23_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q24_VALUE,
            allowMultipleRows: false,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q23_VALUE,
            showWhen: ['Yes'],
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q24_1_VALUE,
                  fieldLabel:
                    'CO2 emissions from biogenic carbon (metric tons CO2)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q24_2_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.SELECT,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q25_VALUE,
            fieldLabel:
              '7.13 Is biogenic carbon pertaining to your direct operations relevant to your current CDP climate change disclosure?',
            tooltip:
              'According to the GHG Protocol Agricultural Guidance, except for land use change (LUC) that results in a reduction of carbon stock, all other CO2 fluxes to/from biologically based carbon pools that are owned or controlled by you should be reported separately from the Scopes in a special “Biogenic Carbon” category. Thus, this question gathers information on biogenic carbon that is not included in your Scope 1 and Scope 2 figures. This information provides context to data users on the extent of your biogenic carbon fluxes and on the neutrality of your CO2 emissions. Note that this question asks about any CO2 fluxes that have not resulted in a reduction of carbon stock, as well as any CO2 emissions from biofuel/biomass combustion in, but not limited to, machinery and vehicles (e.g. land/processing/manufacturing machinery, transportation vehicles).',
            heading: inputType.HEADING,
            colSpan: true,
            options: [
              {value: 'Yes', label: 'Yes'},
              {value: 'No', label: 'No'},
              {value: 'Dont know', label: 'Dont know'}
            ]
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.13.1 Account for biogenic carbon data pertaining to your direct operations and identify any exclusions.',
            tooltip: `This question gathers data on biogenic carbon that is not included in your Scope 1 and Scope 2 figures.
                        This information provides context to data users on the extent of your biogenic carbon fluxes and on the neutrality of your CO2 emissions. `,
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q25_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q25_VALUE
            }
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q26_VALUE,
            scopeColumnTitle: 'Type of change',
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q25_VALUE,
            showWhen: ['Yes'],
            relatedTableKey:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q25_VALUE,
            fixedRows: [
              {
                id: 'type1',
                label: 'CO2 emissions from land use management'
              },
              {
                id: 'type2',
                label: 'CO₂ removals from land use management  '
              },
              {
                id: 'type3',
                label: 'Sequestration during land use change  '
              },
              {
                id: 'type4',
                label:
                  'CO₂ emissions from biofuel combustion (land machinery)  '
              },
              {
                id: 'type5',
                label:
                  'CO₂ emissions from biofuel combustion (processing/manufacturing machinery)  '
              },
              {
                id: 'type6',
                label: 'CO₂ emissions from biofuel combustion (other)'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q26_1_VALUE,
                  fieldLabel: 'Emissions (metric tons CO2)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q26_2_VALUE,
                  fieldLabel: 'Methodology',
                  options: METHODOLOGY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q26_3_VALUE,
                  fieldLabel: 'Please explain',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.14 Do you calculate greenhouse gas emissions for each agricultural commodity reported as significant to',
            tooltip:
              'Agricultural commodities that are significant to your business in terms of revenue could be closely associated with large CO2 emissions and signal dependency on natural capital and its associated ecosystem services under threat by climate change.This question enables data users to gauge how prepared your organization is to respond to risks related to your reliance on agricultural commodities by assessing whether you collect and/or calculate greenhouse gas (GHG) emissions data on these commodities. This information also provides further context to data users about the magnitude of the climate-related risks associated with your business where these commodities are not produced/sourced sustainably or managed carefully.',
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_VALUE
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_VALUE,
            scopeColumnTitle: 'Agricultural commodities',
            fixedRows: [],
            formList: {
              formFields: [
                // {
                //   type: inputType.SELECT,
                //   fieldName:
                //     CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_1_VALUE,
                //   fieldLabel: 'Agricultural commodities',
                //   options: [
                //     {
                //       label: '1',
                //       options: [{value: 'Yes', label: 'Yes'}]
                //     },
                //     {
                //       label: '2',
                //       options: [{value: 'No', label: 'No'}]
                //     }
                //   ],
                //   colSpan: true
                // },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_2_VALUE,
                  fieldLabel: 'GHG emissions calculated for this commodity',
                  options: GHG_EMISSIONS_FOR_COMMODITY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_3_VALUE,
                  fieldLabel: 'Reporting emissions by',
                  options: [
                    {value: 'Total', label: 'Total'},
                    {value: 'Unit of production', label: 'Unit of production'}
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_2_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_2_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Yes'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_2_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_4_VALUE,
                  fieldLabel: 'Emissions (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 10,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_2_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_2_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Yes'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_2_VALUE
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_5_VALUE,
                  fieldLabel: 'Denominator: unit of production',
                  options: DENOMINATOR_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_3_VALUE,
                    condition: conditionType.NOT,
                    values: ['Unit of production']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_3_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Unit of production'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_3_VALUE
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_6_VALUE,
                  fieldLabel: 'Change from last reporting year',
                  options: CHANGE_FROM_LAST_REPORTING_YEAR_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_2_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_2_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Yes'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_2_VALUE
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_7_VALUE,
                  fieldLabel: 'Please explain',
                  colSpan: true,
                  textLimit: 2000,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_2_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_2_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Yes'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_2_VALUE
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_8_VALUE,
                  fieldLabel:
                    'Explain why you do not calculate GHG emissions for this commodity',
                  colSpan: true,
                  textLimit: 2000,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_2_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'No, but we intend to calculate this data within the next two years',
                      'No, and we do not intend to calculate this data within the next two years'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_2_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'No, but we intend to calculate this data within the next two years',
                      'No, and we do not intend to calculate this data within the next two years'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q27_2_VALUE
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.SELECT,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q28_VALUE,
            fieldLabel:
              '7.15 Does your organization break down its Scope 1 emissions by greenhouse gas type?',
            tooltip:
              'For many sectors and business activities, greenhouse gases other than carbon dioxide are significant and relevant. Since these gases are often only reported in CO2-equivalents (CO2e), their contribution to overall emissions is sometimes masked. CDP therefore requests companies to break down their gross Scope 1 emissions by GHG type.',
            heading: inputType.HEADING,
            colSpan: true,
            options: [
              {value: 'Yes', label: 'Yes'},
              {value: 'No', label: 'No'},
              {value: 'Dont know', label: 'Dont know'}
            ]
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.15.1 Break down your total gross global Scope 1 emissions by greenhouse gas type and provide the source of each used global warming potential (GWP).',
            tooltip:
              'For many sectors and business activities, greenhouse gases other than carbon dioxide are significant and relevant. Since these gases are often only reported in CO2-equivalents (CO2e), their contribution to overall emissions is sometimes masked. CDP therefore requests companies to break down their gross Scope 1 emissions by GHG type.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q28_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q28_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q29_VALUE,
            allowMultipleRows: false,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q28_VALUE,
            showWhen: ['Yes'],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q29_1_VALUE,
                  fieldLabel: 'Greenhouse gas',
                  options: GREENHOUSE_GAS_TYPE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q29_2_VALUE,
                  fieldLabel: 'Scope 1 emissions (metric tons of CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q29_3_VALUE,
                  fieldLabel: 'GWP Reference',
                  options: GWP_REFERENCE_OPTIONS,
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.15.2 Break down your total gross global Scope 1 emissions from coal mining activities in the reporting year by greenhouse gas type.',
            tooltip:
              'Coal sector organizations face significant exposure to transitions around global GHG emissions either directly through the companies’ own energy use for production or indirectly through combustion of fossil fuels. Organizations with coal mining activities are therefore requested to provide gross emissions for their emission sources by greenhouse gas type so that users of the information can account for the GHG emissions from the various emission sources including fugitive, combustion, and other emission sources.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q28_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q28_VALUE
            }
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q30_VALUE,
            scopeColumnTitle: 'Emissions sources',
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q28_VALUE,
            showWhen: ['Yes'],
            relatedTableKey:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q28_VALUE,
            fixedRows: [
              {
                id: 'source1',
                label: 'Fugitives (Underground coal mining)'
              },
              {
                id: 'source2',
                label: 'Fugitives (Surface coal mining)'
              },
              {
                id: 'source3',
                label: 'Fugitives (Post-mining and abandoned coal mines)'
              },
              {
                id: 'source4',
                label: 'Flaring'
              },
              {
                id: 'source5',
                label: 'Utilized methane'
              },
              {
                id: 'source6',
                label:
                  'Combustion (Underground coal mining, excluding flaring and utilization)'
              },
              {
                id: 'source7',
                label:
                  'Combustion (Surface coal mining, excluding flaring and utilization)'
              },
              {
                id: 'source8',
                label: 'Combustion (Electricity generation)'
              },
              {
                id: 'source9',
                label: 'Combustion (Other)'
              },
              {
                id: 'source10',
                label: 'Emissions not elsewhere classified'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q30_1_VALUE,
                  fieldLabel: 'Gross Scope 1 CO2 emissions (metric tons CO2)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q30_2_VALUE,
                  fieldLabel:
                    'Gross Scope 1 methane emissions (metric tons CH4)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q30_3_VALUE,
                  fieldLabel:
                    'Total gross Scope 1 GHG emissions (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q30_4_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.15.3 Break down your total gross global Scope 1 emissions from electric utilities value chain activities by greenhouse type.',
            tooltip:
              'Electric utilities face significant exposure from the transition to a zero-carbon economy through their global greenhouse gas emissions, either directly through electric utility companies’ own energy use for production, or indirectly through combustion of fossil fuels. Electricity production is responsible for approximately 25% of the world’s GHG production. Electric utilities are therefore requested to provide gross emissions for their emission sources by greenhouse gas from sources including fugitive, combustion and other emission sources.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q28_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q28_VALUE
            }
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q31_VALUE,
            scopeColumnTitle: 'Emissions sources',
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q28_VALUE,
            showWhen: ['Yes'],
            relatedTableKey:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q28_VALUE,
            fixedRows: [
              {
                id: 'source1',
                label: 'Fugitives'
              },
              {
                id: 'source2',
                label: 'Combustion (Electric utilities)'
              },
              {
                id: 'source3',
                label: 'Combustion (Gas utilities)'
              },
              {
                id: 'source4',
                label: 'Combustion (Other)'
              },
              {
                id: 'source5',
                label: 'Emissions not elsewhere classified'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q31_1_VALUE,
                  fieldLabel: 'Gross Scope 1 CO2 emissions (metric tons CO2)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q31_2_VALUE,
                  fieldLabel:
                    'Gross Scope 1 methane emissions (metric tons CH4)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q31_3_VALUE,
                  fieldLabel: 'Gross Scope 1 SF6 emissions (metric tons SF6)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q31_4_VALUE,
                  fieldLabel:
                    'Total gross Scope 1 emissions (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q31_5_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.15.4 Break down your total gross global Scope 1 emissions from oil and gas value chain production greenhouse gas type ',
            tooltip:
              'Reporting gross global Scope 1 emissions by emission category allows for a more in-depth understanding of business risks, such as exposure to future regulation. The emissions categories are broken down to provide data users with a relevant and complete understanding of your organization’s oil and gas production activities and how these contribute to your emissions profile.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q28_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q28_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q32_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q28_VALUE,
            showWhen: ['Yes'],
            formList: {
              formFields: [
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q32_1_VALUE,
                  fieldLabel: 'Emissions category',
                  options: EMISSIONS_CATEGORY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q32_2_VALUE,
                  fieldLabel: 'Value chain',
                  options: VALUE_CHAIN_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q32_3_VALUE,
                  fieldLabel: 'Product',
                  options: PRODUCT_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q32_4_VALUE,
                  fieldLabel: 'Gross Scope 1 CO2 emissions (metric tons CO2)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q32_5_VALUE,
                  fieldLabel:
                    'Gross Scope 1 methane emissions (metric tons CH4)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q32_6_VALUE,
                  fieldLabel:
                    'Total gross Scope 1 emissions (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q32_7_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.16 Break down your total gross global Scope 1 and 2 emissions by country/area.',
            tooltip:
              'By breaking down emissions to country/area level, information and data can be made available to help guide the development of emissions-related legislation.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q33_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q33_1_VALUE,
                  fieldLabel: 'Country/area',
                  options: [
                    {
                      label: '1',
                      options: [{value: 'India', label: 'India'}]
                    },
                    {
                      label: '2',
                      options: [{value: 'USA', label: 'USA'}]
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q33_2_VALUE,
                  fieldLabel: 'Scope 1 emissions (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q33_3_VALUE,
                  fieldLabel: 'Scope 2, location-based (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q33_4_VALUE,
                  fieldLabel: 'Scope 2, market-based (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.SELECT,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q34_VALUE,
            fieldLabel:
              '7.17 Indicate which gross global Scope 1 emissions breakdowns you are able to provide.',
            tooltip:
              'By requesting companies to break down emissions by business division, facility, and activity, CDP grants data users and investors transparency into the sources of a companys Scope 1emissions.',
            heading: inputType.HEADING,
            colSpan: true,
            options: SCOPE_EMISSIONS_BREAKDOWN_OPTIONS
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.17.1 Break down your total gross global Scope 1 emissions by business division.',
            tooltip:
              'This question can give an indication of the relative GHG performance of your company’s divisions. When reported over time, your company and CDP’s data users will be able to review improvements or declines in division performance.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q34_VALUE,
              showWhen: ['By business division'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q34_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q35_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q34_VALUE,
            showWhen: ['By business division'],
            formList: {
              formFields: [
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q35_1_VALUE,
                  fieldLabel: 'Business division',
                  colSpan: true,
                  textLimit: 500
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q35_2_VALUE,
                  fieldLabel: 'Scope 1 emissions (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.17.2 Break down your total gross global Scope 1 emissions by business facility.',
            tooltip:
              'Providing facility-level emission figures may give data users insight into your organization’s current/potential exposure to regulation in this area. Reporting at this level can provide a useful indicator for making comparisons between facilities.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q34_VALUE,
              showWhen: ['By facility'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q34_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q36_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q34_VALUE,
            showWhen: ['By facility'],
            formList: {
              formFields: [
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q36_1_VALUE,
                  fieldLabel: 'Facility',
                  colSpan: true,
                  textLimit: 500
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q36_2_VALUE,
                  fieldLabel: 'Scope 1 emissions (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q36_3_VALUE,
                  fieldLabel: 'Latitude',
                  colSpan: true,
                  roundTo: 6
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q36_4_VALUE,
                  fieldLabel: 'Longitude',
                  colSpan: true,
                  roundTo: 6
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.17.3 Break down your total gross global Scope 1 emissions by business activity.',
            tooltip:
              'Reporting emissions by activity allows a more in-depth understanding of business risks related to future regulation and climate-related issues, and allows organizations to identify potential opportunities to reduce emissions associated with operational activities.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q34_VALUE,
              showWhen: ['By activity'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q34_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q37_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q34_VALUE,
            showWhen: ['By activity'],
            formList: {
              formFields: [
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q37_1_VALUE,
                  fieldLabel: 'Activity',
                  colSpan: true,
                  textLimit: 500
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q37_2_VALUE,
                  fieldLabel: 'Scope 1 emissions (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.SELECT,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q38_VALUE,
            fieldLabel:
              '7.18 Do you include emissions pertaining to your business activity(ies) in your direct operations as part of',
            tooltip:
              'This question gathers data on whether an emissions figure has been calculated for activities pertaining this sector, taking place within your organizational boundary, and is being reported as part of your gross Scope 1. This informs data users on whether your Scope 1 figure is representative of your business’ activities and their associated climate-related impacts',
            heading: inputType.HEADING,
            colSpan: true,
            options: [
              {value: 'Yes', label: 'Yes'},
              {value: 'partially', label: 'partially'},
              {value: 'No', label: 'No'}
            ]
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.SELECT,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q39_VALUE,
            fieldLabel:
              '7.18.1 Select the form(s) in which you are reporting your agricultural/forestry emissions.',
            tooltip:
              'This question provides you the option to breakdown CO2e emissions associated with agricultural/forestry activities in your land in further categories, as advised by the GHG Protocol.',
            heading: inputType.HEADING,
            colSpan: true,
            options: [
              {value: 'Total emissions', label: 'Total emissions'},
              {
                value:
                  'Emissions disaggregated by category (advised by the GHG Protocol)',
                label:
                  'Emissions disaggregated by category (advised by the GHG Protocol)'
              }
            ]
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.18.2  Report the Scope 1 emissions pertaining to your business activity(ies) and explain any exclusions. If applicable, disaggregate your agricultural/forestry by GHG emissions category',
            tooltip:
              'This question gathers information on Scope 1 data pertaining your relevant business activities and gives organizations an opportunity to provide further emissions breakdowns, as advised by the GHG Protocol.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q38_VALUE,
              showWhen: ['Yes', 'partially'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q38_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q40_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q38_VALUE,
            showWhen: ['Yes', 'partially'],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q40_1_VALUE,
                  fieldLabel: 'Activity',
                  options: ACTIVITY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q40_2_VALUE,
                  fieldLabel: 'Emissions Category',
                  options: EMISSIONS_CATEGORY_MECHANICAL_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q39_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Emissions disaggregated by category (advised by the GHG Protocol)'
                    ]
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q40_3_VALUE,
                  fieldLabel: 'Emissions (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q40_4_VALUE,
                  fieldLabel: 'Methodology',
                  options: METHODOLOGY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q40_5_VALUE,
                  fieldLabel: 'Please explain',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.18.3 Why do you not include greenhouse gas emissions pertaining your business activity(ies) in your direct operations as part of your global gross Scope 1 figure? Describe any plans to do so in the future.',
            tooltip:
              'This question aims to identify the main reason for why you have not included emissions pertaining to relevant business activities taking place within your organizational boundary, as part of your gross Scope 1 figure. This informs data users on whether your Scope 1 figure is representative of your business’ activities and their associated climate-related impacts and indicates if have any plans to do so in the next two years.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q38_VALUE,
              showWhen: ['No'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q38_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q41_VALUE,
            allowMultipleRows: false,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q38_VALUE,
            showWhen: ['No'],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q41_1_VALUE,
                  fieldLabel: 'Primary reason',
                  options: METHODOLOGY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q41_2_VALUE,
                  fieldLabel: 'Please explain',
                  colSpan: true,
                  textLimit: 4000
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.19 Break down your organization’s total gross global Scope 1 emissions by sector production activity in metric tons CO2e.',
            tooltip:
              'Reporting emissions by activity allows a more in-depth understanding of business risks related to future regulation and climate-related issues, and allows organizations to identify potential opportunities to reduce emissions associated with operational activities.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q42_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q42_1_VALUE,
                  fieldLabel: 'Sector production activity',
                  options: SECTOR_PRODUCTION_ACTIVITY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q42_2_VALUE,
                  fieldLabel: 'Gross Scope 1 emissions (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q42_3_VALUE,
                  fieldLabel: 'Net Scope 1 emissions (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q42_1_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Cement production activities']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q42_1_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Cement production activities'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q42_1_VALUE
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q42_4_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.SELECT,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q43_VALUE,
            fieldLabel:
              '7.20 Indicate which gross global Scope 2 emissions breakdowns you are able to provide.',
            tooltip:
              'By requesting companies to break down emissions by business division, facility, and activity, CDP grants data users and investors transparency into the sources of a companys Scope 2 emissions.',
            heading: inputType.HEADING,
            colSpan: true,
            options: SCOPE_EMISSIONS_BREAKDOWN_OPTIONS
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.20.1 Break down your total gross global Scope 2 emissions by business division.',
            tooltip:
              'This question can give an indication of the relative GHG performance of your company’s divisions. When reported over time, your company and CDP’s data users will be able to review improvements or declines in division performance.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q43_VALUE,
              showWhen: ['By business division'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q43_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q44_VALUE,
            allowMultipleRows: false,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q43_VALUE,
            showWhen: ['By business division'],
            formList: {
              formFields: [
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q44_1_VALUE,
                  fieldLabel: 'Business division',
                  colSpan: true,
                  textLimit: 500
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q44_2_VALUE,
                  fieldLabel: 'Scope 2, location-based (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q44_3_VALUE,
                  fieldLabel: 'Scope 2, market-based (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  conditions: {
                    dependsOn: [
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_VALUE
                    ],
                    shouldDisable: {
                      formDataDependOn: 'PARENT_FORM',
                      expression: {
                        and: [
                          {
                            parentField:
                              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_VALUE,
                            field:
                              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_2_VALUE,
                            operator: 'notEquals',
                            value:
                              'We are reporting a Scope 2, market-based figure'
                          }
                        ]
                      }
                    }
                  } satisfies FieldConditions
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.20.2 Break down your total gross global Scope 2 emissions by business facility..',
            tooltip:
              'Providing facility-level emission figures may give data users insight into your organization’s current/potential exposure to regulation in this area. Reporting at this level can provide a useful indicator for making comparisons between facilities.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q43_VALUE,
              showWhen: ['By facility'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q43_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q45_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q43_VALUE,
            showWhen: ['By facility'],
            formList: {
              formFields: [
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q45_1_VALUE,
                  fieldLabel: 'Facility',
                  colSpan: true,
                  textLimit: 500
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q45_2_VALUE,
                  fieldLabel: 'Scope 2, location-based (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q45_3_VALUE,
                  fieldLabel: 'Scope 2, market-based (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  conditions: {
                    dependsOn: [
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_VALUE
                    ],
                    shouldDisable: {
                      formDataDependOn: 'PARENT_FORM',
                      expression: {
                        and: [
                          {
                            parentField:
                              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_VALUE,
                            field:
                              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_2_VALUE,
                            operator: 'notEquals',
                            value:
                              'We are reporting a Scope 2, market-based figure'
                          }
                        ]
                      }
                    }
                  } satisfies FieldConditions
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.20.3 Break down your total gross global Scope 2 emissions by business activity.',
            tooltip:
              'Reporting emissions by activity allows a more in-depth understanding of business risks related to future regulation and climate-related issues, and allows organizations to identify potential opportunities to reduce emissions associated with operational activities.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q43_VALUE,
              showWhen: ['By activity'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q43_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q46_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q43_VALUE,
            showWhen: ['By activity'],
            formList: {
              formFields: [
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q46_1_VALUE,
                  fieldLabel: 'Activity',
                  colSpan: true,
                  textLimit: 500
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q46_2_VALUE,
                  fieldLabel: 'Scope 2, location-based (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q46_3_VALUE,
                  fieldLabel: 'Scope 2, market-based (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  conditions: {
                    dependsOn: [
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_VALUE
                    ],
                    shouldDisable: {
                      formDataDependOn: 'PARENT_FORM',
                      expression: {
                        and: [
                          {
                            parentField:
                              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_VALUE,
                            field:
                              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_2_VALUE,
                            operator: 'notEquals',
                            value:
                              'We are reporting a Scope 2, market-based figure'
                          }
                        ]
                      }
                    }
                  } satisfies FieldConditions
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.21 Break down your organization’s total gross global Scope 2 emissions by sector production activity in metric tons CO2e.',
            tooltip:
              ' Reporting emissions by activity allows a more in-depth understanding of business risks related to future regulation and climate-related issues, and allows organizations to identify potential opportunities to reduce emissions associated with operational activities.'
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q47_VALUE,
            scopeColumnTitle: 'Sector production activity',
            customFixedRowsBasedOnDependency: {
              dependentFieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q42_VALUE,
              checkDependency: fixRowDependency.Q7_21_FixRow
            },
            fixedRows: [
              {
                id: 'sector1',
                label: 'Cement production activities'
              },
              {
                id: 'sector2',
                label: 'Chemicals production activities'
              },
              {
                id: 'sector3',
                label: 'Coal production activities'
              },
              {
                id: 'sector4',
                label: 'Metals and mining production activities'
              },
              {
                id: 'sector5',
                label: 'Oil and gas production activities (upstream)'
              },
              {
                id: 'sector6',
                label: 'Oil and gas production activities (midstream)'
              },
              {
                id: 'sector7',
                label: 'Oil and gas production activities (downstream)'
              },
              {
                id: 'sector8',
                label: 'Steel production activities'
              },
              {
                id: 'sector9',
                label: 'Transport OEM activities'
              },
              {
                id: 'sector10',
                label: 'Transport Services activities'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q47_1_VALUE,
                  fieldLabel: 'Scope 2, location-based (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q47_2_VALUE,
                  fieldLabel:
                    'Scope 2, market-based (if applicable) (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q47_3_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.22 Break down your gross Scope 1 and Scope 2 emissions between your consolidated accounting group and other entities included in your response.',
            tooltip:
              'Awareness of emissions associated with the consolidated accounting group enables the organization to target actions to reduce emissions. The breakdown also provides data  users with the opportunity to better understand the emissions sources and therefore risks and opportunities throughout the business.'
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q48_VALUE,
            scopeColumnTitle: 'Group of entities',
            fixedRows: [
              {
                id: 'group1',
                label: 'Consolidated accounting group'
              },
              {
                id: 'group2',
                label: 'All other entities'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q48_1_VALUE,
                  fieldLabel: 'Scope 1 emissions (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q48_2_VALUE,
                  fieldLabel:
                    'Scope 2, location-based emissions (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q48_3_VALUE,
                  fieldLabel:
                    'Scope 2, market-based emissions (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  conditions: {
                    dependsOn: [
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_VALUE
                    ],
                    shouldDisable: {
                      formDataDependOn: 'PARENT_FORM',
                      expression: {
                        and: [
                          {
                            parentField:
                              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_VALUE,
                            field:
                              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_2_VALUE,
                            operator: 'notEquals',
                            value:
                              'We are reporting a Scope 2, market-based figure'
                          }
                        ]
                      }
                    }
                  } satisfies FieldConditions
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q48_4_VALUE,
                  fieldLabel: 'Please explain',
                  colSpan: true,
                  textLimit: 2500
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.SELECT,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q49_VALUE,
            fieldLabel:
              '7.23 Is your organization able to break down your emissions data for any of the subsidiaries included in your CDP response?',
            tooltip:
              'Awareness of subsidiary-level emission figures enables a parent company to better target action to reduce emissions. The breakdown also provides investors and other data users with the opportunity of better understanding the emissions sources and therefore the risks and opportunities throughout the business.',
            heading: inputType.HEADING,
            colSpan: true,
            options: [
              {value: 'Yes', label: 'Yes'},
              {value: 'No', label: 'No'},
              {
                value: 'Not relevant as we do not have any subsidiaries',
                label: 'Not relevant as we do not have any subsidiaries'
              }
            ]
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.23.1 Break down your gross Scope 1 and Scope 2 emissions by subsidiary.',
            tooltip: `Awareness of subsidiary-level emissions enables a
                          parent organization to target actions to reduce
                          emissions. The breakdown also provides data users with
                          the opportunity to better understand the emissions
                          sources and therefore risks and opportunities throughout
                          the business.`,
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q49_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q49_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q49_VALUE,
            showWhen: ['Yes'],
            formList: {
              formFields: [
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_1_VALUE,
                  fieldLabel: 'Subsidiary name',
                  colSpan: true,
                  textLimit: 200
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_2_VALUE,
                  fieldLabel: 'Primary activity',
                  colSpan: true,
                  textLimit: 200
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_3_VALUE,
                  fieldLabel:
                    'Select the unique identifiers you are able to provide for this subsidiary',
                  options: [
                    {value: 'ISIN code – bond', label: 'ISIN code – bond'},
                    {value: 'ISIN code – equity', label: 'ISIN code – equity'},
                    {value: 'CUSIP number', label: 'CUSIP number'},
                    {value: 'Ticker symbol', label: 'Ticker symbol'},
                    {value: 'SEDOL code', label: 'SEDOL code'},
                    {value: 'LEI number', label: 'LEI number'},
                    {value: 'D-U-N-S number', label: 'D-U-N-S number'},
                    {
                      value: 'Other unique identifier please specify',
                      label: 'Other unique identifier please specify'
                    },
                    {
                      value: 'No unique identifier',
                      label: 'No unique identifier'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_4_VALUE,
                  fieldLabel: 'ISIN code – bond',
                  colSpan: true,
                  textLimit: 12
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_5_VALUE,
                  fieldLabel: 'ISIN code – equity',
                  colSpan: true,
                  textLimit: 12
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_6_VALUE,
                  fieldLabel: 'CUSIP number',
                  colSpan: true,
                  textLimit: 9
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_7_VALUE,
                  fieldLabel: 'Ticker symbol',
                  colSpan: true,
                  textLimit: 5
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_8_VALUE,
                  fieldLabel: 'SEDOL code',
                  colSpan: true,
                  textLimit: 7
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_9_VALUE,
                  fieldLabel: 'LEI number',
                  colSpan: true,
                  textLimit: 20
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_10_VALUE,
                  fieldLabel: 'D-U-N-S number',
                  colSpan: true,
                  textLimit: 9
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_11_VALUE,
                  fieldLabel: 'Other unique identifier',
                  colSpan: true,
                  textLimit: 50
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_12_VALUE,
                  fieldLabel: 'Scope 1 emissions (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_13_VALUE,
                  fieldLabel:
                    'Scope 2, location-based emissions (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_14_VALUE,
                  fieldLabel:
                    'Scope 2, market-based emissions (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  conditions: {
                    dependsOn: [
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_VALUE
                    ],
                    shouldDisable: {
                      formDataDependOn: 'PARENT_FORM',
                      expression: {
                        and: [
                          {
                            parentField:
                              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_VALUE,
                            field:
                              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_2_VALUE,
                            operator: 'notEquals',
                            value:
                              'We are reporting a Scope 2, market-based figure'
                          }
                        ]
                      }
                    }
                  } satisfies FieldConditions
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q50_15_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2500
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.24 Report your methane emissions as percentages of natural gas and hydrocarbon production or throughput.',
            tooltip: `Emissions of methane, the main component of natural
                        gas, represent a loss of resources that directly impact
                        topline revenue for oil and gas organizations. Data users
                        need rigorous, accurate, and comparable information to
                        assess organizations’ emissions of methane. By
                        reporting emissions as a percentage of production or throughput, the resulting data becomes comparable
                        between companies, regardless of size, and over time, as
                        a given company’s operations evolve.`
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q51_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.MULTISELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q51_1_VALUE,
                  fieldLabel: 'Oil and gas business division',
                  options: OIL_AND_GAS_BUSINESS_DIVISION_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q51_2_VALUE,
                  fieldLabel:
                    'Estimated total methane emitted expressed as % of natural gas production or throughput at given division',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q51_3_VALUE,
                  fieldLabel:
                    'Estimated total methane emitted expressed as % of total hydrocarbon production or throughput at given division',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q51_4_VALUE,
                  fieldLabel:
                    'Indicate whether your methane emissions figure is based on observational data',
                  options: OBSERVATIONAL_DATA_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q51_5_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.25 Disclose the percentage of your organization’s Scope 3, Category 1 emissions by purchased chemical feedstock.',
            tooltip:
              'Accounting for Scope 3, Category 1 emissions from purchased feedstock can help to identify the value chain components with greatest emission reduction potential, improve GHG performance of suppliers, and inform the development of sector-specific guidance for the chemical industry.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q52_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q52_1_VALUE,
                  fieldLabel: 'Purchased feedstock',
                  options: PURCHASED_FEEDSTOCK_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q52_2_VALUE,
                  fieldLabel:
                    'Percentage of Scope 3, Category 1 tCO2e from purchased feedstock',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q52_3_VALUE,
                  fieldLabel: 'Explain calculation methodology',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.25.1 Disclose sales of products that are greenhouse gases.',
            tooltip:
              'Reporting sales of products that are greenhouse gases allows a more in-depth understanding of your Scope 3 emissions and business risks associated with potential future climate-related regulation.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q53_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q53_1_VALUE,
                  fieldLabel: 'Output product',
                  options: OUTPUT_PRODUCT_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q53_2_VALUE,
                  fieldLabel: 'Sales, metric tons',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q53_3_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.26 Allocate your emissions to your customers listed below according to the goods or services you have sold them in this reporting period.',
            tooltip: `This information provides clarity to requesting Supply Chain members on the emissions associated with goods and products sold to them over the reporting year. This supports transparency in emissions allocations, verification of these
emissions allocations and methodologies used. This question also provides transparency regarding how data was acquired and used to derive emissions values allocated to requesting Supply Chain members.`
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_1_VALUE,
                  fieldLabel: 'Requesting member',
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_2_VALUE,
                  fieldLabel: 'Scope of emissions',
                  options: SCOPE_OF_EMISSIONS_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_3_VALUE,
                  fieldLabel: 'Scope 3 category(ies)',
                  options: SCOPE_3_CATEGORIES_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_2_VALUE,
                    condition: conditionType.NOT,
                    values: ['Scope 3']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_4_VALUE,
                  fieldLabel: 'Allocation level',
                  options: ALLOCATION_LEVEL_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_5_VALUE,
                  fieldLabel: 'Allocation level detail',
                  colSpan: true,
                  textLimit: 500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_4_VALUE,
                    condition: conditionType.NOT,
                    values: ['Business unit (subsidiary company)', 'Facility']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_6_VALUE,
                  fieldLabel: 'Allocation method',
                  options: ALLOCATION_METHOD_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_7_VALUE,
                  fieldLabel:
                    'Unit for market value or quantity of goods/services supplied',
                  options:
                    UNIT_FOR_MARKET_VALUE_OR_QUANTITY_OF_GOODS_SERVICES_SUPPLIED_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_6_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Allocation not necessary due to type of primary data available',
                      'Allocation not necessary as secondary data used'
                    ]
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_8_VALUE,
                  fieldLabel:
                    'Market value or quantity of goods/services supplied to the requesting member',
                  colSpan: true,
                  roundTo: 4,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_6_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Allocation not necessary due to type of primary data available',
                      'Allocation not necessary as secondary data used'
                    ]
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_9_VALUE,
                  fieldLabel: 'Emissions in metric tons of CO2e',
                  colSpan: true,
                  roundTo: 4,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_6_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Allocation not necessary due to type of primary data available',
                      'Allocation not necessary as secondary data used'
                    ]
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_10_VALUE,
                  fieldLabel: 'Uncertainty (± %)',
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_11_VALUE,
                  fieldLabel: 'Major sources of emissions',
                  colSpan: true,
                  textLimit: 2500
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_12_VALUE,
                  fieldLabel: 'Allocation verified by a third party?',
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_13_VALUE,
                  fieldLabel:
                    'Please explain how you have identified the GHG source, including major limitations to this process and assumptions made',
                  colSpan: true,
                  textLimit: 5000
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q54_14_VALUE,
                  fieldLabel:
                    'Where published information has been used, please provide a reference',
                  colSpan: true,
                  textLimit: 5000
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.27 What are the challenges in allocating emissions to different customers, and what would help you to overcome these challenges?',
            tooltip: `The purpose of this question is to provide your customers with insights about the challenges in assigning specific emissions to them from your products or services. In certain cases, it might
be that specific solutions can be found between you and your customer to overcome those challenges.`
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q55_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q55_1_VALUE,
                  fieldLabel: 'Allocation challenges',
                  options: ALLOCATION_CHALLENGES_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q55_2_VALUE,
                  fieldLabel:
                    'Please explain what would help you overcome these challenges',
                  colSpan: true,
                  textLimit: 2500
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.28 Do you plan to develop your capabilities to allocate emissions to your customers in the future?',
            tooltip:
              'This question aims to provide your customers with insights and transparency into how you aim to develop your capabilities to allocate emissions to them, and thus allow them to gain a greater understanding of the emissions and/or energy intensity of the goods/services that you provide to them'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q56_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q56_1_VALUE,
                  fieldLabel:
                    'Do you plan to develop your capabilities to allocate emissions to your customers in the future?',
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q56_2_VALUE,
                  fieldLabel:
                    'Describe how you plan to develop your capabilities',
                  colSpan: true,
                  textLimit: 5000
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q56_3_VALUE,
                  fieldLabel:
                    'Primary reason for no plans to develop your capabilities to allocate emissions to your customers',
                  options:
                    PRIMARY_REASON_FOR_NO_PLANS_TO_DEVELOP_CAPABILITIES_TO_ALLOCATE_EMISSIONS_TO_CUSTOMERS_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q56_4_VALUE,
                  fieldLabel:
                    'Describe how you plan to develop your capabilities',
                  colSpan: true,
                  textLimit: 5000
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.SELECT,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q57_VALUE,
            fieldLabel:
              '7.29 What percentage of your total operational spend in the reporting year was on energy?',
            tooltip:
              'The aim of this question is to identify the degree to which your organization’s activities are sensitive to energy costs and energy supply.',
            heading: inputType.HEADING,
            colSpan: true,
            options: PERCENTAGE_OF_TOTAL_OPERATIONAL_SPEND_ON_ENERGY_OPTIONS
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.30 Select which energy-related activities your organization has undertaken.',
            tooltip:
              'This question provides data users with information on the organization’s consumption of energy forms relating to Scope 1 and Scope 2 emissions, and transparency on the generation of energy.'
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE,
            scopeColumnTitle: 'Activity',
            fixedRows: [
              {
                id: 'activity1',
                label: 'Consumption of fuel (excluding feedstocks)'
              },
              {
                id: 'activity2',
                label: 'Consumption of purchased or acquired electricity'
              },
              {
                id: 'activity3',
                label: 'Consumption of purchased or acquired heat'
              },
              {
                id: 'activity4',
                label: 'Consumption of purchased or acquired steam'
              },
              {
                id: 'activity5',
                label: 'Consumption of purchased or acquired cooling'
              },
              {
                id: 'activity6',
                label: 'Generation of electricity, heat, steam, or cooling'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_1_VALUE,
                  fieldLabel:
                    'Indicate whether your organization undertook this energyrelated activity in the reporting year',
                  options: ['Yes', 'No'],
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.30.1 Report your organization’s energy consumption totals (excluding feedstocks) in MWh.',
            tooltip:
              'Given the importance of energy consumption in emissions accounting, this question attempts to provide transparency to data users on the consumption of energy by the organization. The question provides the opportunity for organizations to disclose their total energy consumption and distinguish renewable and non-renewable forms of energy.'
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q59_VALUE,
            scopeColumnTitle: 'Activity',
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE,
            customFixedRowsBasedOnDependency: {
              dependentFieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE,
              checkDependency: fixRowDependency.Q7_30_DependsOn58_FixRow
            },
            fixedRows: [
              {
                id: 'activity1',
                label: 'Consumption of fuel (excluding feedstocks)'
              },
              {
                id: 'activity2',
                label: 'Consumption of purchased or acquired electricity'
              },
              {
                id: 'activity3',
                label: 'Consumption of purchased or acquired heat'
              },
              {
                id: 'activity4',
                label: 'Consumption of purchased or acquired steam'
              },
              {
                id: 'activity5',
                label: 'Consumption of purchased or acquired cooling'
              },
              {
                id: 'activity6',
                label: 'Generation of electricity, heat, steam, or cooling'
              },
              {
                id: 'activity7',
                label: 'Total energy consumption'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q59_1_VALUE,
                  fieldLabel: 'Heating value',
                  options: HEATING_VALUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q59_2_VALUE,
                  fieldLabel: 'MWh from renewable sources',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q59_3_VALUE,
                  fieldLabel: 'MWh from non-renewable sources',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.DISPLAY_CALCULATION_IN_TABLE,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q59_4_VALUE,
                  fieldLabel: 'Total (renewable + non-renewable) MWh',
                  relatedKey: [
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q59_2_VALUE,
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q59_3_VALUE
                  ],
                  formula: calculateSum
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.30.2 Report your organization’s energy consumption totals (excluding feedstocks) for cement production activities in MWh.',
            tooltip: `Question 7.30 has been modified and represented here for the cement sector. This is to enable consistency of reporting across organizations with varying coverage over activities
that may be separate from the cement sector or independent of the production activities defining the cement sector. Cement is also one of the most energy intensive sectors of industry, so it is important to represent the sector separately from outside activities.`
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q60_VALUE,
            scopeColumnTitle: 'Activity',
            customFixedRowsBasedOnDependency: {
              dependentFieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE,
              checkDependency: fixRowDependency.Q7_30_DependsOn58_FixRow
            },
            fixedRows: [
              {
                id: 'activity1',
                label: 'Consumption of fuel (excluding feedstocks)'
              },
              {
                id: 'activity2',
                label: 'Consumption of purchased or acquired electricity'
              },
              {
                id: 'activity3',
                label:
                  'Consumption of other purchased or acquired energy (heat, steam and/or cooling)'
              },
              {
                id: 'activity4',
                label: 'Total energy consumption'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q60_1_VALUE,
                  fieldLabel: 'Heating value',
                  options: HEATING_VALUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q60_2_VALUE,
                  fieldLabel: 'Total MWh',
                  colSpan: true,
                  roundTo: 2
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.30.3  Report your organization’s energy consumption totals (excluding feedstocks) for chemical production activities in MWh.',
            tooltip:
              'Question 7.30.1 has been modified and represented here for the chemicals sector. This is to enable consistency of reporting across organizations with varying coverage over activities that may be separate from the chemicals sector or independent of the production activities defining the chemicals sector. Chemicals is also one of the largest energy users of industry, so it is important to represent the sector separately from outside activities.'
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q61_VALUE,
            scopeColumnTitle: 'Activity',
            customFixedRowsBasedOnDependency: {
              dependentFieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE,
              checkDependency: fixRowDependency.Q7_30_DependsOn58_FixRow
            },
            fixedRows: [
              {
                id: 'activity1',
                label: 'Consumption of fuel (excluding feedstocks)'
              },
              {
                id: 'activity2',
                label: 'Consumption of purchased or acquired electricity'
              },
              {
                id: 'activity3',
                label: 'Consumption of purchased or acquired heat'
              },
              {
                id: 'activity4',
                label: 'Consumption of purchased or acquired steam'
              },
              {
                id: 'activity5',
                label: 'Consumption of purchased or acquired cooling'
              },
              {
                id: 'activity6',
                label: 'Consumption of selfgenerated non-fuel renewable energy'
              },
              {
                id: 'activity7',
                label: 'Total energy consumption'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q61_1_VALUE,
                  fieldLabel: 'Heating value',
                  options: HEATING_VALUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q61_2_VALUE,
                  fieldLabel:
                    'MWh consumed from renewable sources inside chemical sector boundary',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q61_3_VALUE,
                  fieldLabel:
                    'MWh consumed from non-renewable sources inside chemical sector boundary (excluding recovered waste heat/gases)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q61_4_VALUE,
                  fieldLabel:
                    'MWh consumed from waste heat/gases recovered from processes using fuel feedstocks inside chemical sector boundary',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q61_5_VALUE,
                  fieldLabel:
                    'Total MWh (renewable + non-renewable + MWh from recovered waste heat/gases) consumed inside chemical sector boundary',
                  colSpan: true,
                  roundTo: 2
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.30.4 Report your organization’s energy consumption totals (excluding feedstocks) for metals and mining production activities in MWh.',
            tooltip: `Question 7.30.1 has been modified and represented here for the metals and mining sector. This is to enable consistency of reporting across organizations with varying coverage over
                        activities that may be separate from the metals and mining sector or independent of the production activities defining the metals and mining sector. Metals and mining activities can
                        also be particularly energy intensive, so it is important to represent the sector separately
                        from outside activities.`
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q62_VALUE,
            scopeColumnTitle: 'Activity',
            customFixedRowsBasedOnDependency: {
              dependentFieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE,
              checkDependency: fixRowDependency.Q7_30_DependsOn58_FixRow
            },
            fixedRows: [
              {
                id: 'activity1',
                label: 'Consumption of fuel (excluding feedstocks)'
              },
              {
                id: 'activity2',
                label: 'Consumption of purchased or acquired electricity'
              },
              {
                id: 'activity3',
                label: 'Consumption of purchased or acquired heat'
              },
              {
                id: 'activity4',
                label: 'Consumption of purchased or acquired steam'
              },
              {
                id: 'activity5',
                label: 'Consumption of purchased or acquired cooling'
              },
              {
                id: 'activity6',
                label: 'Consumption of selfgenerated non-fuel renewable energy'
              },
              {
                id: 'activity7',
                label: 'Total energy consumption'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q62_1_VALUE,
                  fieldLabel: 'Heating value',
                  options: HEATING_VALUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q62_2_VALUE,
                  fieldLabel: 'Total MWh',
                  colSpan: true,
                  roundTo: 2
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.30.5 Report your organization’s energy consumption totals (excluding feedstocks) for steel production activities in MWh.',
            tooltip:
              'This question only appears if you selected “Yes” to any of the activities listed in 7.30. A row will appear in this table for each energy-related activity selected in 7.30. The “Total energy consumption” row will always appear. Modified guidance Question 7.30.1 has been modified and represented here for the steel sector. This is to enable consistency of reporting across organizations with varying coverage over activities that may be separate from the steel sector or independent of the production activities defining the steel sector. Steel is also one of the most energy intensive sectors of industry, so it is important to represent the sector separately from outside activities. 150'
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q63_VALUE,
            scopeColumnTitle: 'Activity',
            customFixedRowsBasedOnDependency: {
              dependentFieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE,
              checkDependency: fixRowDependency.Q7_30_DependsOn58_FixRow
            },
            fixedRows: [
              {
                id: 'activity1',
                label: 'Consumption of fuel (excluding feedstocks)'
              },
              {
                id: 'activity2',
                label: 'Consumption of purchased or acquired electricity'
              },
              {
                id: 'activity3',
                label: 'Consumption of purchased or acquired heat'
              },
              {
                id: 'activity4',
                label: 'Consumption of purchased or acquired steam'
              },
              {
                id: 'activity5',
                label: 'Consumption of purchased or acquired cooling'
              },
              {
                id: 'activity6',
                label: 'Consumption of selfgenerated non-fuel renewable energy'
              },
              {
                id: 'activity7',
                label: 'Total energy consumption'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q63_1_VALUE,
                  fieldLabel: 'Heating value',
                  options: HEATING_VALUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q63_2_VALUE,
                  fieldLabel:
                    'MWh consumed from renewable sources inside steel sector boundary',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q63_3_VALUE,
                  fieldLabel:
                    'MWh consumed from non-renewable sources inside steel sector boundary (excluding recovered waste heat/gases)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q63_4_VALUE,
                  fieldLabel:
                    'MWh consumed from waste heat/gases recovered from processes using fuel feedstocks inside steel sector boundary',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.DISPLAY_CALCULATION_IN_TABLE,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q63_5_VALUE,
                  fieldLabel:
                    'Total MWh (renewable + non-renewable + MWh from recovered waste heat/gases) consumed inside steel sector boundary',
                  relatedKey: [
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q63_2_VALUE,
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q63_3_VALUE,
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q63_4_VALUE
                  ],
                  formula: calculateSum
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q64_VALUE,
            controlHeading: {
              fieldType: inputType.HEADING,
              heading:
                '7.30.6 Select the applications of your organization’s consumption of fuel.',
              tooltip:
                'Scope 1 greenhouse gas emissions are directly associated with the consumption of fuel. This question provides data users with more transparency regarding the application of an organization’s fuel consumption for the generation of secondary energy carriers.'
            },
            scopeColumnTitle: 'Fuel application',
            conditions: {
              dependsOn: [
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE
              ],
              shouldShow: {
                expression: {
                  and: [
                    {
                      parentField:
                        CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE,
                      field: 'scopeLabel',
                      operator: 'equals',
                      value: 'Consumption of fuel (excluding feedstocks)'
                    },
                    {
                      parentField:
                        CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE,
                      field:
                        'corporatePerformanceClimateChangeQ58_1_value_activity1',
                      operator: 'equals',
                      value: 'Yes'
                    }
                  ]
                }
              }
            } satisfies FieldConditions,
            fixedRows: [
              {
                id: 'fuel1',
                label: 'Consumption of fuel for the generation of electricity'
              },
              {
                id: 'fuel2',
                label: 'Consumption of fuel for the generation of heat'
              },
              {
                id: 'fuel3',
                label: 'Consumption of fuel for the generation of steam'
              },
              {
                id: 'fuel4',
                label: 'Consumption of fuel for the generation of cooling'
              },
              {
                id: 'fuel5',
                label: 'Consumption of fuel for co-generation or tri-generation'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q64_1_VALUE,
                  fieldLabel:
                    'Indicate whether your organization undertakes this fuel application',
                  options: ['Yes', 'No'],
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q65_VALUE,
            controlHeading: {
              fieldType: inputType.HEADING,
              heading:
                '7.30.7 State how much fuel in MWh your organization has consumed (excluding feedstocks) by fuel type.',
              tooltip: `Scope 1 greenhouse gas emissions are directly
                          associated with the consumption of fuel for energy
                          purposes. This question provides data users with more
                          transparency regarding the type of fuel an organization
                          has consumed. Total consumption of fuels and their
                          consumption for different energy applications also
                          provides insight on the way in which fuels are used by
                          the organization, which can allow for a fairer and more consistent understanding of corporate energy and
                          emissions from data users. `
            },
            scopeColumnTitle: 'Fuels (excluding feedstocks)',
            conditions: {
              dependsOn: [
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE
              ],
              shouldShow: {
                expression: {
                  and: [
                    {
                      parentField:
                        CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE,
                      field: 'scopeLabel',
                      operator: 'equals',
                      value: 'Consumption of fuel (excluding feedstocks)'
                    },
                    {
                      parentField:
                        CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE,
                      field:
                        'corporatePerformanceClimateChangeQ58_1_value_activity1',
                      operator: 'equals',
                      value: 'Yes'
                    }
                  ]
                }
              }
            } satisfies FieldConditions,
            fixedRows: [
              {
                id: 'fuel1',
                label: 'Sustainabl e biomass'
              },
              {
                id: 'fuel2',
                label: 'Other biomass'
              },
              {
                id: 'fuel3',
                label: 'Other renewable fuels (e.g. renewable hydrogen)'
              },
              {
                id: 'fuel4',
                label: 'Coal'
              },
              {
                id: 'fuel5',
                label: 'Oil'
              },
              {
                id: 'fuel6',
                label: 'Gas'
              },
              {
                id: 'fuel7',
                label: 'Other nonrenewable fuels (e.g. nonrenewable hydrogen)'
              },
              {
                id: 'fuel8',
                label: 'Total fuel'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q65_1_VALUE,
                  fieldLabel: 'Heating value',
                  options: HEATING_VALUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q65_2_VALUE,
                  fieldLabel: 'Total fuel MWh consumed by the organization',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q65_3_VALUE,
                  fieldLabel:
                    'MWh fuel consumed for self-generation of electricity',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q65_4_VALUE,
                  fieldLabel: 'MWh fuel consumed for self-generation of heat',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q65_5_VALUE,
                  fieldLabel: 'MWh fuel consumed for self-generation of steam',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q65_6_VALUE,
                  fieldLabel:
                    'MWh fuel consumed for self-generation of cooling',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q65_7_VALUE,
                  fieldLabel:
                    'MWh fuel consumed for self-cogeneration or self-trigeneration',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q65_8_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q66_VALUE,
            controlHeading: {
              fieldType: inputType.HEADING,
              heading:
                '7.30.8 State how much fuel in MWh your organization has consumed (excluding feedstocks) by fuel for cement production activities.',
              tooltip:
                'Question 7.30.7 has been modified and represented here for the cement sector. This is to enable consistency of reporting across organizations with varying coverage over activities that may be separate from the cement sector or independent of the production activities defining the cement sector. Cement is also a highly energy intensive sector of industry, so it is important to represent the sector separately from outside activities.'
            },
            scopeColumnTitle: 'Fuels (excluding feedstocks)',
            conditions: {
              dependsOn: [
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE
              ],
              shouldShow: {
                expression: {
                  and: [
                    {
                      parentField:
                        CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE,
                      field: 'scopeLabel',
                      operator: 'equals',
                      value: 'Consumption of fuel (excluding feedstocks)'
                    },
                    {
                      parentField:
                        CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE,
                      field:
                        'corporatePerformanceClimateChangeQ58_1_value_activity1',
                      operator: 'equals',
                      value: 'Yes'
                    }
                  ]
                }
              }
            } satisfies FieldConditions,
            fixedRows: [
              {
                id: 'fuel1',
                label: 'Sustainabl e biomass'
              },
              {
                id: 'fuel2',
                label: 'Other biomass'
              },
              {
                id: 'fuel3',
                label: 'Other renewable fuels (e.g. renewable hydrogen)'
              },
              {
                id: 'fuel4',
                label: 'Coal'
              },
              {
                id: 'fuel5',
                label: 'Oil'
              },
              {
                id: 'fuel6',
                label: 'Gas'
              },
              {
                id: 'fuel7',
                label: 'Other nonrenewable fuels (e.g. nonrenewable hydrogen)'
              },
              {
                id: 'fuel8',
                label: 'Total fuel'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q66_1_VALUE,
                  fieldLabel: 'Heating value',
                  options: HEATING_VALUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q66_2_VALUE,
                  fieldLabel:
                    'Total MWh fuel consumed for cement production activities',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q66_3_VALUE,
                  fieldLabel: 'MWh fuel consumed at the kiln',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q66_4_VALUE,
                  fieldLabel:
                    'MWh fuel consumed for the generation of heat that is not used in the kiln',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q66_5_VALUE,
                  fieldLabel:
                    'MWh fuel consumed for the self-generation of electricity',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q66_6_VALUE,
                  fieldLabel:
                    'MWh fuel consumed for self-cogeneration or self-trigeneration',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q66_7_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q67_VALUE,
            controlHeading: {
              fieldType: inputType.HEADING,
              heading:
                '7.30.9 Provide details on the electricity, heat, steam, and cooling your organization has generated and consumed in the reporting year',
              tooltip: `Many organizations generate their own electricity, steam, heat, and/or cooling. Bringing thegeneration of these secondary energy carriers inside the organizational boundary has the effect of reducing an organization’s Scope 2 emissions while increasing Scope 1 emissions. Because the scale of self-generation can be highly variable, this can create additional uncertainty for data users when comparing Scope 1 and 2 emissions across company samples or portfolios. CDP
aims to alleviate this distorting factor by bringing transparency on the extent of self-generation by organizations.`
            },
            scopeColumnTitle: 'Energy carrier',
            conditions: {
              dependsOn: [
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE
              ],
              shouldShow: {
                expression: {
                  and: [
                    {
                      parentField:
                        CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE,
                      field: 'scopeLabel',
                      operator: 'equals',
                      value:
                        'Generation of electricity, heat, steam, or cooling'
                    },
                    {
                      parentField:
                        CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE,
                      field:
                        'corporatePerformanceClimateChangeQ58_1_value_activity6',
                      operator: 'equals',
                      value: 'Yes'
                    }
                  ]
                }
              }
            } satisfies FieldConditions,
            fixedRows: [
              {
                id: 'energy1',
                label: 'Electricity'
              },
              {
                id: 'energy2',
                label: 'Heat'
              },
              {
                id: 'energy3',
                label: 'Steam'
              },
              {
                id: 'energy4',
                label: 'Cooling'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q67_1_VALUE,
                  fieldLabel: 'Total gross generation (MWh)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q67_2_VALUE,
                  fieldLabel:
                    'Generation that is consumed by the organization (MWh)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q67_3_VALUE,
                  fieldLabel: 'Gross generation from renewable sources (MWh)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q67_4_VALUE,
                  fieldLabel:
                    'Generation from renewable sources that is consumed by the organization (MWh)',
                  colSpan: true,
                  roundTo: 2
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q68_VALUE,
            controlHeading: {
              fieldType: inputType.HEADING,
              heading:
                '7.30.10 Provide details on the electricity and heat your organization has generated and consumed for cement production activities.',
              tooltip:
                'Question 7.30.9 has been modified and represented here for the cement sector. This enables consistency of reporting across organizations with varying coverage over activities that may be separate from the cement sector or independent of the production activities defining the cement sector.'
            },
            scopeColumnTitle: 'Energy carrier',
            conditions: {
              dependsOn: [
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE
              ],
              shouldShow: {
                expression: {
                  and: [
                    {
                      parentField:
                        CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE,
                      field: 'scopeLabel',
                      operator: 'equals',
                      value:
                        'Generation of electricity, heat, steam, or cooling'
                    },
                    {
                      parentField:
                        CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE,
                      field:
                        'corporatePerformanceClimateChangeQ58_1_value_activity6',
                      operator: 'equals',
                      value: 'Yes'
                    }
                  ]
                }
              }
            } satisfies FieldConditions,
            fixedRows: [
              {
                id: 'energy1',
                label: 'Electricity'
              },
              {
                id: 'energy2',
                label: 'Heat'
              },
              {
                id: 'energy3',
                label: 'Steam'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q68_1_VALUE,
                  fieldLabel:
                    'Total gross generation inside the cement sector boundary',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q68_2_VALUE,
                  fieldLabel:
                    'Generation that is consumed inside the cement sector boundary',
                  colSpan: true,
                  roundTo: 2
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q69_VALUE,
            controlHeading: {
              fieldType: inputType.HEADING,
              heading:
                '7.30.11 Provide details on electricity, heat, steam, and cooling your organization has generated and consumed for chemical production activities.',
              tooltip:
                'Question 7.30.9 has been modified and represented here for the chemicals sector. This enables consistency of reporting across organizations with varying coverage over activities that may be separate from the chemicals sector or independent of the production activities defining the chemicals sector.'
            },
            scopeColumnTitle: 'Energy carrier',
            conditions: {
              dependsOn: [
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE
              ],
              shouldShow: {
                expression: {
                  and: [
                    {
                      parentField:
                        CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE,
                      field: 'scopeLabel',
                      operator: 'equals',
                      value:
                        'Generation of electricity, heat, steam, or cooling'
                    },
                    {
                      parentField:
                        CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE,
                      field:
                        'corporatePerformanceClimateChangeQ58_1_value_activity6',
                      operator: 'equals',
                      value: 'Yes'
                    }
                  ]
                }
              }
            } satisfies FieldConditions,
            fixedRows: [
              {
                id: 'energy1',
                label: 'Electricity'
              },
              {
                id: 'energy2',
                label: 'Heat'
              },
              {
                id: 'energy3',
                label: 'Steam'
              },
              {
                id: 'energy4',
                label: 'Cooling'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q69_1_VALUE,
                  fieldLabel:
                    'Total gross generation inside chemicals sector boundary (MWh)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q69_2_VALUE,
                  fieldLabel:
                    'Generation that is consumed inside chemicals sector boundary (MWh)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q69_3_VALUE,
                  fieldLabel:
                    'Generation from renewable sources inside chemical sector boundary (MWh)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q69_4_VALUE,
                  fieldLabel:
                    'Generation from waste heat/gases recovered from processes using fuel feedstocks inside chemical sector boundary (MWh)',
                  colSpan: true,
                  roundTo: 2
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q70_VALUE,
            controlHeading: {
              fieldType: inputType.HEADING,
              heading:
                '7.30.12 Provide details on the electricity, heat, steam, and cooling your organization has generated and consumed for metals and mining production activities.',
              tooltip:
                'Question 7.30.9 has been modified and represented here for the metals and mining sector. This enables consistency of reporting across organizations with varying coverage over activities that may be separate from the metals and mining sector or independent of the production activities defining the metals and mining sector.'
            },
            scopeColumnTitle: 'Energy carrier',
            conditions: {
              dependsOn: [
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE
              ],
              shouldShow: {
                expression: {
                  and: [
                    {
                      parentField:
                        CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE,
                      field: 'scopeLabel',
                      operator: 'equals',
                      value:
                        'Generation of electricity, heat, steam, or cooling'
                    },
                    {
                      parentField:
                        CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE,
                      field:
                        'corporatePerformanceClimateChangeQ58_1_value_activity6',
                      operator: 'equals',
                      value: 'Yes'
                    }
                  ]
                }
              }
            } satisfies FieldConditions,
            fixedRows: [
              {
                id: 'energy1',
                label: 'Electricity'
              },
              {
                id: 'energy2',
                label: 'Heat'
              },
              {
                id: 'energy3',
                label: 'Steam'
              },
              {
                id: 'energy4',
                label: 'Cooling'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q70_1_VALUE,
                  fieldLabel:
                    'Total gross generation inside metals and mining sector boundary',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q70_2_VALUE,
                  fieldLabel:
                    'Generation that is consumed inside metals and mining sector boundary',
                  colSpan: true,
                  roundTo: 2
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q71_VALUE,
            controlHeading: {
              fieldType: inputType.HEADING,
              heading:
                '7.30.13  Provide details on the electricity, heat, and steam your organization has generated and consumed for steel production activities.',
              tooltip: `Question 7.30.9 has been modified and represented here for the steel sector. This enables consistency of reporting across organizations with varying coverage over activities that may
                          be separate from the steel sector or independent of the production activities defining the steel sector.`
            },
            scopeColumnTitle: 'Energy carrier',
            conditions: {
              dependsOn: [
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE
              ],
              shouldShow: {
                expression: {
                  and: [
                    {
                      parentField:
                        CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE,
                      field: 'scopeLabel',
                      operator: 'equals',
                      value:
                        'Generation of electricity, heat, steam, or cooling'
                    },
                    {
                      parentField:
                        CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE,
                      field:
                        'corporatePerformanceClimateChangeQ58_1_value_activity6',
                      operator: 'equals',
                      value: 'Yes'
                    }
                  ]
                }
              }
            } satisfies FieldConditions,
            fixedRows: [
              {
                id: 'energy1',
                label: 'Electricity'
              },
              {
                id: 'energy2',
                label: 'Heat'
              },
              {
                id: 'energy3',
                label: 'Steam'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q71_1_VALUE,
                  fieldLabel:
                    'Total gross generation inside steel sector boundary (MWh)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q71_2_VALUE,
                  fieldLabel:
                    'Generation that is consumed by the organization inside steel sector boundary (MWh)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q71_3_VALUE,
                  fieldLabel:
                    'Generation from renewable sources inside steel sector boundary (MWh)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q71_4_VALUE,
                  fieldLabel:
                    'Generation from waste heat/gases recovered from processes using fuel feedstocks inside steel sector boundary (MWh)',
                  colSpan: true,
                  roundTo: 2
                }
              ]
            }
          }
        ]
      },

      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.30.14 Provide details on the electricity, heat, steam, and/or cooling amounts that were accounted for at a zero or near-zero emission factor in the market-based Scope 2 figure reported in 7.7. ',
            tooltip:
              'This question provides data users with more transparency regarding organizations’ active sourcing of low-carbon energy.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_1_VALUE_ACTIVITY_1
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q72_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_1_VALUE_ACTIVITY_1,
            showWhen: ['Yes'],
            relatedTableKey:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q58_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q72_1_VALUE,
                  fieldLabel: 'Country/area',
                  options: COUNTRY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q72_2_VALUE,
                  fieldLabel: 'Sourcing method',
                  options: SOURCING_METHOD_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q72_3_VALUE,
                  fieldLabel: 'Energy carrier',
                  options: ENERGY_CARRIER_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q72_4_VALUE,
                  fieldLabel: 'Low-carbon technology type',
                  options: LOW_CARBON_TECHNOLOGY_TYPE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q72_5_VALUE,
                  fieldLabel:
                    'Low-carbon energy consumed via selected sourcing method in the reporting year (MWh)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q72_6_VALUE,
                  fieldLabel: 'Tracking instrument used',
                  options: TRACKING_INSTRUMENT_USED_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q72_7_VALUE,
                  fieldLabel:
                    'Country/area of origin (generation) of the low-carbon energy or energy attribute',
                  options: COUNTRY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q72_8_VALUE,
                  fieldLabel:
                    'Are you able to report the commissioning or re-powering year of the energy generation facility?',
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q72_9_VALUE,
                  fieldLabel:
                    'Commissioning year of the energy generation facility (e.g. date of first commercial operation or repowering)',
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q72_8_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q72_10_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2500
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.30.15 Provide details on the average emission factor used for all transport movements per mode that directly source energy from the grid.',
            tooltip:
              'Some alternatives to fossil-fuel based technologies use electrical energy sourced from the grid. The degree to which this replacement has climate benefits depends on the average grid emission factor used for the movements of these electric vehicles.',
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q73_VALUE
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q73_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q73_1_VALUE,
                  fieldLabel: 'Category',
                  options: [
                    {value: 'LDV', label: 'LDV'},
                    {value: 'HDV', label: 'HDV'},
                    {value: 'Rail', label: 'Rail'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q73_2_VALUE,
                  fieldLabel: 'Emission factor unit',
                  options: [
                    {value: 'gCO2/kWh', label: 'gCO2/kWh'},
                    {value: 'gCO2e/kWh', label: 'gCO2e/kWh'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q73_3_VALUE,
                  fieldLabel: 'Average emission factor: unit value',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q73_4_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.30.16 Provide a breakdown by country/area of your electricity/heat/steam/cooling consumption in the reporting year.',
            tooltip: `Breaking down energy consumption to the country/area
level is useful to data users, as this is often the level at which energy-related legislation is introduced. Data from this question can help guide the development of energyrelated legislation.`,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q74_VALUE
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q74_VALUE,
            allowMultipleRows: false,
            scopeColumnTitle: 'Country/area',
            fixedRows: [],
            formList: {
              formFields: [
                // {
                //   type: inputType.SELECT,
                //   fieldName:
                //     CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q74_1_VALUE,
                //   fieldLabel: 'Country/area',
                //   options: COUNTRY_OPTIONS,
                //   colSpan: true
                // },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q74_2_VALUE,
                  fieldLabel: 'Consumption of purchased electricity (MWh)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q74_3_VALUE,
                  fieldLabel: 'Consumption of self-generated electricity (MWh)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q74_4_VALUE,
                  fieldLabel:
                    'Is some or all of this electricity consumption excluded from your RE100 commitment?',
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q74_5_VALUE,
                  fieldLabel:
                    'Consumption of purchased heat, steam, and cooling (MWh)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q74_6_VALUE,
                  fieldLabel:
                    'Consumption of self-generated heat, steam, and cooling (MWh)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.DISPLAY_CALCULATION_IN_TABLE,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q74_7_VALUE,
                  fieldLabel:
                    'Total electricity/heat/steam/cooling energy consumption (MWh)',
                  relatedKey: [
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q74_2_VALUE,
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q74_3_VALUE,
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q74_5_VALUE,
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q74_6_VALUE
                  ],
                  formula: ([sum1, sum2, sum3, sum4]: any[]):
                    | number
                    | string => {
                    const total = sum1 + sum2 + sum3 + sum4;

                    return total;
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q74_8_VALUE,
                  fieldLabel:
                    'Provide details of the electricity consumption excluded',
                  colSpan: true,
                  textLimit: 2500
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.30.17 Provide details of your organization’s renewable electricity purchases in the reporting year by country/area. ',
            tooltip:
              'Renewable energy is critical to the transition to a lowcarbon economy. In this question, organizations can demonstrate progress towards their RE100 commitment by reporting the details of their renewable electricity purchasing by country/area.',
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q75_VALUE
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q75_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q75_1_VALUE,
                  fieldLabel:
                    'Country/area of consumption of purchased renewable electricity',
                  options: COUNTRY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q75_2_VALUE,
                  fieldLabel: 'Sourcing method',
                  options: SOURCING_METHOD_2_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q75_3_VALUE,
                  fieldLabel: 'Renewable electricity technology type',
                  options: RENEWABLE_ELECTRICITY_TECHNOLOGY_TYPE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q75_4_VALUE,
                  fieldLabel:
                    'Renewable electricity consumed via selected sourcing method in the reporting year (MWh)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q75_5_VALUE,
                  fieldLabel: 'Tracking instrument used',
                  options: TRACKING_INSTRUMENT_USED_2_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q75_6_VALUE,
                  fieldLabel:
                    'Country/area of origin (generation) of purchased renewable electricity',
                  options: COUNTRY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q75_7_VALUE,
                  fieldLabel:
                    'Are you able to report the commissioning or re-powering year of the energy generation facility?',
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q75_8_VALUE,
                  fieldLabel:
                    'Commissioning year of the energy generation facility (e.g. date of first commercial operation or repowering)',
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q75_7_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q75_9_VALUE,
                  fieldLabel:
                    'Vintage of the renewable energy/attribute (i.e. year of generation)',
                  options: VINTAGE_OF_RENEWABLE_ENERGY_ATTRIBUTE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q75_10_VALUE,
                  fieldLabel: 'Supply arrangement start year',
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q75_11_VALUE,
                  fieldLabel:
                    'Ecolabel associated with purchased renewable electricity',
                  options:
                    ECOLABEL_ASSOCIATED_WITH_PURCHASED_RENEWABLE_ELECTRICITY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q75_12_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2500
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.30.18  Provide details of your organization’s low-carbon heat, steam, and cooling purchases in the reporting year by country/area.',
            tooltip:
              'Providing details of low-carbon heat, steam and cooling purchases by country/area provides data users with a more complete picture of an organization’s low carbon and renewable energy consumption. ',
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q76_VALUE
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q76_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q76_1_VALUE,
                  fieldLabel: 'Sourcing method',
                  options: SOURCING_METHOD_3_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q76_2_VALUE,
                  fieldLabel:
                    'Country/area of consumption of low-carbon heat, steam or cooling',
                  options: COUNTRY_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q76_1_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'None (no purchases of low-carbon heat, steam, or cooling)'
                    ]
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q76_3_VALUE,
                  fieldLabel: 'Energy carrier',
                  options: ENERGY_CARRIER_2_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q76_1_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'None (no purchases of low-carbon heat, steam, or cooling)'
                    ]
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q76_4_VALUE,
                  fieldLabel: 'Low-carbon technology type',
                  options: LOW_CARBON_TECHNOLOGY_TYPE_2_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q76_1_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'None (no purchases of low-carbon heat, steam, or cooling)'
                    ]
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q76_5_VALUE,
                  fieldLabel:
                    'Low-carbon heat, steam, or cooling consumed (MWh)',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q76_1_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'None (no purchases of low-carbon heat, steam, or cooling)'
                    ]
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q76_6_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q76_1_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'None (no purchases of low-carbon heat, steam, or cooling)'
                    ]
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.30.19 Provide details of your organization’s renewable electricity generation by country/area in the reporting year',
            tooltip:
              'Renewable energy is critical to the transition to a low-carbon economy. In this question, companies can demonstrate progress towards their RE100 commitment by reporting the details of their renewable electricity generation by country/area.',
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q77_VALUE
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q77_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q77_1_VALUE,
                  fieldLabel: 'Country/area of generation',
                  options: COUNTRY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q77_2_VALUE,
                  fieldLabel: 'Renewable electricity technology type',
                  options: RENEWABLE_ELECTRICITY_TECHNOLOGY_TYPE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q77_3_VALUE,
                  fieldLabel: 'Facility capacity (MW)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q77_4_VALUE,
                  fieldLabel:
                    'Total renewable electricity generated by this facility in the reporting year (MWh)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q77_5_VALUE,
                  fieldLabel:
                    'Renewable electricity consumed by your organization from this facility in the reporting year (MWh)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q77_6_VALUE,
                  fieldLabel:
                    'Energy attribute certificates issued for this generation',
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q77_7_VALUE,
                  fieldLabel: 'Type of energy attribute certificate',
                  options: ENERGY_ATTRIBUTE_CERTIFICATE_TYPE_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q77_6_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q77_8_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2500
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.WYSIWYG,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q78_VALUE,
            fieldLabel:
              '7.30.20 Describe how your organization’s renewable electricity sourcing strategy directly or indirectly',
            tooltip:
              'Renewable electricity sourcing mechanisms differ in the impact they have on the grid in the market where the electricity is consumed. This question informs data users about the contribution that RE100 members’ sourcing strategies make to driving new renewable electricity capacity.',
            heading: inputType.HEADING,
            colSpan: true,
            textLimit: 5000
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.30.21 In the reporting year, has your organization faced barriers or challenges to sourcing renewable ',
            tooltip:
              'Insight into the challenges organizations face in meeting their RE100 targets is one of RE100’s tools to advocate policy change to make renewable electricity more accessible.',
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q79_VALUE
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q79_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q79_1_VALUE,
                  fieldLabel: 'Challenges to sourcing renewable electricity',
                  options: CHALLENGES_TO_SOURCING_RENEWABLE_ELECTRICITY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q79_2_VALUE,
                  fieldLabel:
                    'Challenges faced by your organization which were not country/area-specific*',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q79_1_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Yes, not specific to a country/area',
                      'Yes, both in specific countries/areas and in general'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q79_1_VALUE,
                    condition: conditionType.INCLUDES,
                    values: [
                      'Yes, not specific to a country/area',
                      'Yes, both in specific countries/areas and in general'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q79_1_VALUE
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.30.22 Provide details of the country/area-specific challenges to sourcing renewable electricity faced by your organization in the reporting year.',
            tooltip:
              'Transparency of the challenges that organizations have faced in meeting their RE100 targets is crucial to show policy makers that there is unmet demand from companies, which can be used as a driver of change to progress the renewable energy ambition.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q79_VALUE,
              showWhen: [
                'Yes, not specific to a country/area',
                'Yes, both in specific countries/areas and in general'
              ],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q79_1_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q80_VALUE,
            allowMultipleRows: false,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q79_1_VALUE,
            showWhen: [
              'Yes, not specific to a country/area',
              'Yes, both in specific countries/areas and in general'
            ],
            relatedTableKey:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q79_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q80_1_VALUE,
                  fieldLabel: 'Country/area',
                  options: COUNTRY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q80_2_VALUE,
                  fieldLabel:
                    'Reasons why it was challenging to source renewable electricity within selected country/area',
                  options:
                    REASONS_WHY_IT_WAS_CHALLENGING_TO_SOURCING_RENEWABLE_ELECTRICITY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q80_3_VALUE,
                  fieldLabel:
                    'Provide additional details of the barriers faced within this country/area',
                  colSpan: true,
                  textLimit: 2500
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.RADIOGROUP,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q81_VALUE,
            fieldLabel:
              '7.31 Does your organization consume fuels as feedstocks for chemical production activities?',
            tooltip:
              'Consumption of energy as feedstock is unique to chemical sector. A large share of fuels used by the sector is not combusted but is consumed as raw material. The information requested in this and the following question provides transparency on the level of fuel feedstocks consumed by your organization.',
            heading: inputType.HEADING,
            colSpan: true,
            options: ['Yes', 'No']
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.31.1 Disclose details on your organization’s consumption of feedstocks for chemical production activities.',
            tooltip:
              'A significant proportion of fuels used in the chemicals industry are consumed as feedstocks. The information requested in this question provides transparency on the level of fuel feedstocks consumed by your organization, as well as on their inherent carbon dioxide emission factor. This can be useful for quality checking of your emissions disclosure in question 7.19.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q81_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q81_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q82_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q81_VALUE,
            showWhen: ['Yes'],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q82_1_VALUE,
                  fieldLabel: 'Fuels used as feedstocks',
                  options: FUELS_USED_AS_FEEDSTOCKS_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q82_2_VALUE,
                  fieldLabel: 'Total consumption',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q82_3_VALUE,
                  fieldLabel: 'Total consumption unit',
                  options: TOTAL_CONSUMPTION_UNIT_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q82_4_VALUE,
                  fieldLabel:
                    'Inherent carbon dioxide emission factor of feedstock (metric tons CO2 per consumption unit)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q82_5_VALUE,
                  fieldLabel:
                    'Heating value of feedstock (MWh per consumption unit)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q82_6_VALUE,
                  fieldLabel: 'Heating value',
                  options: HEATING_VALUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q82_7_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.31.2 State the percentage, by mass, of primary resource from which your chemical feedstocks derive.',
            tooltip: `Increasing the share of alternative, low-carbon
                        feedstocks is one of the key levers of decarbonization for
                        the sector, so the share of biomass/waste in an organization’s total chemical feedstock should be increasing year on year`,
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q81_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q81_VALUE
            }
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q83_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q81_VALUE,
            showWhen: ['Yes'],
            scopeColumnTitle: 'Feedstock source',
            fixedRows: [
              {
                id: 'source1',
                label: 'Oil'
              },
              {
                id: 'source2',
                label: 'Natural Gas'
              },
              {
                id: 'source3',
                label: 'Coal'
              },
              {
                id: 'source4',
                label: 'Biomass'
              },
              {
                id: 'source5',
                label: 'Waste (non-biomass)'
              },
              {
                id: 'source6',
                label:
                  'Fossil fuel (where coal, gas, oil cannot be distinguished)'
              },
              {
                id: 'source7',
                label: 'Unknown source or unable to disaggregate'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q83_1_VALUE,
                  fieldLabel: 'Percentage of total chemical feedstock (%)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q83_2_VALUE,
                  fieldLabel:
                    'Direction of change in percentage of total chemical feedstock from previous year',
                  options: [
                    {value: 'Increased', label: 'Increased'},
                    {value: 'Decreased', label: 'Decreased'},
                    {value: 'No change', label: 'No change'}
                  ],
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.32 Disclose details on your organization’s consumption of feedstocks for steel production activities.',
            tooltip:
              'The steel sector is largely dependent on carbon-based feedstocks, which act as chemical agents in the reduction of iron ore. It is also common for steel companies to consume coal as a feedstock in the production of coke. These feedstocks are consumed in large quantities and represent a significant depletion of natural resources. Furthermore, they are the source of byproduct gasses, which are subsequently combusted, releasing greenhouse gas emissions. As such, data users are interested in the specification of carbon and energy content of these feedstocks, their consumption, and the consumption of non-carbon based reducing agents.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q85_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q85_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q84_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q85_VALUE,
            showWhen: ['Yes'],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q84_1_VALUE,
                  fieldLabel: 'Feedstocks',
                  options: FEEDSTOCKS_STEEL,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q84_2_VALUE,
                  fieldLabel: 'Total consumption',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q84_3_VALUE,
                  fieldLabel: 'Total consumption unit',
                  options: TOTAL_CONSUMPTION_UNIT_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q84_4_VALUE,
                  fieldLabel: 'Dry or wet basis?',
                  options: [
                    {value: 'Dry basis', label: 'Dry basis'},
                    {value: 'Wet basis', label: 'Wet basis'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q84_5_VALUE,
                  fieldLabel:
                    'Inherent carbon dioxide emission factor of feedstock (metric tons CO2 per consumption unit)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q84_6_VALUE,
                  fieldLabel:
                    'Heating value of feedstock (MWh per consumption unit)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q84_7_VALUE,
                  fieldLabel: 'Heating value',
                  options: HEATING_VALUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q84_8_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.RADIOGROUP,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q85_VALUE,
            fieldLabel:
              '7.33 Does your electric utility organization have a transmission and distribution business?',
            tooltip:
              'Transmission and distribution companies play an important role in enabling the transition to low-carbon electricity systems. Transmission and distribution systems also have significant energy losses. Therefore, data users are interested in what transmission and distribution companies are doing to reduce their own carbon footprint (energy losses) and the carbon footprint of the grids they operate (grid decarbonization).',
            heading: inputType.HEADING,
            colSpan: true,
            options: ['Yes', 'No']
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.33.1 Disclose the following information about your transmission and distribution business.',
            tooltip:
              'A set of quantitative disclosures is put forward that allows electric utility organizations with a transmission and distribution business(s) to characterize their grid operations. These companies often operate within strict regulatory and contractual clauses, and therefore are provided with the opportunity to provide a narrative description to explain such instances. '
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q86_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q86_1_VALUE,
                  fieldLabel: 'Country/area/region',
                  options: COUNTRY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q86_2_VALUE,
                  fieldLabel: 'Voltage level',
                  options: [
                    {
                      value: 'Transmission (high voltage)',
                      label: 'Transmission (high voltage)'
                    },
                    {
                      value: 'Distribution (low voltage)',
                      label: 'Distribution (low voltage)'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q86_3_VALUE,
                  fieldLabel: 'Annual load (GWh)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q86_4_VALUE,
                  fieldLabel: 'Annual energy losses (% of annual load)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q86_5_VALUE,
                  fieldLabel:
                    'Scope where emissions from energy losses are accounted for',
                  options: [
                    {value: 'Scope 1', label: 'Scope 1'},
                    {
                      value: 'Scope 2 (location-based)',
                      label: 'Scope 2 (location-based)'
                    },
                    {
                      value: 'Scope 2 (market-based)',
                      label: 'Scope 2 (market-based)'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q86_6_VALUE,
                  fieldLabel: 'Emissions from energy losses (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q86_7_VALUE,
                  fieldLabel: 'Length of network (km)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q86_8_VALUE,
                  fieldLabel: 'Number of connections',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q86_9_VALUE,
                  fieldLabel: 'Area covered (km²)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q86_10_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.34 Does your organization measure the efficiency of any of its products or services?',
            tooltip:
              'Energy efficiency will be key to achieving the International Energy Agency’s below 2-degree scenario as global energy demand grows. Since this sector produces the technology that will allow end-markets to achieve their own efficiency goals, data users are interested in whether companies are measuring and improving the efficiency of their products and services.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q87_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q87_1_VALUE,
                  fieldLabel: 'Measurement of product/service efficiency',
                  options: MEASUREMENT_OF_PRODUCT_SERVICE_EFFICIENCY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q87_2_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.34.1 Provide details of the metrics used to measure the efficiency of your organizations products or services.',
            tooltip:
              'In line with the TCFD recommendations, the efficiency levels achieved by organizations in this sector provide investors with an indication of the vulnerability of the product portfolio to transition risk and thus the earning capacity of the organization. This question provides data users with information on the metrics companies are using to measure the efficiency of their products and services, including the proportion of the total product range measured.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q87_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q87_1_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q88_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q87_1_VALUE,
            showWhen: ['Yes'],
            relatedTableKey:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q87_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q88_1_VALUE,
                  fieldLabel: 'Category of product or service',
                  options: CATEGORY_OF_PRODUCT_OR_SERVICE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q88_2_VALUE,
                  fieldLabel: 'Product or service (optional)',
                  colSpan: true,
                  textLimit: 500
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q88_3_VALUE,
                  fieldLabel:
                    '% of revenue from this product or service in the reporting year',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q88_4_VALUE,
                  fieldLabel: 'Efficiency figure in the reporting year',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q88_5_VALUE,
                  fieldLabel: 'Metric numerator',
                  options: METRIC_NUMERATOR_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q88_6_VALUE,
                  fieldLabel: 'Metric denominator',
                  options: METRIC_DENOMINATOR_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q88_7_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.35 Provide any efficiency metrics that are appropriate for your organization’s transport products and/or services',
            tooltip:
              'Efficiency metrics are the primary way through which transport sector companies can measure the energy efficiency of their vehicles across modes of transportation. Various primary metrics exist as standards for different modes of transport, and sector experts and relevant data users will be able to use this information to compare the company’s overall efficiency.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q89_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q89_1_VALUE,
                  fieldLabel: 'Activity',
                  options: TRANSPORT_MODE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q89_2_VALUE,
                  fieldLabel: 'Metric figure',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q89_3_VALUE,
                  fieldLabel: 'Metric numerator',
                  options: METRIC_NUMERATOR_GROUPED_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q89_4_VALUE,
                  fieldLabel: 'Metric denominator',
                  options: METRIC_NUMERATOR_GROUPED_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q89_5_VALUE,
                  fieldLabel: 'Metric numerator: Unit total',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q89_6_VALUE,
                  fieldLabel: 'Metric denominator: Unit total',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q89_7_VALUE,
                  fieldLabel: '% change from last year',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q89_8_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.36 Provide any efficiency metrics that are appropriate for your organization’s transport products and/or',
            tooltip:
              'Efficiency metrics are the primary way through which transport sector companies can measure the energy efficiency of their vehicles across modes of transportation. Various primary metrics exist as standards for different modes of transport, and sector experts and relevant data users will be able to use this information to compare the company’s overall efficiency.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q90_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q90_1_VALUE,
                  fieldLabel: 'Activity',
                  options: TRANSPORT_MODE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q90_2_VALUE,
                  fieldLabel: 'Metric figure',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q90_3_VALUE,
                  fieldLabel: 'Metric numerator',
                  options: METRIC_NUMERATOR_GROUPED_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q90_4_VALUE,
                  fieldLabel: 'Metric denominator',
                  options: METRIC_NUMERATOR_GROUPED_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q90_5_VALUE,
                  fieldLabel: 'Metric numerator: Unit total',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q90_6_VALUE,
                  fieldLabel: 'Metric denominator: Unit total',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q90_7_VALUE,
                  fieldLabel: '% change from last year',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q90_8_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.37 Disclose coal reserves and production by coal type attributable to your organization in the reporting year',
            tooltip:
              'Fossil fuels are the largest source of global emissions and coal is the most carbon intensive fossil fuel. It is therefore important to have transparency about the production and reserves of coal attributable to organizations. The split between thermal coal and metallurgical coal is also important. Thermal coal has higher transition risk because consumers can substitute it with other sources of energy.'
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q91_VALUE,
            scopeColumnTitle: 'Coal type',
            fixedRows: [
              {
                id: 'type1',
                label: 'Thermal coal'
              },
              {
                id: 'type2',
                label: 'Metallurgical coal'
              },
              {
                id: 'type3',
                label: 'Other coal'
              },
              {
                id: 'type4',
                label: 'Total coal'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q91_1_VALUE,
                  fieldLabel: 'Proven reserves (million metric tons)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q91_2_VALUE,
                  fieldLabel: 'Probable reserves (million metric tons)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q91_3_VALUE,
                  fieldLabel: 'Production (million metric tons)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q91_4_VALUE,
                  fieldLabel:
                    'Energy content of production (GJ per metric ton)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q91_5_VALUE,
                  fieldLabel: 'Heating value',
                  options: HEATING_VALUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q91_6_VALUE,
                  fieldLabel:
                    'Emission factor of production (metric tons CO2e per metric ton)',
                  colSpan: true,
                  roundTo: 4
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q91_7_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.37.1 Disclose coal resources by coal type attributable to your organization in the reporting year.',
            tooltip:
              'The transition to a low-carbon economy may affect the value of resources or long-lived assets. Providing insight into potential future emissions can help to inform investors about the potential impacts of regulatory measures and demand changes on earning capacity. The following questions enable investors to understand an organizations exposure to coal resources.'
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q92_VALUE,
            scopeColumnTitle: 'Coal type',
            fixedRows: [
              {
                id: 'type1',
                label: 'Thermal coal'
              },
              {
                id: 'type2',
                label: 'Metallurgical coal'
              },
              {
                id: 'type3',
                label: 'Other coal'
              },
              {
                id: 'type4',
                label: 'Total coal'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q92_1_VALUE,
                  fieldLabel: 'Measured resources (million metric tons)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q92_2_VALUE,
                  fieldLabel: 'Indicated resources (million metric tons)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q92_3_VALUE,
                  fieldLabel: 'Inferred resources (million metric tons)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q92_4_VALUE,
                  fieldLabel: 'Total resources (million metric tons)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q92_5_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.38 Disclose your net liquid and gas hydrocarbon production (total of subsidiaries and equity-accounted entities).',
            tooltip:
              'Investors and other data users are interested in information relating to the production of different hydrocarbon categories due to the differing environmental impacts associated with each.',
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q93_VALUE
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q93_VALUE,
            scopeColumnTitle: 'Hydrocarbon category',
            fixedRows: [
              {
                id: 'category1',
                label: 'Crude oil and condensate, million barrels'
              },
              {
                id: 'category2',
                label: 'Natural gas liquids, million barrels'
              },
              {
                id: 'category3',
                label:
                  'Oil sands, million barrels (includes bitumen and synthetic crude)'
              },
              {
                id: 'category4',
                label: 'Natural gas, billion cubic feet'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q93_1_VALUE,
                  fieldLabel: 'In-year net production',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q93_2_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.WYSIWYG,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q94_VALUE,
            fieldLabel:
              '7.38.1 Explain which listing requirements or other methodologies you use to report reserves data. If your',
            tooltip:
              'This question identifies any limitations on the comparability of data that may be due to different methodologies being used.',
            heading: inputType.HEADING,
            colSpan: true,
            textLimit: 5000
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.38.2 Disclose your estimated total net reserves and resource base (million boe), including the total',
            tooltip:
              'The transition to a low-carbon economy may affect the value of resources or long-lived assets. Robust data on proved, probable and total resource base is valuable information for data users and investors. Providing insight into organization’s reserves and resource base can help to inform investors about the potential impacts of regulatory measures and demand changes on earning capacity.',
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q95_VALUE
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q95_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q95_1_VALUE,
                  fieldLabel:
                    'Estimated total net proved + probable reserves (2P) (million BOE)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q95_2_VALUE,
                  fieldLabel:
                    'Estimated total net proved + probable + possible reserves (3P) (million BOE)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q95_3_VALUE,
                  fieldLabel: 'Estimated net total resource base (million BOE)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q95_4_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.38.3 Disclose your net liquid and gas hydrocarbon production (total of subsidiaries and equity-accounted entities).',
            tooltip:
              'Investors and other data users are interested in information relating to the production of different hydrocarbon categories due to the differing environmental impacts associated with each.',
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q96_VALUE
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q96_VALUE,
            scopeColumnTitle: 'Hydrocarbon category',
            fixedRows: [
              {
                id: 'category1',
                label: 'Crude oil/ condensate/natural gas liquids'
              },
              {
                id: 'category2',
                label: 'Natural gas'
              },
              {
                id: 'category3',
                label: 'Oil sands (includes bitumen and synthetic crude)'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q96_1_VALUE,
                  fieldLabel: 'Net proved + probable reserves (2P) (%)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q96_2_VALUE,
                  fieldLabel:
                    'Net proved + probable + possible reserves (3P) (%)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q96_3_VALUE,
                  fieldLabel: 'Net total resource base (%)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q96_4_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.38.4 Provide an indicative percentage split for production, 1P, 2P, 3P reserves, and total resource base by development types',
            tooltip:
              'The transition to a low-carbon economy may affect the value of reserves or long-lived assets. A breakdown of reserves and resource base by development type provides insight into potential future emissions. This insight can help to inform investors about the potential impacts of regulatory measures and demand changes on earning capacity. Information regarding the breakdown of conventional and unconventional hydrocarbons of the total resource base is valuable to investors.',
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q97_VALUE
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q97_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q97_1_VALUE,
                  fieldLabel: 'Development type',
                  options: DEVELOPMENT_TYPE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q97_2_VALUE,
                  fieldLabel: 'In-year net production (%)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q97_3_VALUE,
                  fieldLabel: 'Net proved reserves (1P) (%)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q97_4_VALUE,
                  fieldLabel: 'Net proved + probable reserves (2P) (%)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q97_5_VALUE,
                  fieldLabel:
                    'Net proved + probable + possible reserves (3P) (%)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q97_6_VALUE,
                  fieldLabel: 'Net total resource base (%)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q97_7_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.39 Provide details on your organization’s chemical products.',
            tooltip:
              'Unlike most other high-impact sectors identified by CDP, the chemicals sector is heterogeneous and highly diverse in structure, and can even be characterized as a group of disparate subsectors. It is, therefore, problematic to consider sector-wide intensities. However, it is useful to identify the most important chemical production processes from an environmental or transition risk perspective and shed light on the presence and impact of them within and between organizations.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q98_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q98_1_VALUE,
                  fieldLabel: 'Output product',
                  options: OUTPUT_PRODUCT_OPTIONS_2,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q98_2_VALUE,
                  fieldLabel: 'Production (metric tons)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q98_3_VALUE,
                  fieldLabel: 'Capacity (metric tons)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q98_4_VALUE,
                  fieldLabel:
                    'Direct emissions intensity (metric tons CO2e per metric ton of product)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q98_5_VALUE,
                  fieldLabel:
                    'Electricity intensity (MWh per metric ton of product)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q98_6_VALUE,
                  fieldLabel: 'Steam intensity (MWh per metric ton of product)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q98_7_VALUE,
                  fieldLabel:
                    'Steam/heat recovered (MWh per metric ton of product)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q98_8_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.40 Break down the coal production attributed to your organization in the reporting year by grade.',
            tooltip:
              'Investors and data users are interested in information relating to the production of different coal grades due to the environmental impacts associated with each.'
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q99_VALUE,
            scopeColumnTitle: 'Coal grade',
            fixedRows: [
              {
                id: 'grade1',
                label: 'Lignite'
              },
              {
                id: 'grade2',
                label: 'Subbituminous'
              },
              {
                id: 'grade3',
                label: 'Bituminous'
              },
              {
                id: 'grade4',
                label: 'Anthracite'
              },
              {
                id: 'grade5',
                label: 'Other'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q99_1_VALUE,
                  fieldLabel: 'Production (%)',
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q99_2_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.40.1 Break down the coal production attributed to your organization in the reporting year by mine type.',
            tooltip:
              'There is a significantly greater energy requirement and fugitive emissions associated with coal production from underground mines. Furthermore, it is necessary to know this split in order to turn the activity emissions split into factors.'
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q100_VALUE,
            scopeColumnTitle: 'Coal mine type',
            fixedRows: [
              {
                id: 'mine1',
                label: 'Underground'
              },
              {
                id: 'mine2',
                label: 'Surface'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q100_1_VALUE,
                  fieldLabel: 'Production (%)',
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.41 Report your organization’s steel-related consumption, production and capacity figures by steel plant.',
            tooltip:
              'The steel sector is structured around primary and secondary production of steel. Each production route has very different implications from the perspective of raw material and energy needs, greenhouse gas emissions, and technological and market risks and opportunities. It is therefore important for organizations to provide transparency on their operational structure. The most commonly used steel furnace in the primary route is the basic oxygen furnace, while the electric arc furnace is the most common steel furnace used in secondary production. Because the relative proportion of scrap and new iron charged to each 240 steel furnace can vary, it is important to know the mix of metallic feedstocks consumed by steel furnace, as well as the steel furnace production output.'
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q101_VALUE,
            scopeColumnTitle: 'Steel plant',
            fixedRows: [
              {
                id: 'plant1',
                label: 'Basic oxygen furnace'
              },
              {
                id: 'plant2',
                label: 'Electric arc furnace'
              },
              {
                id: 'plant3',
                label: 'Other'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q101_1_VALUE,
                  fieldLabel: 'Metal scrap consumption (metric tons)',
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q101_2_VALUE,
                  fieldLabel: 'Blast furnace iron consumption (metric tons)',
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q101_3_VALUE,
                  fieldLabel: 'Direct reduced iron consumption (metric tons)',
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q101_4_VALUE,
                  fieldLabel: 'Crude steel production (metric tons)',
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q101_5_VALUE,
                  fieldLabel: 'Crude steel capacity (metric tons)',
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.41.1 Report your organization’s steel-related production outputs and capacities by product.',
            tooltip:
              'Given the wide range of different structures and configurations of steel processes covered by organizations, it is important to provide transparency on the output of key products within the sector. This contributes significantly to the understanding of emissions and emissions intensity by allowing data users and investors to know the reach of an organization’s activities and understand that organizations have various levels of coverage within the sector or within a given process route.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q102_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q102_1_VALUE,
                  fieldLabel: 'Product',
                  options: PRODUCT_OPTIONS_2,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q102_2_VALUE,
                  fieldLabel: 'Production (metric tons)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q102_3_VALUE,
                  fieldLabel: 'Capacity (metric tons)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q102_4_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.42 Provide details on the commodities relevant to the mining production activities of your organization.',
            tooltip:
              'Unlike most other high-impact sectors identified by CDP, the metals and mining sector is heterogeneous and highly diverse in structure, and can even be characterized as a group of disparate subsectors. It is, therefore, problematic to consider sector-wide intensities. However, it is useful to identify metals and mining commodities individually and shed light on the presence and impact of them within and between organizations.',
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q103_VALUE
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q103_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q103_1_VALUE,
                  fieldLabel: 'Output product',
                  options: OUTPUT_PRODUCT_OPTIONS_3,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q103_2_VALUE,
                  fieldLabel: 'Capacity (metric tons)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q103_3_VALUE,
                  fieldLabel: 'Production (metric tons)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q103_4_VALUE,
                  fieldLabel:
                    'Production (copper-equivalent units) (metric tons)',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q103_1_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Bauxite',
                      'Copper',
                      'Gold',
                      'Platinum group metals',
                      'Silver',
                      'Iron ore',
                      'Nickel',
                      'Zinc',
                      'Lead',
                      'Diamonds',
                      'Other non-ferrous metal mining (please specify)'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q103_1_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Bauxite',
                      'Copper',
                      'Gold',
                      'Platinum group metals',
                      'Silver',
                      'Iron ore',
                      'Nickel',
                      'Zinc',
                      'Lead',
                      'Diamonds',
                      'Other non-ferrous metal mining (please specify)'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q103_1_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q103_5_VALUE,
                  fieldLabel: 'Scope 1 emissions',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q103_6_VALUE,
                  fieldLabel: 'Scope 2 emissions',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q103_7_VALUE,
                  fieldLabel: 'Scope 2 emissions approach',
                  options: SCOPE_2_EMISSIONS_APPROACH_OPTIONS,
                  colSpan: true,
                  conditions: {
                    dependsOn: [
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_VALUE
                    ],
                    shouldDisable: {
                      formDataDependOn: 'PARENT_FORM',
                      expression: {
                        and: [
                          {
                            parentField:
                              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_VALUE,
                            field:
                              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_2_VALUE,
                            operator: 'notEquals',
                            value:
                              'We are reporting a Scope 2, market-based figure'
                          }
                        ]
                      }
                    }
                  } satisfies FieldConditions
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q103_8_VALUE,
                  fieldLabel:
                    'Pricing methodology for copper-equivalent figure',
                  colSpan: true,
                  textLimit: 2400,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q103_1_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Bauxite',
                      'Copper',
                      'Gold',
                      'Platinum group metals',
                      'Silver',
                      'Iron ore',
                      'Nickel',
                      'Zinc',
                      'Lead',
                      'Diamonds',
                      'Other non-ferrous metal mining (please specify)'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q103_1_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Bauxite',
                      'Copper',
                      'Gold',
                      'Platinum group metals',
                      'Silver',
                      'Iron ore',
                      'Nickel',
                      'Zinc',
                      'Lead',
                      'Diamonds',
                      'Other non-ferrous metal mining (please specify)'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q103_1_VALUE
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q103_9_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.42.1 Provide details on the commodities relevant to the metals production activities of your organization.',
            tooltip:
              'Unlike most other high-impact sectors identified by CDP, the metals and mining sector is heterogeneous and highly diverse in structure, and can even be characterized as a group of disparate sub-sectors. It is, therefore, problematic to consider sector-wide intensities. However, it is useful to identify metals and mining commodities individually and shed light on the presence and impact of them within and between organizations.',
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q104_VALUE
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q104_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q104_1_VALUE,
                  fieldLabel: 'Output product',
                  options: OUTPUT_PRODUCT_OPTIONS_4,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q104_2_VALUE,
                  fieldLabel: 'Capacity (metric tons)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q104_3_VALUE,
                  fieldLabel: 'Production (metric tons)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q104_4_VALUE,
                  fieldLabel:
                    'Annual production in copper-equivalent units (thousand tons)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q104_5_VALUE,
                  fieldLabel: 'Scope 1 emissions (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q104_6_VALUE,
                  fieldLabel: 'Scope 2 emissions (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q104_7_VALUE,
                  fieldLabel: 'Scope 2 emissions approach',
                  options: SCOPE_2_EMISSIONS_APPROACH_OPTIONS,
                  colSpan: true,
                  conditions: {
                    dependsOn: [
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_VALUE
                    ],
                    shouldDisable: {
                      formDataDependOn: 'PARENT_FORM',
                      expression: {
                        and: [
                          {
                            parentField:
                              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_VALUE,
                            field:
                              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_2_VALUE,
                            operator: 'notEquals',
                            value:
                              'We are reporting a Scope 2, market-based figure'
                          }
                        ]
                      }
                    }
                  } satisfies FieldConditions
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q104_8_VALUE,
                  fieldLabel:
                    'Pricing methodology for copper-equivalent figure',
                  colSpan: true,
                  textLimit: 2400
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q104_9_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.43 Disclose your total refinery throughput capacity in the reporting year in thousand barrels per day.',
            tooltip:
              'Investors and other data users are interested in understanding the total refinery throughput as it is important for investment analysis, in addition it can provide context for the organizations emissions for the reporting year.',
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q105_VALUE
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q105_VALUE,
            fieldLabel:
              'Total refinery throughput capacity (Thousand barrels per day)',
            colSpan: true,
            roundTo: 2
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.43.1 Disclose feedstocks processed in the reporting year in million barrels per year.',
            tooltip: `There is a significant environmental impact due to the energy intensive nature and emissions output associated with the processing of feedstocks. Understanding the throughput of
                     feedstocks processed in the reporting year is important for investment analysis.`,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q106_VALUE
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q106_VALUE,
            scopeColumnTitle: 'Feedstock',
            fixedRows: [
              {
                id: 'feedstock1',
                label: 'Oil'
              },
              {
                id: 'feedstock2',
                label: 'Other feedstocks'
              },
              {
                id: 'feedstock3',
                label: 'Total '
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q106_1_VALUE,
                  fieldLabel: 'Throughput (million barrels)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q106_2_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.RADIOGROUP,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q107_VALUE,
            fieldLabel:
              '7.43.2 Are you able to break down your refinery products and net production?',
            tooltip:
              'It is important to take account of refinery net production and product slate in order better understand the sources of Scope 3 category 11 “use of sold product” emissions from organizations. It is also useful to investors for broadly indicating the spread of the organization across the various petroleum product markets.',
            heading: inputType.HEADING,
            options: ['Yes', 'No'],
            colSpan: true
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.43.3 Disclose your refinery products and net production in the reporting year in million barrels per year.',
            tooltip:
              'It is important to take account of refinery net production and product slate in order better understand the sources of Scope 3 category 11 “use of sold product” emissions from organizations. It is also useful to investors for broadly indicating the spread of the organization across the various petroleum product markets.',
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q108_VALUE,
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q107_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q107_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q108_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q107_VALUE,
            showWhen: ['Yes'],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q108_1_VALUE,
                  fieldLabel: 'Product produced',
                  options: PRODUCT_PRODUCED_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q108_2_VALUE,
                  fieldLabel:
                    'Refinery net production (Million barrels) not including products used/consumed on site',
                  colSpan: true,
                  roundTo: 2
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.43.4 Please disclose your petrochemicals production in the reporting year in thousand metric tons.',
            tooltip:
              'Petrochemicals is an important part of the oil and gas value chain but not practiced by all integrated oil and gas companies or independent refiners. It is therefore necessary to take account of these activities separately. To help data users understand the coverage of activities employed by oil and gas companies, it is important for organizations to provide transparency on petrochemicals production activities, as these have environmental impacts and are exposed to transition risks.',
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q109_VALUE
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q109_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q109_1_VALUE,
                  fieldLabel: 'Product',
                  options: [
                    {
                      value: ' High value chemicals (Steam cracking)',
                      label: ' High value chemicals (Steam cracking)'
                    },
                    {
                      value: 'Other please specify',
                      label: 'Other please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q109_2_VALUE,
                  fieldLabel: 'Production (thousand metric tons)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q109_3_VALUE,
                  fieldLabel: 'Capacity (thousand metric tons)',
                  colSpan: true,
                  roundTo: 2
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.WYSIWYG,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q110_VALUE,
            fieldLabel:
              '7.44 Explain which listing requirements or other methodologies you have used to provide reserves data in 7.37. If your organization cannot provide data due to legal restrictions on reporting reserves figures in certain countries/areas, please explain this.',
            tooltip:
              'The intention of this question is to highlight any limitations on the comparability of data that may be due to different methodologies being used.',
            heading: inputType.HEADING,
            colSpan: true,
            textLimit: 5000
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.45 Describe your gross global combined Scope 1 and 2 emissions for the reporting year in metric tons',
            tooltip: `Intensity measures describe an organization’s CO2e emissions in the context of another business metric. In this way, the emissions are normalized to account for growth and other
                  factors. Many organizations and investors have historically tracked environmental performance with intensity ratios.`
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q111_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q111_1_VALUE,
                  fieldLabel: 'Intensity figure',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q111_2_VALUE,
                  fieldLabel:
                    'Metric numerator (Gross global combined Scope 1 and 2 emissions, metric tons CO2e)',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q111_3_VALUE,
                  fieldLabel: 'Metric denominator',
                  options: METRIC_DENOMINATOR_OPTIONS_2,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q111_4_VALUE,
                  fieldLabel: 'Metric denominator: Unit total',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q111_5_VALUE,
                  fieldLabel: 'Scope 2 figure used',
                  options: [
                    {value: 'Location-based', label: 'Location-based'},
                    {value: 'Market-based', label: 'Market-based'}
                  ],
                  colSpan: true,
                  conditions: {
                    dependsOn: [
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_VALUE
                    ],
                    shouldShow: {
                      formDataDependOn: 'PARENT_FORM',
                      expression: {
                        and: [
                          {
                            parentField:
                              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_VALUE,
                            field:
                              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q5_2_VALUE,
                            operator: 'equals',
                            value:
                              'We are reporting a Scope 2, market-based figure'
                          }
                        ]
                      }
                    }
                  } satisfies FieldConditions
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q111_6_VALUE,
                  fieldLabel: '% change from previous year',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q111_7_VALUE,
                  fieldLabel: 'Direction of change',
                  options: DIRECTION_OF_CHANGE_OPTIONS_2,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q111_8_VALUE,
                  fieldLabel: 'Reasons for change',
                  options: REASONS_FOR_CHANGE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q111_9_VALUE,
                  fieldLabel: 'Please explain',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.46 For your electric utility activities, provide a breakdown of your Scope 1 emissions and emissions intensity relating to your total power plant capacity, and generation during the reporting year by source.',
            tooltip:
              'This question provides data users with more transparency regarding organizations’ active sourcing of low-carbon energy.',
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q112_VALUE
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q112_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q112_1_VALUE,
                  fieldLabel: 'Power generation technology',
                  options: POWER_GENERATION_TECHNOLOGY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q112_2_VALUE,
                  fieldLabel: 'Absolute Scope 1 emissions (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q112_3_VALUE,
                  fieldLabel:
                    'Emissions intensity based on gross or net electricity generation',
                  options: [
                    {value: 'Gross', label: 'Gross'},
                    {value: 'Net', label: 'Net'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q112_4_VALUE,
                  fieldLabel: 'Scope 1 emissions intensity (Gross generation)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q112_5_VALUE,
                  fieldLabel: 'Scope 1 emissions intensity (Net generation)',
                  colSpan: true,
                  roundTo: 2
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.47 State your organization’s Scope 1 and Scope 2 emissions intensities related to cement production activities',
            tooltip:
              'For high impact homogenous sectors, it is common to express emissions per unit of physical output. Emissions intensity provides the means to indicatively compare emissions between companies and better understand the importance and spread of emissions across the sector.'
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q113_VALUE,
            scopeColumnTitle: 'Output product',
            fixedRows: [
              {
                id: 'output1',
                label: 'Clinker'
              },
              {
                id: 'output2',
                label: 'Cement equivalent'
              },
              {
                id: 'output3',
                label: 'Cementitious products'
              },
              {
                id: 'output4',
                label: 'Low-CO2 materials'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q113_1_VALUE,
                  fieldLabel:
                    'Gross Scope 1 emissions intensity (metric tons CO2e per metric ton)',
                  colSpan: true,
                  roundTo: 4
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q113_2_VALUE,
                  fieldLabel:
                    'Net Scope 1 emissions intensity (metric tons CO2e per metric ton)',
                  colSpan: true,
                  roundTo: 4
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q113_3_VALUE,
                  fieldLabel:
                    'Scope 2, location-based emissions intensity (metric tons CO2e per metric ton)',
                  colSpan: true,
                  roundTo: 4
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.48 Provide the intensity figures for Scope 1 emissions (metric tons CO2e) per unit of hydrocarbon',
            tooltip:
              'Intensity measures describe an organization’s CO2e emissions in the context of another business metric. In this way, the emissions are normalized to account for growth. Data users and investors often track environmental performance with intensity ratios.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q114_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q114_1_VALUE,
                  fieldLabel: 'Unit of hydrocarbon category (denominator)',
                  options: HYDROCARBON_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q114_2_VALUE,
                  fieldLabel:
                    'Metric tons CO2e from hydrocarbon category per unit specified',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q114_3_VALUE,
                  fieldLabel: '% change from previous year',
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q114_4_VALUE,
                  fieldLabel: 'Direction of change',
                  options: DIRECTION_OF_CHANGE_OPTIONS_2,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q114_5_VALUE,
                  fieldLabel: 'Reason for change',
                  colSpan: true,
                  textLimit: 2400
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q114_6_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.49 State your organization’s emissions and energy intensities by steel production process route. ',
            tooltip:
              'For high impact homogenous sectors, it is common to express emissions per unit of physical output. In the case of steel, energy intensity is also an important metric measured by the industry. Steel is produced via different routes, each of which plays a key role in the sustainability of steel supply to the economy. However, because typical intensities vary between routes, disclosing a single company-wide intensity could be misleading, because it masks the relative contribution from each route. Data users are therefore interested in average intensities per process route. The aim is to account for emissions concentration across sector and organization by acknowledging different process routes within the sector.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q115_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q115_1_VALUE,
                  fieldLabel: 'Process route',
                  options: PROCESS_ROUTE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q115_2_VALUE,
                  fieldLabel:
                    'Emissions intensity figure (metric tons CO2e per metric ton of crude steel production)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q115_3_VALUE,
                  fieldLabel:
                    'Energy intensity figure (GJ (LHV) per metric ton of crude steel production)',
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q115_4_VALUE,
                  fieldLabel: 'Methodology applied',
                  options: METHODOLOGY_APPLIED_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q115_5_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.50 Provide primary intensity metrics that are appropriate to your indirect emissions in Scope 3 Category 11: Use of sold products from transport.',
            tooltip:
              'Intensity metrics can help investors and data users compare the performance of your products with others with a similar purpose, as well as with policy and market trends.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q116_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q116_1_VALUE,
                  fieldLabel: 'Activity',
                  options: TRANSPORT_MODE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q116_2_VALUE,
                  fieldLabel: 'Emissions intensity figure',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q116_3_VALUE,
                  fieldLabel:
                    'Metric numerator (Scope 3 emissions: use of sold products) (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q116_4_VALUE,
                  fieldLabel: 'Metric denominator',
                  options: METRIC_DENOMINATOR_OPTIONS_3,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q116_5_VALUE,
                  fieldLabel: 'Metric denominator: Unit total',
                  colSpan: true,
                  roundTo: 6
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q116_6_VALUE,
                  fieldLabel: '% change from previous year',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q116_7_VALUE,
                  fieldLabel: 'Vehicle unit sales in reporting year',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q116_8_VALUE,
                  fieldLabel: 'Vehicle lifetime (years)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q116_9_VALUE,
                  fieldLabel:
                    'Annual distance (km or miles — unit specified by column 4)',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q116_10_VALUE,
                  fieldLabel: 'Load factor',
                  colSpan: true,
                  textLimit: 2400
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q116_11_VALUE,
                  fieldLabel:
                    'Please explain the changes, and relevant standards/methodologies used',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.51 What are your primary intensity (activity-based) metrics that are appropriate to your emissions from transport activities in Scope 1, 2, and 3?',
            tooltip:
              'The metrics requested in this question allow measuring carbon efficiency of transportation directly, independent of size or distance. This makes comparison between organizations and different transport modes possible. Information collected in this question will enable your organization, as well as investors and data users, to compare your emissions’ intensity over time and provide a more accurate measure of any improvements you are making.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q117_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q117_1_VALUE,
                  fieldLabel: 'Organization',
                  options: [
                    {
                      label: '',
                      options: [{value: '', label: ''}]
                    },
                    {
                      label: '',
                      options: [{value: '', label: ''}]
                    }
                  ],
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.52 Provide any additional climate-related metrics relevant to your business.',
            tooltip:
              'CDP data users seek to understand in which areas, beyond GHG emissions, companies are trying to reduce their environmental impacts.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q118_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q118_1_VALUE,
                  fieldLabel: 'Description',
                  options: DESCRIPTION_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q118_2_VALUE,
                  fieldLabel: 'Metric value',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q118_3_VALUE,
                  fieldLabel: 'Metric numerator',
                  colSpan: true,
                  textLimit: 50
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q118_4_VALUE,
                  fieldLabel: 'Metric denominator (intensity metric only)',
                  colSpan: true,
                  textLimit: 50
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q118_5_VALUE,
                  fieldLabel: '% change from previous year',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q118_6_VALUE,
                  fieldLabel: 'Direction of change',
                  options: DIRECTION_OF_CHANGE_OPTIONS_2,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q118_7_VALUE,
                  fieldLabel: 'Please explain',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.SELECT,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q119_VALUE,
            fieldLabel:
              '7.53.1 Did you have an emissions target that was active in the reporting year?',
            tooltip:
              'Target setting plays a vital role in environmental action through its role in the successful execution of corporate strategies, as well as in the effective management of dependencies, impacts, risks, and opportunities. The question encourages organizations to set and make progress towards timebound, tracked, quantitative targets, informed by the guidance of leading initiatives and frameworks, such as the Science Based Targets initiative where available.',
            heading: inputType.HEADING,
            options: [
              {value: 'Absolute target', label: 'Absolute target'},
              {value: 'Intensity target', label: 'Intensity target'},
              {value: 'Portfolio target', label: 'Portfolio target'},
              {value: 'No target', label: 'No target'}
            ],
            colSpan: true
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.53.1 Provide details of your absolute emissions targets and progress made against those targets.',
            tooltip: `Target setting plays a vital role in environmental action through its role in the successful execution of corporate strategies, as well as in the effective management of dependencies, impacts, risks, and opportunities. The question encourages organizations to set and make progress towards
timebound, tracked, quantitative targets, informed by the guidance of leading initiatives and frameworks, such as the Science Based Targets initiative where available.`,
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q119_VALUE,
              showWhen: ['Absolute target'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q119_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q119_VALUE,
            showWhen: ['Absolute target'],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_1_VALUE,
                  fieldLabel: 'Target reference number',
                  options: ABS_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_2_VALUE,
                  fieldLabel: 'Is this a science-based target?',
                  options: SCIENCE_BASED_TARGET_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.FILEUPLOAD,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_3_VALUE,
                  fieldLabel:
                    'Science Based Targets initiative official validation letter',
                  colSpan: true,
                  fileUploadAction:
                    API_ENDPOINT_JSON.ESG.CDP_CORPORATE.documentUpload
                      .climateChange,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_2_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Yes, and this target has been approved by the Science Based Targets initiative'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_2_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Yes, and this target has been approved by the Science Based Targets initiative'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_2_VALUE
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_4_VALUE,
                  fieldLabel: 'Target ambition',
                  options: TARGET_AMBITION_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_2_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Yes, and this target has been approved by the Science Based Targets initiative',
                      'Yes, we consider this a science-based target, and the target is currently being reviewed by the Science Based Targets initiative',
                      'Yes, we consider this a science-based target, and we have committed to seek validation of this target by the Science Based Targets initiative in the next two years',
                      'Yes, we consider this a science-based target, but we have not committed to seek validation of this target by the Science Based Targets initiative within the next two years'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_2_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Yes, and this target has been approved by the Science Based Targets initiative',
                      'Yes, we consider this a science-based target, and the target is currently being reviewed by the Science Based Targets initiative',
                      'Yes, we consider this a science-based target, and we have committed to seek validation of this target by the Science Based Targets initiative in the next two years',
                      'Yes, we consider this a science-based target, but we have not committed to seek validation of this target by the Science Based Targets initiative within the next two years'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_2_VALUE
                  }
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_5_VALUE,
                  fieldLabel: 'Date target was set',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_6_VALUE,
                  fieldLabel: 'Target coverage',
                  options: TARGET_COVERAGE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_7_VALUE,
                  fieldLabel: 'Greenhouse gases covered by target',
                  options: GREENHOUSE_GAS_COVERED_BY_TARGET_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                  fieldLabel: 'Scopes',
                  options: SCOPES_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_9_VALUE,
                  fieldLabel: 'Scope 2 accounting method',
                  options: [
                    {value: 'Location-based', label: 'Location-based'},
                    {value: 'Market-based', label: 'Market-based'}
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 2']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 2'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_10_VALUE,
                  fieldLabel: 'Scope 3 categories',
                  options: SCOPE_3_CATEGORIES_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_11_VALUE,
                  fieldLabel: 'End date of base year',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_12_VALUE,
                  fieldLabel:
                    'Base year Scope 1 emissions covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 1']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 1'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_13_VALUE,
                  fieldLabel:
                    'Base year Scope 2 emissions covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 2']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 2'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_14_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Purchased goods and services] emissions covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_15_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Capital goods] emissions covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_16_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Fuel- and energy-related activities] emissions covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_17_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Upstream transportation and distribution] emissions covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_18_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Waste generated in operations] emissions covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_19_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Business travel] emissions covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_20_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Employee commuting] emissions covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_21_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Upstream leased assets] emissions covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_22_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Downstream transportation and distribution] emissions covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_23_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Processing of sold products] emissions covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_24_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Use of sold products] emissions covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_25_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [End-of-life treatment of sold products] emissions covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_26_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Downstream leased assets] emissions covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_27_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Franchises] emissions covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_28_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Investments] emissions covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_29_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Other (upstream)] emissions covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_30_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Other (downstream)] emissions covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_31_VALUE,
                  fieldLabel:
                    'Base year total Scope 3 emissions covered by target (metric tons CO2e)[auto-calculated]',
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_32_VALUE,
                  fieldLabel:
                    'Total base year emissions covered by target in all selected Scopes (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_33_VALUE,
                  fieldLabel:
                    'Base year Scope 1 emissions covered by target as % of total base year emissions in Scope 1',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 1']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 1'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_34_VALUE,
                  fieldLabel:
                    'Base year Scope 2 emissions covered by target as % of total base year emissions in Scope 2',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 2']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 2'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_35_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Purchased goods and services] emissions covered by target as % of total base year emissions in Scope 3, Category [Purchased goods and services] (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_36_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Capital goods] emissions covered by target as % of total base year emissions in Scope 3, Category [Capital goods] (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_37_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Fuel- and energy-related activities ] emissions covered by target as % of total base year emissions in Scope 3, Category [Fuel- and energy-related activities] (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_38_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Upstream transportation and distribution] emissions covered by target as % of total base year emissions in Scope 3, Category [Upstream transportation and distribution] (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_39_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Waste generated in operations] emissions covered by target as % of total base year emissions in Scope 3, Category [Waste generated in operations] (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_40_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Business travel] emissions covered by target as % of total base year emissions in Scope 3, Category [Business travel] (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_41_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Employee commuting] emissions covered by target as % of total base year emissions in Scope 3, Category [Employee commuting] (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_42_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Upstream leased assets] emissions covered by target as % of total base year emissions in Scope 3, Category [Upstream leased assets] (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_43_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Downstream transportation and distribution] emissions covered by target as % of total base year emissions in Scope 3, Category [Downstream transportation and distribution] (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_44_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Processing of sold products] emissions covered by target as % of total base year emissions in Scope 3, Category [Processing of sold products] (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_45_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Use of sold products] emissions covered by target as % of total base year emissions in Scope 3, Category [Use of sold products] (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_46_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [End-of-life treatment of sold products] emissions covered by target as % of total base year emissions in Scope 3, Category [End-of-life treatment of sold products] (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_47_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Downstream leased assets] emissions covered by target as % of total base year emissions in Scope 3, Category [Downstream leased assets] (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_48_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Franchises] emissions covered by target as % of total base year emissions in Scope 3, Category [Franchises] (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_49_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Investments] emissions covered by target as % of total base year emissions in Scope 3, Category [Investments] (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_50_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Other (upstream)] emissions covered by target as % of total base year emissions in Scope 3, Category [Other (upstream)] (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_51_VALUE,
                  fieldLabel:
                    'Base year Scope 3, Category [Other (downstream)] emissions covered by target as % of total base year emissions in Scope 3, Category [Other (downstream)] (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_52_VALUE,
                  fieldLabel:
                    'Base year total Scope 3 emissions covered by target as % of total base year emissions in Scope 3 (in all Scope 3 categories)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_53_VALUE,
                  fieldLabel:
                    'Base year emissions covered by target in all selected Scopes as % of total base year emissions in all selected Scopes',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_54_VALUE,
                  fieldLabel: 'End date of target',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_55_VALUE,
                  fieldLabel: 'Targeted reduction from base year (%)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_56_VALUE,
                  fieldLabel:
                    'Total emissions at end date of target covered by target in all selected Scopes (metric tons CO2e) [auto-calculated]',
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_57_VALUE,
                  fieldLabel:
                    'Scope 1 emissions in reporting year covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_58_VALUE,
                  fieldLabel:
                    'Scope 2 emissions in reporting year covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_59_VALUE,
                  fieldLabel:
                    'Scope 3, Category [Purchased goods and services] emissions in reporting year covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_60_VALUE,
                  fieldLabel:
                    'Scope 3, Category [Capital goods] emissions in reporting year covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_61_VALUE,
                  fieldLabel:
                    'Scope 3, Category [Fuel- and energy-related activities] emissions in reporting year covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_62_VALUE,
                  fieldLabel:
                    'Scope 3, Category [Upstream transportation and distribution] emissions in reporting year covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_63_VALUE,
                  fieldLabel:
                    'Scope 3, Category [Waste generated in operations] emissions in reporting year covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_64_VALUE,
                  fieldLabel:
                    'Scope 3, Category [Business travel] emissions in reporting year covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_65_VALUE,
                  fieldLabel:
                    'Scope 3, Category [Employee commuting] emissions in reporting year covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_66_VALUE,
                  fieldLabel:
                    'Scope 3, Category [Upstream leased assets] emissions in reporting year covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_67_VALUE,
                  fieldLabel:
                    'Scope 3, Category [Downstream transportation and distribution] emissions in reporting year covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_68_VALUE,
                  fieldLabel:
                    'Scope 3, Category [Processing of sold products] emissions in reporting year covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_69_VALUE,
                  fieldLabel:
                    'Scope 3, Category [Use of sold products] emissions in reporting year covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_70_VALUE,
                  fieldLabel:
                    'Scope 3, Category [End-of-life treatment of sold products] emissions in reporting year covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_71_VALUE,
                  fieldLabel:
                    'Scope 3, Category [Downstream leased assets] emissions in reporting year covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_72_VALUE,
                  fieldLabel:
                    'Scope 3, Category [Franchises] emissions in reporting year covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_73_VALUE,
                  fieldLabel:
                    'Scope 3, Category [Investments] emissions in reporting year covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_74_VALUE,
                  fieldLabel:
                    'Scope 3, Category [Other (upstream)] emissions in reporting year covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_75_VALUE,
                  fieldLabel:
                    'Scope 3, Category [Other (downstream)] emissions in reporting year covered by target (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_76_VALUE,
                  fieldLabel:
                    'Total Scope 3 emissions in reporting year covered by target (metric tons CO2e)',
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_77_VALUE,
                  fieldLabel:
                    'Total emissions in reporting year covered by target in all selected scopes (metric tons CO2e)',
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_78_VALUE,
                  fieldLabel: 'Land-related emissions covered by target',
                  options: LAND_RELATED_EMISSIONS_COVERED_BY_TARGET_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_79_VALUE,
                  fieldLabel:
                    '% of target achieved relative to base year [auto-calculated]',
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_80_VALUE,
                  fieldLabel: 'Target status in reporting year',
                  options: TARGET_STATUS_IN_REPORTING_YEAR_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_81_VALUE,
                  fieldLabel:
                    'Explain the reasons for the revision, replacement, or retirement of the target',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_80_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Revised', 'Replaced', 'Retired']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_80_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Revised', 'Replaced', 'Retired'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_80_VALUE
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_82_VALUE,
                  fieldLabel:
                    'Explain target coverage and identify any exclusions',
                  colSpan: true,
                  textLimit: 2500
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_83_VALUE,
                  fieldLabel: 'Target objective',
                  colSpan: true,
                  textLimit: 1500
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_84_VALUE,
                  fieldLabel:
                    'Plan for achieving target, and progress made to the end of the reporting year',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_80_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Revised', 'Underway', 'New']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_80_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Revised', 'Underway', 'New'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_80_VALUE
                  }
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_85_VALUE,
                  fieldLabel:
                    'Target derived using a sectoral decarbonization approach',
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_86_VALUE,
                  fieldLabel:
                    'List the emissions reduction initiatives which contribute most to achieving this target',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_80_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Achieved', 'Achieved and maintained']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_80_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Achieved', 'Achieved and maintained'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q120_80_VALUE
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.53.2 Provide details of your emissions intensity targets and progress made against those targets.',
            tooltip: `Target setting plays a vital role in environmental action through its role the successful execution of corporate strategies, as well as in the effective management of dependencies, impacts, risks, and opportunities. The question encourages organizations to set and make progress towards timebound, tracked, quantitative targets informed by the guidance of leading initiatives and frameworks, such as the
                    Science Based Targets initiative where available. `,
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q119_VALUE,
              showWhen: ['Intensity target'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q119_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q119_VALUE,
            showWhen: ['Intensity target'],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_1_VALUE,
                  fieldLabel: 'Target reference number',
                  options: INT_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_2_VALUE,
                  fieldLabel: 'Is this a science-based target?',
                  options: SCIENCE_BASED_TARGET_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.FILEUPLOAD,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_3_VALUE,
                  fieldLabel:
                    'Science Based Targets initiative official validation letter',
                  colSpan: true,
                  fileUploadAction:
                    API_ENDPOINT_JSON.ESG.CDP_CORPORATE.documentUpload
                      .climateChange,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_2_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Yes, and this target has been approved by the Science Based Targets initiative'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_2_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Yes, and this target has been approved by the Science Based Targets initiative'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_2_VALUE
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_4_VALUE,
                  fieldLabel: 'Target ambition',
                  options: TARGET_AMBITION_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_2_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Yes, and this target has been approved by the Science Based Targets initiative',
                      'Yes, we consider this a science-based target, and the target is currently being reviewed by the Science Based Targets initiative',
                      'Yes, we consider this a science-based target, and we have committed to seek validation of this target by the Science Based Targets initiative in the next two years',
                      'Yes, we consider this a science-based target, but we have not committed to seek validation of this target by the Science Based Targets initiative within the next two years'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_2_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Yes, and this target has been approved by the Science Based Targets initiative',
                      'Yes, we consider this a science-based target, and the target is currently being reviewed by the Science Based Targets initiative',
                      'Yes, we consider this a science-based target, and we have committed to seek validation of this target by the Science Based Targets initiative in the next two years',
                      'Yes, we consider this a science-based target, but we have not committed to seek validation of this target by the Science Based Targets initiative within the next two years'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_2_VALUE
                  }
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_5_VALUE,
                  fieldLabel: 'Date target was set',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_6_VALUE,
                  fieldLabel: 'Target coverage',
                  options: TARGET_COVERAGE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_7_VALUE,
                  fieldLabel: 'Greenhouse gases covered by target',
                  options: GREENHOUSE_GAS_COVERED_BY_TARGET_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                  fieldLabel: 'Scopes',
                  options: SCOPES_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_9_VALUE,
                  fieldLabel: 'Scope 2 accounting method',
                  options: [
                    {value: 'Location-based', label: 'Location-based'},
                    {value: 'Market-based', label: 'Market-based'}
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 2']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 2'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_10_VALUE,
                  fieldLabel: 'Scope 3 categories',
                  options: SCOPE_3_CATEGORIES_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_11_VALUE,
                  fieldLabel: 'Intensity metric',
                  options: INT_METRIC_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_12_VALUE,
                  fieldLabel: 'End date of base year',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_13_VALUE,
                  fieldLabel: 'Intensity figure in base year for Scope 1',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_14_VALUE,
                  fieldLabel: 'Intensity figure in base year for Scope 2',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_15_VALUE,
                  fieldLabel:
                    'Intensity figure in base year for Scope 3, Category [Purchased goods and services]',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_16_VALUE,
                  fieldLabel:
                    'Intensity figure in base year for Scope 3, Category [Capital goods]',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_17_VALUE,
                  fieldLabel:
                    'Intensity figure in base year for Scope 3, Category [Fuel- and energy-related activities]',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_18_VALUE,
                  fieldLabel:
                    'Intensity figure in base year for Scope 3, Category [Upstream transportation and distribution]',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_19_VALUE,
                  fieldLabel:
                    'Intensity figure in base year for Scope 3, Category [Waste generated in operations]',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_20_VALUE,
                  fieldLabel:
                    'Intensity figure in base year for Scope 3, Category [Business travel]',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_21_VALUE,
                  fieldLabel:
                    'Intensity figure in base year for Scope 3, Category [Employee commuting]',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_22_VALUE,
                  fieldLabel:
                    'Intensity figure in base year for Scope 3,, Category [Upstream leased assets]',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_23_VALUE,
                  fieldLabel:
                    'Intensity figure in base year for Scope 3, Category [Downstream transportation and distribution]',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_24_VALUE,
                  fieldLabel:
                    'Intensity figure in base year for Scope 3, Category [Processing of sold products]',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_25_VALUE,
                  fieldLabel:
                    'Intensity figure in base year for Scope 3, Category [Use of sold products]',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_26_VALUE,
                  fieldLabel:
                    'Intensity figure in base year for Scope 3, Category [End-of-life treatment of sold products]',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_27_VALUE,
                  fieldLabel:
                    'Intensity figure in base year for Scope 3, Category [Downstream leased assets]',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_28_VALUE,
                  fieldLabel:
                    'Intensity figure in base year for Scope 3, Category [Franchises]',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_29_VALUE,
                  fieldLabel:
                    'Intensity figure in base year for Scope 3, Category [Investments]',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_30_VALUE,
                  fieldLabel:
                    'Intensity figure in base year for Scope 3, Category [Other (upstream)]',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_31_VALUE,
                  fieldLabel:
                    'Intensity figure in base year for Scope 3, Category [Other (downstream)]',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_32_VALUE,
                  fieldLabel: 'Intensity figure in base year for total Scope 3',
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_33_VALUE,
                  fieldLabel:
                    'Intensity figure in base year for all selected Scopes',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_34_VALUE,
                  fieldLabel:
                    '% of total base year emissions in Scope 1 covered by this Scope 1 intensity figure',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 1']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 1'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_35_VALUE,
                  fieldLabel:
                    '% of total base year emissions in Scope 2 covered by this Scope 2 intensity figure',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 2']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 2'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_36_VALUE,
                  fieldLabel:
                    '% of total base year emissions in Scope 3, Category [Purchased goods and services] covered by this Scope 3, Category [Purchased goods and services] intensity figure',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_37_VALUE,
                  fieldLabel:
                    '% of total base year emissions in Scope 3, Category [Capital goods] covered by this Scope 3, Category [Capital goods] intensity figure',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_38_VALUE,
                  fieldLabel:
                    '% of total base year emissions in Scope 3, Category [Fuel- and energy-related activities] covered by this Scope 3, Category [Fuel- and energy-related activities] intensity figure',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_39_VALUE,
                  fieldLabel:
                    '% of total base year emissions in Scope 3, Category [Upstream transportation and distribution] covered by this Scope 3, Category [Upstream transportation and distribution] intensity figure',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_40_VALUE,
                  fieldLabel:
                    '% of total base year emissions in Scope 3, Category [Waste generated in operations] covered by this Scope 3, Category [Waste generated in operations] intensity figure',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_41_VALUE,
                  fieldLabel:
                    '% of total base year emissions in Scope 3, Category [Business travel] covered by this Scope 3, Category [Business travel] intensity figure',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_42_VALUE,
                  fieldLabel:
                    '% of total base year emissions in Scope 3, Category [Employee commuting] covered by this Scope 3, Category [Employee commuting] intensity figure',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_43_VALUE,
                  fieldLabel:
                    '% of total base year emissions in Scope 3, Category [Upstream leased assets] covered by this Scope 3, Category [Upstream leased assets] intensity figure',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_44_VALUE,
                  fieldLabel:
                    '% of total base year emissions in Scope 3, Category [Downstream transportation and distribution] covered by this Scope 3, Category [Downstream transportation and distribution] intensity figure',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_45_VALUE,
                  fieldLabel:
                    '% of total base year emissions in Scope 3, Category [Processing of sold products] covered by this Scope 3, Category [Processing of sold products] intensity figure',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_46_VALUE,
                  fieldLabel:
                    '% of total base year emissions in Scope 3, Category [Use of sold products] covered by this Scope 3, Category [Use of sold products] intensity figure',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_47_VALUE,
                  fieldLabel:
                    '% of total base year emissions in Scope 3, Category [End-of-life treatment of sold products] covered by this Scope 3, Category [End-of-life treatment of sold products] intensity figure',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_48_VALUE,
                  fieldLabel:
                    '% of total base year emissions in Scope 3, Category [Downstream leased assets] covered by this Scope 3, Category [Downstream leased assets] intensity figure',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_49_VALUE,
                  fieldLabel:
                    '% of total base year emissions in Scope 3, Category [Franchises] covered by this Scope 3, Category [Franchises] intensity figure',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_50_VALUE,
                  fieldLabel:
                    '% of total base year emissions in Scope 3, Category [Investments] covered by this Scope 3, Category [Investments] intensity figure',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_51_VALUE,
                  fieldLabel:
                    '% of total base year emissions in Scope 3, Category [Other (upstream)] covered by this Scope 3, Category [Other (upstream)] intensity figure',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_52_VALUE,
                  fieldLabel:
                    '% of total base year emissions in Scope 3, Category [Other (downstream)] covered by this Scope 3, Category [Other (downstream)] intensity figure',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_53_VALUE,
                  fieldLabel:
                    '% of total base year emissions in Scope 3 (in all Scope 3 categories) covered by this total Scope 3 intensity figure',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_54_VALUE,
                  fieldLabel:
                    '% of total base year emissions in all selected Scopes covered by this intensity figure',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_55_VALUE,
                  fieldLabel: 'End date of target',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_56_VALUE,
                  fieldLabel: 'Targeted reduction from base year (%)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_57_VALUE,
                  fieldLabel:
                    'Intensity figure at end date of target for all selected Scopes [auto-calculated]',
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_58_VALUE,
                  fieldLabel:
                    '% change anticipated in absolute Scope 1+2 emissions',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 1', 'Scope 2']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 1', 'Scope 2'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_59_VALUE,
                  fieldLabel:
                    '% change anticipated in absolute Scope 3 emissions',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 3']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 3'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_60_VALUE,
                  fieldLabel: 'Intensity figure in reporting year for Scope 1',
                  colSpan: true,
                  roundTo: 10,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 1']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 1'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_61_VALUE,
                  fieldLabel: 'Intensity figure in reporting year for Scope 2',
                  colSpan: true,
                  roundTo: 10,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Scope 2']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Scope 2'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_62_VALUE,
                  fieldLabel:
                    'Intensity figure in reporting year for Scope 3, Category [Purchased goods and services]',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_63_VALUE,
                  fieldLabel:
                    'Intensity figure in reporting year for Scope 3, Category [Capital goods]',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_64_VALUE,
                  fieldLabel:
                    'Intensity figure in reporting year for Scope 3, Category [Fuel- and energy-related activities]',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_65_VALUE,
                  fieldLabel:
                    'Intensity figure in reporting year for Scope 3, Category [Upstream transportation and distribution]',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_66_VALUE,
                  fieldLabel:
                    'Intensity figure in reporting year for Scope 3, Category [Waste generated in operations]',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_67_VALUE,
                  fieldLabel:
                    'Intensity figure in reporting year for Scope 3, Category [Business travel]',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_68_VALUE,
                  fieldLabel:
                    'Intensity figure in reporting year for Scope 3, Category [Employee commuting]',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_69_VALUE,
                  fieldLabel:
                    'Intensity figure in reporting year for Scope 3, Category [Upstream leased assets]',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_70_VALUE,
                  fieldLabel:
                    'Intensity figure in reporting year for Scope 3, Category [Downstream transportation and distribution]',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_71_VALUE,
                  fieldLabel:
                    'Intensity figure in reporting year for Scope 3, Category [Processing of sold products]',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_72_VALUE,
                  fieldLabel:
                    'Intensity figure in reporting year for Scope 3, Category [Use of sold products]',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_73_VALUE,
                  fieldLabel:
                    'Intensity figure in reporting year for Scope 3, Category [End-of-life treatment of sold products]',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_74_VALUE,
                  fieldLabel:
                    'Intensity figure in reporting year for Scope 3, Category [Downstream leased assets]',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_75_VALUE,
                  fieldLabel:
                    'Intensity figure in reporting year for Scope 3, Category [Franchises]',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_76_VALUE,
                  fieldLabel:
                    'Intensity figure in reporting year for Scope 3, Category [Investments]',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_77_VALUE,
                  fieldLabel:
                    'Intensity figure in reporting year for Scope 3, Category [Other (upstream)]',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_78_VALUE,
                  fieldLabel:
                    'Intensity figure in reporting year for Scope 3, Category [Other (downstream)]',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_79_VALUE,
                  fieldLabel:
                    'Intensity figure in reporting year for total Scope 3',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_80_VALUE,
                  fieldLabel:
                    'Intensity figure in reporting year for all selected Scopes',
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_81_VALUE,
                  fieldLabel: 'Land-related emissions covered by target',
                  options: LAND_RELATED_EMISSIONS_COVERED_BY_TARGET_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_82_VALUE,
                  fieldLabel: '% of target achieved relative to base year',
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_83_VALUE,
                  fieldLabel: 'Target status in reporting year',
                  options: TARGET_STATUS_IN_REPORTING_YEAR_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_84_VALUE,
                  fieldLabel:
                    'Explain the reasons for the revision, replacement, or retirement of the target',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_83_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Revised', 'Replaced', 'Retired']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_83_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Revised', 'Replaced', 'Retired'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_83_VALUE
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_85_VALUE,
                  fieldLabel:
                    'Explain target coverage and identify any exclusions',
                  colSpan: true,
                  textLimit: 5000,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_6_VALUE,
                    condition: conditionType.NOT,
                    values: ['Organization-wide']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_6_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Organization-wide'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_6_VALUE
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_86_VALUE,
                  fieldLabel: 'Target objective',
                  colSpan: true,
                  textLimit: 1500
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_87_VALUE,
                  fieldLabel:
                    'Plan for achieving target, and progress made to the end of the reporting year',
                  colSpan: true,
                  textLimit: 2400,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_83_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Revised', 'Underway', 'New']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_83_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Revised', 'Underway', 'New'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_83_VALUE
                  }
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_88_VALUE,
                  fieldLabel:
                    'Target derived using a sectoral decarbonization approach',
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_89_VALUE,
                  fieldLabel:
                    'List the emissions reduction initiatives which contributed most to achieving this target',
                  colSpan: true,
                  textLimit: 2400,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_83_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Achieved', 'Achieved and maintained']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_83_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Achieved', 'Achieved and maintained'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q121_83_VALUE
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.53.3 Explain why you did not have an emissions target, and forecast how your emissions will change over the next five years.',
            tooltip:
              'As setting a target is a pre-requisite for leadership in environmental practice, data users need to understand why companies do not have active targets guiding environmental strategy.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q119_VALUE,
              showWhen: ['No'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q119_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q122_VALUE,
            allowMultipleRows: false,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q119_VALUE,
            showWhen: ['No'],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q122_1_VALUE,
                  fieldLabel: 'Primary reason',
                  options: PRIMARY_REASONS_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q122_2_VALUE,
                  fieldLabel: 'Five-year forecast',
                  colSpan: true,
                  textLimit: 2400
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q122_3_VALUE,
                  fieldLabel: 'Please explain',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.53.4 Provide details of the climate-related targets for your portfolio.',
            tooltip: `•Achieving net zero by 2050 will require a major redirection of capital into sustainable solutions and low-carbon technologies, which only the financial services sector can provide. This profound influence on the wider economy means financial institutions’ climate-related impact occurs mostly in their portfolios, rather than through their direct operations. Thus, setting targets and reporting on progress at a portfolio level is
considered best practice for financial institutions and can help them align their financing, investment and insurance underwriting to a 1.5ºC world.`,
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q119_VALUE,
              showWhen: ['Portfolio target'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q119_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q119_VALUE,
            showWhen: ['Portfolio target'],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_1_VALUE,
                  fieldLabel: 'Target reference number',
                  options: POR_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_2_VALUE,
                  fieldLabel: 'Target type',
                  options: TARGET_TYPE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_3_VALUE,
                  fieldLabel:
                    'Taxonomy or framework used to define “green finance',
                  options:
                    TAXONOMY_OR_FRAMEWORK_USED_TO_DEFINE_GREEN_FINANCE_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_2_VALUE,
                    condition: conditionType.NOT,
                    values: ['Green finance']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_2_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Green finance'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_2_VALUE
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_4_VALUE,
                  fieldLabel: 'Methodology used when setting the target',
                  options: METHODOLOGY_USED_WHEN_SETTING_THE_TARGET_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_5_VALUE,
                  fieldLabel: 'Date target was set',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_6_VALUE,
                  fieldLabel:
                    'Target is set and progress against it is tracked at',
                  options:
                    TARGET_IS_SET_AND_PROGRESS_AGAINST_IT_IS_TRACKED_AT_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_7_VALUE,
                  fieldLabel: 'Sector',
                  options: SECTOR_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_6_VALUE,
                    condition: conditionType.NOT,
                    values: ['Sector level']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_6_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Sector level'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_6_VALUE
                  }
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_8_VALUE,
                  fieldLabel: 'Portfolios covered by the target',
                  options: PORTFOLIOS_COVERED_BY_THE_TARGET_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_7_VALUE,
                    condition: conditionType.EMPTY,
                    values: []
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_7_VALUE,
                    condition: conditionType.EQUALS,
                    values: [],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_7_VALUE
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_9_VALUE,
                  fieldLabel: 'Portfolio',
                  options: PORTFOLIOS_COVERED_BY_THE_TARGET_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_8_VALUE,
                    condition: conditionType.EMPTY,
                    values: []
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_8_VALUE,
                    condition: conditionType.EQUALS,
                    values: [],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_8_VALUE
                  }
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_10_VALUE,
                  fieldLabel: 'Asset classes covered by the target',
                  options: ASSET_CLASSES_COVERED_BY_THE_TARGET_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_9_VALUE,
                    condition: conditionType.EMPTY,
                    values: []
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_9_VALUE,
                    condition: conditionType.EQUALS,
                    values: [],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_9_VALUE
                  }
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_11_VALUE,
                  fieldLabel: 'Sectors covered by the target',
                  options: SECTOR_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_6_VALUE,
                    condition: conditionType.NOT,
                    values: ['Portfolio level', 'Asset class level']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_6_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Portfolio level', 'Asset class level'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_6_VALUE
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_12_VALUE,
                  fieldLabel: 'Target type: Absolute or intensity',
                  options: TARGET_TYPE_ABSOLUTE_OR_INTENSITY_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_2_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Green finance',
                      'Sector Decarbonization Approach (SDA)',
                      'Absolute portfolio emissions',
                      'Portfolio emissions intensity',
                      'Weighted average carbon intensity',
                      'Engagement target',
                      'Other, please specify'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_2_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Green finance',
                      'Sector Decarbonization Approach (SDA)',
                      'Absolute portfolio emissions',
                      'Portfolio emissions intensity',
                      'Weighted average carbon intensity',
                      'Engagement target',
                      'Other, please specify'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_2_VALUE
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_13_VALUE,
                  fieldLabel:
                    'Emissions scopes of portfolio companies covered by the target',
                  options:
                    EMISSIONS_SCOPES_OF_PORTFOLIO_COMPANIES_COVERED_BY_THE_TARGET_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_2_VALUE,
                    condition: conditionType.NOT,
                    values: ['Portfolio temperature rating target']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_2_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Portfolio temperature rating target'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_2_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_14_VALUE,
                  fieldLabel: '% of portfolio emissions covered by the target',
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_9_VALUE,
                    condition: conditionType.EMPTY,
                    values: []
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_9_VALUE,
                    condition: conditionType.EQUALS,
                    values: [],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_9_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_15_VALUE,
                  fieldLabel:
                    '% of asset class emissions covered by the target',
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_10_VALUE,
                    condition: conditionType.EMPTY,
                    values: []
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_10_VALUE,
                    condition: conditionType.EQUALS,
                    values: [],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_10_VALUE
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_16_VALUE,
                  fieldLabel: 'Metric (or target numerator if intensity)',
                  options: METRIC_OR_TARGET_NUMERATOR_IF_INTENSITY_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_12_VALUE,
                    condition: conditionType.NOT,
                    values: ['Intensity']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_12_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Intensity'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_12_VALUE
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_17_VALUE,
                  fieldLabel: 'Target denominator',
                  options: TARGET_DENOMINATOR_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_12_VALUE,
                    condition: conditionType.NOT,
                    values: ['Intensity']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_12_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Intensity'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_12_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_18_VALUE,
                  fieldLabel:
                    '% of portfolio covered in relation to total portfolio value',
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_8_VALUE,
                    condition: conditionType.EMPTY,
                    values: []
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_8_VALUE,
                    condition: conditionType.EQUALS,
                    values: [],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_8_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_19_VALUE,
                  fieldLabel: 'Total value of assets covered by the target',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_20_VALUE,
                  fieldLabel:
                    '% of asset class covered by the target, based on the total value of this asset class',
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_21_VALUE,
                  fieldLabel: 'Frequency of target reviews',
                  options: FREQUENCY_OF_TARGET_REVIEWS_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_22_VALUE,
                  fieldLabel: 'End date of base year',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_23_VALUE,
                  fieldLabel: 'Figure in base year',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_24_VALUE,
                  fieldLabel: 'We have an interim target',
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_25_VALUE,
                  fieldLabel: 'End date of interim target',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_26_VALUE,
                  fieldLabel: 'Figure in interim target year',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_25_VALUE,
                    condition: conditionType.EMPTY,
                    values: []
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_25_VALUE,
                    condition: conditionType.EQUALS,
                    values: [],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_25_VALUE
                  }
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_27_VALUE,
                  fieldLabel: 'End date of target',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_28_VALUE,
                  fieldLabel: 'Figure in target year',
                  colSpan: true,
                  roundTo: 3,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_27_VALUE,
                    condition: conditionType.EMPTY,
                    values: []
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_27_VALUE,
                    condition: conditionType.EQUALS,
                    values: [],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_27_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_29_VALUE,
                  fieldLabel: 'Figure in reporting year',
                  colSpan: true,
                  roundTo: 3
                },
                {
                  type: inputType.DISPLAY_CALCULATION_IN_TABLE,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_30_VALUE,
                  fieldLabel: '% of target achieved relative to base year',
                  relatedKey: [
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_23_VALUE,
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_29_VALUE,
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_28_VALUE
                  ],
                  formula: ([
                    FIGURE_IN_BASE_YEAR,
                    FIGURE_IN_TARGET_YEAR,
                    FIGURE_IN_REPORTING_YEAR
                  ]: any[]): number | string => {
                    const total =
                      ((FIGURE_IN_BASE_YEAR - FIGURE_IN_TARGET_YEAR) /
                        (FIGURE_IN_BASE_YEAR - FIGURE_IN_REPORTING_YEAR)) *
                      100;

                    return total;
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_31_VALUE,
                  fieldLabel: 'Target status in reporting year',
                  options: TARGET_STATUS_IN_REPORTING_YEAR_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_32_VALUE,
                  fieldLabel: 'Aggregation weighting used',
                  options: AGGREGATION_WEIGHTING_USED_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_2_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Portfolio coverage',
                      'Portfolio temperature rating target'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_2_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Portfolio coverage',
                      'Portfolio temperature rating target'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_2_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_33_VALUE,
                  fieldLabel:
                    '% of the temperature score calculated in the reporting year based on company targets',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_2_VALUE,
                    condition: conditionType.NOT,
                    values: ['Portfolio temperature rating target']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_2_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Portfolio temperature rating target'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_2_VALUE
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_34_VALUE,
                  fieldLabel: 'Is this a science-based target?',
                  options: SCIENCE_BASED_TARGET_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_8_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Banking (Bank)',
                      'Investing (Asset manager)',
                      'Investing (Asset owner)'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_8_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Banking (Bank)',
                      'Investing (Asset manager)',
                      'Investing (Asset owner)'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_8_VALUE
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_35_VALUE,
                  fieldLabel: 'Target ambition',
                  options: TARGET_AMBITION_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_34_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Yes, and this target has been approved by the Science Based Targets initiative',
                      'Yes, we consider this a science-based target, and the target is currently being reviewed by the Science Based Targets initiative',
                      'Yes, we consider this a science-based target, and we have committed to seek validation of this target by the Science Based Targets initiative in the next two years',
                      'Yes, we consider this a science-based target, but we have not committed to seek validation of this target by the Science Based Targets initiative within the next two years'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_34_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Yes, and this target has been approved by the Science Based Targets initiative',
                      'Yes, we consider this a science-based target, and the target is currently being reviewed by the Science Based Targets initiative',
                      'Yes, we consider this a science-based target, and we have committed to seek validation of this target by the Science Based Targets initiative in the next two years',
                      'Yes, we consider this a science-based target, but we have not committed to seek validation of this target by the Science Based Targets initiative within the next two years'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_34_VALUE
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_36_VALUE,
                  fieldLabel: 'Provide details of your target and metrics',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_2_VALUE,
                    condition: conditionType.NOT,
                    values: ['Adaptation and resilience target']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_2_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Adaptation and resilience target'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_2_VALUE
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_37_VALUE,
                  fieldLabel:
                    'Please explain target coverage and identify any exclusions',
                  colSpan: true,
                  textLimit: 2500
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q123_38_VALUE,
                  fieldLabel: 'Target objective',
                  colSpan: true,
                  textLimit: 1500
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.SELECT,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q124_VALUE,
            fieldLabel:
              '7.54 Did you have any other climate-related targets that were active in the reporting year?',
            tooltip:
              'Target setting plays a vital role in environmental action through its role in the successful execution of corporate strategies, as well as in the effective management of dependencies, impacts, risks, and opportunities. Emissions reduction targets are not the only type of relevant targets that organizations use to drive change, as other target types can be an important element of organizations’ strategies to reduce their emissions. This question increases transparency of corporate environmental commitments relevant to different organizations. ',
            heading: inputType.HEADING,
            options: [
              {
                value:
                  'Targets to increase or maintain low-carbon energy consumption or production',
                label:
                  'Targets to increase or maintain low-carbon energy consumption or production'
              },
              {
                value: 'Targets to reduce methane emissions',
                label: 'Targets to reduce methane emissions'
              },
              {value: 'Net-zero targets', label: 'Net-zero targets'},
              {
                value: 'Other climate-related targets',
                label: 'Other climate-related targets'
              },
              {
                value: 'No other climate-related targets  ',
                label: 'No other climate-related targets'
              }
            ],
            colSpan: true
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.54.1 Provide details of your targets to increase or maintain low-carbon energy consumption or production ',
            tooltip:
              'Target setting plays a vital role in environmental action through its role in the successful execution of corporate strategies, as well as in the effective management of dependencies, impacts, risks, and opportunities. Targets related to increasing or maintaining low-carbon energy consumption or production can be an important element of organizations’ strategies to reduce their emissions. ',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q124_VALUE,
              showWhen: [
                'Targets to increase or maintain low-carbon energy consumption or production'
              ],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q124_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q124_VALUE,
            showWhen: [
              'Targets to increase or maintain low-carbon energy consumption or production'
            ],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_1_VALUE,
                  fieldLabel: 'Target reference number',
                  options: LOW_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_2_VALUE,
                  fieldLabel: 'Date target was set',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_3_VALUE,
                  fieldLabel: 'Target coverage',
                  options: TARGET_COVERAGE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_4_VALUE,
                  fieldLabel: 'Target type: energy carrier',
                  options: TARGET_TYPE_ENERGY_CARRIER_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_5_VALUE,
                  fieldLabel: 'Target type: activity',
                  options: TARGET_TYPE_ACTIVITY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_6_VALUE,
                  fieldLabel: 'Target type: energy source',
                  options: TARGET_TYPE_ENERGY_SOURCE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_7_VALUE,
                  fieldLabel: 'End date of base year',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_8_VALUE,
                  fieldLabel:
                    'Consumption or production of selected energy carrier in base year (MWh)',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_9_VALUE,
                  fieldLabel:
                    '% share of low-carbon or renewable energy in base year',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_10_VALUE,
                  fieldLabel: 'End date of target',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_11_VALUE,
                  fieldLabel:
                    '% share of low-carbon or renewable energy at end date of target',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_12_VALUE,
                  fieldLabel:
                    '% share of low-carbon or renewable energy in reporting year',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.DISPLAY_CALCULATION_IN_TABLE,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_13_VALUE,
                  fieldLabel: '% of target achieved relative to base year',
                  colSpan: true,
                  roundTo: 2,
                  relatedKey: [
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_11_VALUE,
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_9_VALUE,
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_12_VALUE
                  ],
                  formula: ([colum11, column9, column12]: any[]):
                    | number
                    | string => {
                    const data1 = colum11 - column9;
                    const data2 = column12 - column9;
                    const total = (data1 / data2) * 100;

                    return total;
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_14_VALUE,
                  fieldLabel: 'Target status in reporting year',
                  options: TARGET_STATUS_IN_REPORTING_YEAR_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_15_VALUE,
                  fieldLabel:
                    'Explain the reasons for the revision, replacement, or retirement of the target',
                  colSpan: true,
                  textLimit: 2400,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_14_VALUE,
                    condition: conditionType.NOT,
                    values: ['Revised', 'Replaced', 'Retired']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_14_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Revised', 'Replaced', 'Retired'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_14_VALUE
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_16_VALUE,
                  fieldLabel: 'Is this target part of an emissions target?',
                  colSpan: true,
                  textLimit: 2400
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_17_VALUE,
                  fieldLabel:
                    'Is this target part of an overarching initiative?',
                  options: TARGET_IS_PART_OF_AN_OVERARCHING_INITIATIVE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.FILEUPLOAD,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_18_VALUE,
                  fieldLabel:
                    'Science Based Targets initiative official validation letter',
                  colSpan: true,
                  fileUploadAction:
                    API_ENDPOINT_JSON.ESG.CDP_CORPORATE.documentUpload
                      .climateChange,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_17_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Science Based Targets initiative']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_17_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Science Based Targets initiative'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_17_VALUE
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_19_VALUE,
                  fieldLabel:
                    'Explain target coverage and identify any exclusions',
                  colSpan: true,
                  textLimit: 2400
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_20_VALUE,
                  fieldLabel: 'Target objective',
                  colSpan: true,
                  textLimit: 1500
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_21_VALUE,
                  fieldLabel:
                    'Plan for achieving target, and progress made to the end of the reporting year',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_14_VALUE,
                    condition: conditionType.NOT,
                    values: ['Revised', 'Underway', 'New']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_14_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Revised', 'Underway', 'New'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_14_VALUE
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_22_VALUE,
                  fieldLabel:
                    'List the actions which contributed most to achieving this target',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_14_VALUE,
                    condition: conditionType.NOT,
                    values: ['Achieved', 'Achieved and maintained']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_14_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Achieved', 'Achieved and maintained'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q125_14_VALUE
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.54.2 Provide details of any other climate-related targets, including methane reduction targets.',
            tooltip:
              'Target setting plays a vital role in environmental action through its role in the successful execution of corporate strategies, as well as in the effective management of dependencies, impacts, risks, and opportunities. Emissions reduction targets are not the only type of relevant targets that organizations use to drive change.Other climate-related targets can be an important element of organizations’ strategy to reduce their emissions. This question increases transparency of corporate environmental commitments.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q124_VALUE,
              showWhen: ['Other climate-related targets'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q124_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q124_VALUE,
            showWhen: ['Other climate-related targets'],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_1_VALUE,
                  fieldLabel: 'Target reference number',
                  options: OTH_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_2_VALUE,
                  fieldLabel: 'Date target was set',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_3_VALUE,
                  fieldLabel: 'Target coverage',
                  options: TARGET_COVERAGE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_4_VALUE,
                  fieldLabel: 'Target type: absolute or intensity',
                  options: TARGET_TYPE_ABSOLUTE_OR_INTENSITY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_5_VALUE,
                  fieldLabel:
                    'Target type: category & metric (target numerator if reporting an intensity target)',
                  options: TARGET_TYPE_CATEGORY_METRIC_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_6_VALUE,
                  fieldLabel: 'Target denominator (intensity targets only)',
                  options: TARGET_DENOMINATOR_INTENSITY_TARGETS_ONLY_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_4_VALUE,
                    condition: conditionType.NOT,
                    values: ['Intensity']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_4_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Intensity'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_4_VALUE
                  }
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_7_VALUE,
                  fieldLabel: 'End date of base year',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_8_VALUE,
                  fieldLabel: 'Figure or percentage in base year',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_9_VALUE,
                  fieldLabel: 'End date of target',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_10_VALUE,
                  fieldLabel: 'Figure or percentage at end date of target',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_11_VALUE,
                  fieldLabel: 'Figure or percentage in reporting year',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_12_VALUE,
                  fieldLabel: '% of target achieved relative to base year',
                  colSpan: true,
                  relatedKey: [
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_10_VALUE,
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_8_VALUE,
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_11_VALUE
                  ],
                  formula: ([colum10, column8, column11]: any[]):
                    | number
                    | string => {
                    const data1 = colum10 - column8;
                    const data2 = column11 - column8;
                    const total = data1 / data2;

                    return total;
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_13_VALUE,
                  fieldLabel: 'Target status in reporting year',
                  options: TARGET_STATUS_IN_REPORTING_YEAR_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_14_VALUE,
                  fieldLabel:
                    'Explain the reasons for the revision, replacement, or retirement of the target',
                  colSpan: true,
                  textLimit: 2400,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_13_VALUE,
                    condition: conditionType.NOT,
                    values: ['Revised', 'Replaced', 'Retired']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_13_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Revised', 'Replaced', 'Retired'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_13_VALUE
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_15_VALUE,
                  fieldLabel: 'Is this target part of an emissions target?',
                  colSpan: true,
                  textLimit: 2400
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_16_VALUE,
                  fieldLabel:
                    'Is this target part of an overarching initiative?',
                  options:
                    TARGET_IS_PART_OF_AN_OVERARCHING_INITIATIVE_OPTIONS_2,
                  colSpan: true
                },
                {
                  type: inputType.FILEUPLOAD,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_17_VALUE,
                  fieldLabel:
                    'Science Based Targets initiative official validation letter',
                  colSpan: true,
                  fileUploadAction:
                    API_ENDPOINT_JSON.ESG.CDP_CORPORATE.documentUpload
                      .climateChange,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_16_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: [
                      'Science Based Targets initiative - approved supplier engagement target',
                      'Science Based Targets initiative - approved customer engagement target',
                      'Science Based Targets initiative - approved other'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_16_VALUE,
                    condition: conditionType.INCLUDES,
                    values: [
                      'Science Based Targets initiative - approved supplier engagement target',
                      'Science Based Targets initiative - approved customer engagement target',
                      'Science Based Targets initiative - approved other'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_16_VALUE
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_18_VALUE,
                  fieldLabel:
                    'Please explain target coverage and identify any exclusions',
                  colSpan: true,
                  textLimit: 2400
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_19_VALUE,
                  fieldLabel: 'Target objective',
                  colSpan: true,
                  textLimit: 1500
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_20_VALUE,
                  fieldLabel:
                    'Plan for achieving target, and progress made to the end of the reporting year',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_13_VALUE,
                    condition: conditionType.NOT,
                    values: ['Revised', 'Underway', 'New']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_13_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Revised', 'Underway', 'New'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_13_VALUE
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_21_VALUE,
                  fieldLabel:
                    'List the actions which contributed most to achieving this target',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_13_VALUE,
                    condition: conditionType.NOT,
                    values: ['Achieved', 'Achieved and maintained']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_13_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Achieved', 'Achieved and maintained'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q126_13_VALUE
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading: '7.54.3 Provide details of your net-zero target(s).',
            tooltip: `Reaching net-zero emissions at the global level is a central goal of the climate action movement. Corporate net-zero targets are a powerful opportunity for organizations to reduce their emissions along a 1.5C aligned pathway and counterbalance any residual emissions at target year with permanent carbon removals (i.e. neutralization). By setting net-zero targets, companies can also accelerate climate action outside their
                      value chains and contribute to reaching the global net-zero goal. This question provides data users with transparency on your organization’s commitment to achieving net-zero
                      emissions.`,
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q124_VALUE,
              showWhen: ['Net-zero targets'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q124_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q124_VALUE,
            showWhen: ['Net-zero targets'],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_1_VALUE,
                  fieldLabel: 'Target reference number',
                  options: NZ_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_2_VALUE,
                  fieldLabel: 'End date of target',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_3_VALUE,
                  fieldLabel: 'Target Coverage',
                  options: TARGET_COVERAGE_OPTIONS_2,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_4_VALUE,
                  fieldLabel: 'Targets linked to this net zero target',
                  options: TARGETS_LINKED_TO_THIS_NET_ZERO_TARGET_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_5_VALUE,
                  fieldLabel: 'End date of base year',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_6_VALUE,
                  fieldLabel: 'Is this a science-based target?',
                  options: SCIENCE_BASED_TARGET_OPTIONS_2,
                  colSpan: true
                },
                {
                  type: inputType.FILEUPLOAD,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_7_VALUE,
                  fieldLabel:
                    'Science Based Targets initiative official validation letter',
                  colSpan: true,
                  fileUploadAction:
                    API_ENDPOINT_JSON.ESG.CDP_CORPORATE.documentUpload
                      .climateChange,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_6_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Yes, and this target has been approved by the Science Based Targets initiative'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_6_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Yes, and this target has been approved by the Science Based Targets initiative'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_6_VALUE
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_8_VALUE,
                  fieldLabel: 'Scopes',
                  options: SCOPES_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_9_VALUE,
                  fieldLabel: 'Greenhouse gases covered by target',
                  options: GREENHOUSE_GAS_COVERED_BY_TARGET_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_10_VALUE,
                  fieldLabel:
                    'Explain target coverage and identify any exclusions',
                  colSpan: true,
                  textLimit: 2400
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_11_VALUE,
                  fieldLabel: 'Target objective',
                  colSpan: true,
                  textLimit: 2400
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_12_VALUE,
                  fieldLabel:
                    'Do you intend to neutralize any residual emissions with permanent carbon removals at the end of the target?',
                  options: [
                    {value: 'Yes', label: 'Yes'},
                    {value: 'No', label: 'No'},
                    {value: 'Unsure', label: 'Unsure'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_13_VALUE,
                  fieldLabel:
                    'Do you plan to mitigate emissions beyond your value chain?',
                  options:
                    PLAN_TO_MITIGATE_EMISSIONS_BEYOND_VALUE_CHAIN_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_14_VALUE,
                  fieldLabel:
                    'Do you intend to purchase and cancel carbon credits for neutralization and/or beyond value chain mitigation?',
                  options:
                    PLAN_TO_PURCHASE_AND_CANCEL_CARBON_CREDITS_FOR_NEUTRALIZATION_AND_OR_BEYOND_VALUE_CHAIN_MITIGATION_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_12_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_12_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Yes'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_12_VALUE
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_15_VALUE,
                  fieldLabel:
                    'Planned milestones and/or near-term investments for neutralization at the end of the target',
                  colSpan: true,
                  textLimit: 2400,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_12_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_12_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Yes'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_12_VALUE
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_16_VALUE,
                  fieldLabel:
                    'Describe the actions to mitigate emissions beyond your value chain',
                  colSpan: true,
                  textLimit: 2400
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_17_VALUE,
                  fieldLabel: 'Target status in reporting year',
                  options: TARGET_STATUS_IN_REPORTING_YEAR_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_18_VALUE,
                  fieldLabel:
                    'Explain the reasons for the revision, retirement, or replacement of the target',
                  colSpan: true,
                  textLimit: 2400,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_17_VALUE,
                    condition: conditionType.NOT,
                    values: ['Revised', 'Replaced', 'Retired']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_17_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Revised', 'Replaced', 'Retired'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_17_VALUE
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q127_19_VALUE,
                  fieldLabel: 'Process for reviewing target',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.WYSIWYG,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q128_VALUE,
            fieldLabel:
              '7.54.4 Indicate which targets reported in 7.53.1/2 incorporate methane emissions, or if you do not have a methane-specific emissions reduction target for your oil and gas activities, please explain why not and forecast how your methane emissions will change over the next five years.',
            tooltip:
              'Methane emissions from the oil and gas sector are increasingly viewed as a financial, regulatory, and reputational issue for companies. Investors are therefore interested in increasing the transparency of methane reduction efforts. This can be achieved by organizations reporting the methane targets they have in place and how they forecast that their methane emissions will change.',
            heading: inputType.HEADING,
            colSpan: true,
            textLimit: 5000
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.WYSIWYG,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q129_VALUE,
            fieldLabel:
              '7.54.5 Indicate which targets reported in 7.53.1/2 incorporate methane emissions, or if you do not have a methane-specific emissions reduction target for your coal mining activities, please explain why not and forecast how your methane emissions will change over the next five years.',
            tooltip:
              'Methane emissions from the coal sector are increasingly viewed as a financial, regulatory, and reputational issue for companies. Investors are therefore interested in increasing the transparency of methane reduction efforts which can be achieved by organizations reporting the methane targets they have in place and how they forecast that their methane emissions will change.',
            heading: inputType.HEADING,
            colSpan: true,
            textLimit: 5000
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.RADIOGROUP,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q130_VALUE,
            fieldLabel:
              '7.55 Did you have emissions reduction initiatives that were active within the reporting year? Note that this can include those in the planning and/or implementation phases.',
            tooltip:
              'The answer to this question enables CDP data users to understand your organization’s commitment to reducing emissions beyond business-as-usual scenario (beyond standard maintenance/replacement activities).',
            heading: inputType.HEADING,
            options: ['Yes', 'No'],
            colSpan: true
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.55.1 Identify the total number of initiatives at each stage of development, and for those in the',
            tooltip:
              'This question only appears if you select “Yes” in response to 7.55.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q130_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q130_VALUE
            }
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q131_VALUE,
            scopeColumnTitle: 'Stage of development',
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q130_VALUE,
            showWhen: ['Yes'],
            fixedRows: [
              {
                id: 'stage1',
                label: 'Under investigation'
              },
              {
                id: 'stage2',
                label: 'To be implemented'
              },
              {
                id: 'stage3',
                label: 'Implementation commenced'
              },
              {
                id: 'stage4',
                label: 'Implemented'
              },
              {
                id: 'stage5',
                label: 'Not to be implemented'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q131_1_VALUE,
                  fieldLabel: 'Number of initiatives',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q131_2_VALUE,
                  fieldLabel:
                    'Total estimated annual CO2e savings (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 2
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.55.2 Identify the total number of initiatives at each stage of development, and for those in the ',
            tooltip:
              'This question only appears if you select “Yes” in response to 7.55.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q130_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q130_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q132_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q130_VALUE,
            showWhen: ['Yes'],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q132_1_VALUE,
                  fieldLabel: 'Initiative category & Initiative type',
                  options: INITIATIVE_CATEGORY_AND_INITIATIVE_TYPE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q132_2_VALUE,
                  fieldLabel:
                    'Estimated annual CO2e savings (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q132_3_VALUE,
                  fieldLabel:
                    'Scope(s) or Scope 3 category(ies) where emissions savings occur',
                  options: SCOPES_COVERED_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q132_4_VALUE,
                  fieldLabel: 'Voluntary/Mandatory',
                  options: [
                    {value: 'Voluntary', label: 'Voluntary'},
                    {value: 'Mandatory', label: 'Mandatory'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q132_5_VALUE,
                  fieldLabel:
                    'Annual monetary savings (unit currency – as specified in 1.2)',
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q132_6_VALUE,
                  fieldLabel:
                    'Investment required (unit currency – as specified in 1.2)',
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q132_7_VALUE,
                  fieldLabel: 'Payback period',
                  options: PAYBACK_PERIOD_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q132_8_VALUE,
                  fieldLabel: 'Estimated lifetime of the initiative',
                  options: OTHER_INITIATIVE_LIFETIME_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q132_9_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 1500
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.55.3 What methods do you use to drive investment in emissions reduction activities?',
            tooltip:
              'This question provides data users with more transparency into your organization’s approach to realizing emissions reductions and progress towards targets.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q130_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q130_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q133_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q130_VALUE,
            showWhen: ['Yes'],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q133_1_VALUE,
                  fieldLabel: 'Method',
                  options: METHOD_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q133_2_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.WYSIWYG,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q134_VALUE,
            fieldLabel:
              '7.55.4 Why did you not have any emissions reduction initiatives active during the reporting year?',
            tooltip:
              'Emissions reduction initiatives are crucial to meeting emissions targets and reducing negative environmental impacts. CDP data users need to know why you do not engage in the best practice of actively reducing your emissions',
            heading: inputType.HEADING,
            colSpan: true,
            textLimit: 5000
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.56 Describe any planned climate-related projects within your public authority for which you hope to attract financing.',
            tooltip:
              'Data users are interested in learning about your organization’s plans for climate resilient, sustainable, and equitable infrastructure projects. Your response to this question will allow CDP data users to see, in one place, details of resilient infrastructure projects for which you are seeking funding and/or financing to enhance partnership and resource allocation, and connect eligible projects to technical assistance, where possible.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_1_VALUE,
                  fieldLabel: 'Project area',
                  options: PROJECT_AREA_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_2_VALUE,
                  fieldLabel: 'Project title',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_1_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Buildings',
                      'Energy efficiency (including public lighting)',
                      'Renewable energy',
                      'Transport',
                      'Waste management (including waste recycling)',
                      'Water management',
                      'Sustainable food consumption/production',
                      'Land-Use',
                      'Nature-Based Solutions',
                      'Public and green spaces',
                      'Landscape and Jurisdictional Approaches',
                      'Jurisdictional REDD+ Program',
                      'Other, please specify',
                      'Health systems and services'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_1_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Buildings',
                      'Energy efficiency (including public lighting)',
                      'Renewable energy',
                      'Transport',
                      'Waste management (including waste recycling)',
                      'Water management',
                      'Sustainable food consumption/production',
                      'Land-Use',
                      'Nature-Based Solutions',
                      'Public and green spaces',
                      'Landscape and Jurisdictional Approaches',
                      'Jurisdictional REDD+ Program',
                      'Other, please specify'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_1_VALUE
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_3_VALUE,
                  fieldLabel: 'Stage of project development',
                  options: STAGE_OF_PROJECT_DEVELOPMENT_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_1_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Buildings',
                      'Energy efficiency (including public lighting)',
                      'Renewable energy',
                      'Transport',
                      'Waste management (including waste recycling)',
                      'Water management',
                      'Sustainable food consumption/production',
                      'Land-Use',
                      'Nature-Based Solutions',
                      'Public and green spaces',
                      'Landscape and Jurisdictional Approaches',
                      'Jurisdictional REDD+ Program',
                      'Other, please specify',
                      'Health systems and services'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_1_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Buildings',
                      'Energy efficiency (including public lighting)',
                      'Renewable energy',
                      'Transport',
                      'Waste management (including waste recycling)',
                      'Water management',
                      'Sustainable food consumption/production',
                      'Land-Use',
                      'Nature-Based Solutions',
                      'Public and green spaces',
                      'Landscape and Jurisdictional Approaches',
                      'Jurisdictional REDD+ Program',
                      'Other, please specify'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_1_VALUE
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_4_VALUE,
                  fieldLabel: 'Status of financing',
                  options: STATUS_OF_FINANCING_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_1_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Buildings',
                      'Energy efficiency (including public lighting)',
                      'Renewable energy',
                      'Transport',
                      'Waste management (including waste recycling)',
                      'Water management',
                      'Sustainable food consumption/production',
                      'Land-Use',
                      'Nature-Based Solutions',
                      'Public and green spaces',
                      'Landscape and Jurisdictional Approaches',
                      'Jurisdictional REDD+ Program',
                      'Other, please specify',
                      'Health systems and services'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_1_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Buildings',
                      'Energy efficiency (including public lighting)',
                      'Renewable energy',
                      'Transport',
                      'Waste management (including waste recycling)',
                      'Water management',
                      'Sustainable food consumption/production',
                      'Land-Use',
                      'Nature-Based Solutions',
                      'Public and green spaces',
                      'Landscape and Jurisdictional Approaches',
                      'Jurisdictional REDD+ Program',
                      'Other, please specify'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_1_VALUE
                  }
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_5_VALUE,
                  fieldLabel: 'Identified financing model',
                  options: IDENTIFIED_FINANCING_MODEL_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_1_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Buildings',
                      'Energy efficiency (including public lighting)',
                      'Renewable energy',
                      'Transport',
                      'Waste management (including waste recycling)',
                      'Water management',
                      'Sustainable food consumption/production',
                      'Land-Use',
                      'Nature-Based Solutions',
                      'Public and green spaces',
                      'Landscape and Jurisdictional Approaches',
                      'Jurisdictional REDD+ Program',
                      'Other, please specify',
                      'Health systems and services'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_1_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Buildings',
                      'Energy efficiency (including public lighting)',
                      'Renewable energy',
                      'Transport',
                      'Waste management (including waste recycling)',
                      'Water management',
                      'Sustainable food consumption/production',
                      'Land-Use',
                      'Nature-Based Solutions',
                      'Public and green spaces',
                      'Landscape and Jurisdictional Approaches',
                      'Jurisdictional REDD+ Program',
                      'Other, please specify'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_1_VALUE
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_6_VALUE,
                  fieldLabel:
                    'Project description and URL link (if applicable)',
                  colSpan: true,
                  textLimit: 5000,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_1_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Buildings',
                      'Energy efficiency (including public lighting)',
                      'Renewable energy',
                      'Transport',
                      'Waste management (including waste recycling)',
                      'Water management',
                      'Sustainable food consumption/production',
                      'Land-Use',
                      'Nature-Based Solutions',
                      'Public and green spaces',
                      'Landscape and Jurisdictional Approaches',
                      'Jurisdictional REDD+ Program',
                      'Other, please specify',
                      'Health systems and services'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_1_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Buildings',
                      'Energy efficiency (including public lighting)',
                      'Renewable energy',
                      'Transport',
                      'Waste management (including waste recycling)',
                      'Water management',
                      'Sustainable food consumption/production',
                      'Land-Use',
                      'Nature-Based Solutions',
                      'Public and green spaces',
                      'Landscape and Jurisdictional Approaches',
                      'Jurisdictional REDD+ Program',
                      'Other, please specify'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_1_VALUE
                  }
                },
                {
                  type: inputType.FILEUPLOAD,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_7_VALUE,
                  fieldLabel: 'Attach project proposal (if applicable)',
                  colSpan: true,
                  fileUploadAction:
                    API_ENDPOINT_JSON.ESG.CDP_CORPORATE.documentUpload
                      .climateChange,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_1_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Buildings',
                      'Energy efficiency (including public lighting)',
                      'Renewable energy',
                      'Transport',
                      'Waste management (including waste recycling)',
                      'Water management',
                      'Sustainable food consumption/production',
                      'Land-Use',
                      'Nature-Based Solutions',
                      'Public and green spaces',
                      'Landscape and Jurisdictional Approaches',
                      'Jurisdictional REDD+ Program',
                      'Other, please specify',
                      'Health systems and services'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_1_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Buildings',
                      'Energy efficiency (including public lighting)',
                      'Renewable energy',
                      'Transport',
                      'Waste management (including waste recycling)',
                      'Water management',
                      'Sustainable food consumption/production',
                      'Land-Use',
                      'Nature-Based Solutions',
                      'Public and green spaces',
                      'Landscape and Jurisdictional Approaches',
                      'Jurisdictional REDD+ Program',
                      'Other, please specify'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_1_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_8_VALUE,
                  fieldLabel: 'Total cost of project',
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_1_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Buildings',
                      'Energy efficiency (including public lighting)',
                      'Renewable energy',
                      'Transport',
                      'Waste management (including waste recycling)',
                      'Water management',
                      'Sustainable food consumption/production',
                      'Land-Use',
                      'Nature-Based Solutions',
                      'Public and green spaces',
                      'Landscape and Jurisdictional Approaches',
                      'Jurisdictional REDD+ Program',
                      'Other, please specify',
                      'Health systems and services'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_1_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Buildings',
                      'Energy efficiency (including public lighting)',
                      'Renewable energy',
                      'Transport',
                      'Waste management (including waste recycling)',
                      'Water management',
                      'Sustainable food consumption/production',
                      'Land-Use',
                      'Nature-Based Solutions',
                      'Public and green spaces',
                      'Landscape and Jurisdictional Approaches',
                      'Jurisdictional REDD+ Program',
                      'Other, please specify'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_1_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_9_VALUE,
                  fieldLabel: 'Total investment cost needed (if relevant)',
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_1_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Buildings',
                      'Energy efficiency (including public lighting)',
                      'Renewable energy',
                      'Transport',
                      'Waste management (including waste recycling)',
                      'Water management',
                      'Sustainable food consumption/production',
                      'Land-Use',
                      'Nature-Based Solutions',
                      'Public and green spaces',
                      'Landscape and Jurisdictional Approaches',
                      'Jurisdictional REDD+ Program',
                      'Other, please specify',
                      'Health systems and services'
                    ]
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_1_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Buildings',
                      'Energy efficiency (including public lighting)',
                      'Renewable energy',
                      'Transport',
                      'Waste management (including waste recycling)',
                      'Water management',
                      'Sustainable food consumption/production',
                      'Land-Use',
                      'Nature-Based Solutions',
                      'Public and green spaces',
                      'Landscape and Jurisdictional Approaches',
                      'Jurisdictional REDD+ Program',
                      'Other, please specify'
                    ],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q135_1_VALUE
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.WYSIWYG,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q136_VALUE,
            fieldLabel:
              '7.57 Describe your organization’s efforts to reduce methane emissions from your activities.',
            tooltip:
              'Methane emissions represent significant direct emissions from oil and gas activities. Disclosing relevant information relating to your organization’s efforts to reduce methane emissions from your oil and gas activities can reduce the financial and reputational risk facing investors. Investors and other data users are interested in learning about methane reduction projects and collaborative initiatives',
            heading: inputType.HEADING,
            colSpan: true,
            textLimit: 5000
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.WYSIWYG,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q137_VALUE,
            fieldLabel:
              '7.58 Describe your organization’s efforts to reduce methane emissions from your activities.',
            tooltip:
              'This question only appears if you select “Electricity generation”, “Gas storage, transmission and distribution”, “Coal mining” and/or “Gas extraction and production” in response to 1.16. No change Disclosing relevant information on your organization’s efforts to reduce methane emissions relating to your activities can reduce the financial and reputational risk facing companies and investors. Investors and other data users are interested in learning about methane reduction targets, projects and collaborative initiatives that companies have in place.',
            heading: inputType.HEADING,
            colSpan: true,
            textLimit: 5000
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.WYSIWYG,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q138_VALUE,
            fieldLabel:
              '7.59 Describe your organization’s efforts to reduce methane emissions from your activities.',
            tooltip:
              'Disclosing relevant information relating to your organization’s efforts to reduce methane emissions from your coal mining activities can reduce the financial and reputational risk facing investors. Significant uncertainty exists in quantifying coal organization’s contributions to methane emissions and their efforts to reduce methane emissions, with investors and data users interested in learning about methane reduction projects and collaborative initiatives.',
            heading: inputType.HEADING,
            colSpan: true,
            textLimit: 5000
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.SELECT,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q139_VALUE,
            fieldLabel:
              '7.60 Does your organization conduct leak detection and repair (LDAR) or use other methods to find and fix fugitive methane emissions from coal mining activities?',
            tooltip:
              'Investors are interested in how organizations approach methane leak detection and repair (LDAR), or other methane leak detection methods, in order to gauge how effectively methane emissions are being reduced.',
            heading: inputType.HEADING,
            colSpan: true,
            options: [
              {value: 'Yes', label: 'Yes'},
              {
                value: 'No we do not have a program in place ',
                label: 'No we do not have a program in place '
              },
              {
                value: ' No this is not relevant to our operations',
                label: ' No this is not relevant to our operations'
              }
            ]
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.WYSIWYG,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q140_VALUE,
            fieldLabel:
              '7.60.1 Describe the protocol through which methane leak detection and repair or other methane leak detection methods are conducted for your coal mining activities, including predominant frequency of inspections, estimates of assets covered, and methodologies employed.',
            tooltip:
              'Investors are interested in how organizations approach methane leak detection and repair (LDAR), or other methane leak detection methods, in order to gauge how effectively methane emissions are being reduced. This question provides information to data users with further information on the methods used to detect methane leaks. ',
            heading: inputType.HEADING,
            colSpan: true,
            textLimit: 5000
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.WYSIWYG,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q141_VALUE,
            fieldLabel:
              '7.60.2 Explain why not and whether you plan to conduct methane leak detection and repair or adopt other methods to find and fix fugitive methane emissions, and whether you have a plan to do so from your coal mining activities.',
            tooltip:
              'For many reasons, organizations with coal production activities may not have a program in place to reduce methane emissions using LDAR. This question is developed to provide investors with information on why organizations with coal activities do not have an LDAR program in place.',
            heading: inputType.HEADING,
            colSpan: true,
            textLimit: 5000
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.SELECT,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q142_VALUE,
            fieldLabel:
              '7.61 Does your organization conduct leak detection and repair (LDAR) or use other methods to find and fix fugitive methane emissions from oil and gas production activities?',
            tooltip:
              'Investors are interested to understand how companies approach methane leak detection and repair (LDAR) or other methane leak detection methods, in order to gauge how effectively methane emissions are being reduced.',
            heading: inputType.HEADING,
            colSpan: true,
            options: [
              {value: 'Yes', label: 'Yes'},
              {
                value: 'No we do not have a program in place ',
                label: 'No we do not have a program in place '
              },
              {
                value: ' No this is not relevant to our operations',
                label: ' No this is not relevant to our operations'
              }
            ]
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.WYSIWYG,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q143_VALUE,
            fieldLabel:
              '7.61.1 Describe the protocol through which methane leak detection and repair or other leak detection methods, are conducted for oil and gas production activities, including predominant frequency of inspections, estimates of assets covered, and methodologies employed.',
            tooltip:
              'Investors are interested to understand how companies approach methane leak detection and repair (LDAR) or other methane leak detection methods, in order to gauge how effectively methane emissions are being reduced.',
            heading: inputType.HEADING,
            colSpan: true,
            textLimit: 5000
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.WYSIWYG,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q144_VALUE,
            fieldLabel:
              '7.61.2 Explain why you do not conduct LDAR or use other methods to find and fix fugitive methane emissions, and whether you have a plan to do so from your oil and gas production activities.',
            tooltip:
              'It may be the case that an organization with oil and gas production activities does not have a program in place to reduce methane emissions using LDAR. This question is developed to provide investors with information on why organizations with oil and gas activities do not have an LDAR program in place.',
            heading: inputType.HEADING,
            colSpan: true,
            textLimit: 5000
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.WYSIWYG,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q145_VALUE,
            fieldLabel:
              '7.62.1 Describe your organization’s efforts to reduce flaring, including any flaring reduction targets.',
            tooltip:
              '"Flaring of gas contributes to climate change and impacts the environment through emissions of CO2 and other pollutants while wasting a valuable energy resource, hence investors are interested in learning about organization’s efforts to reduce flaring."',
            heading: inputType.HEADING,
            colSpan: true,
            textLimit: 5000
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.WYSIWYG,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q146_VALUE,
            fieldLabel:
              '7.63 If flaring is relevant to your coal mining operations, describe your organization’s efforts to reduce flaring, including any flaring reduction targets.',
            tooltip:
              'Flaring of gas contributes to climate change and impacts the environment through emissions of CO2 and other pollutants while wasting a valuable energy resource, hence investors are interested in learning about organizations’ efforts to reduce flaring.',
            heading: inputType.HEADING,
            colSpan: true,
            textLimit: 5000
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.64 Disclose your organization’s best available techniques as a percentage of Portland cement clinker production capacity.',
            tooltip:
              'The purpose of this question is to achieve a reasonable indication of the level of adoption of Best Available Techniques (BAT) in the sector. CDP recognizes that this should not be taken as a proxy for overall efficiency and productivity in an organization. Nonetheless, this information is useful in understanding the general adoption status of BAT in the organization and across the sector.',
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q147_VALUE
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q147_VALUE,
            scopeColumnTitle: 'Technique',
            fixedRows: [
              {
                id: 'technique1',
                label: '4+ cyclone preheating'
              },
              {
                id: 'technique2',
                label: 'Pre-calciner'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q147_1_VALUE,
                  fieldLabel: 'Total production capacity coverage (%)',
                  colSpan: true,
                  roundTo: 2
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.65 Disclose your organization’s best available techniques as a percentage of total plant capacity.',
            tooltip:
              'The purpose of this question is to achieve a reasonable indication of the level of adoption of Best Available Techniques (BAT) in the sector. CDP recognizes that this should not be taken as a proxy for overall efficiency and productivity in an organization. Furthermore, the adoption of some technologies is dependent on various site or market conditions, which is why we provide the opportunity for explanation. Nonetheless, this information is useful in understanding the general landscape and adoption status of BAT in the organization and across the sector, and the reasons behind their limitations.',
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q148_VALUE
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q148_VALUE,
            scopeColumnTitle: 'Technique/Process',
            fixedRows: [
              {
                id: 'technique1',
                label: 'Coke oven: Coke dry quenching'
              },
              {
                id: 'technique2',
                label: 'Coke oven: Coal moisture control process'
              },
              {
                id: 'technique3',
                label: 'Coke oven: Programmed heating'
              },
              {
                id: 'technique4',
                label:
                  'Sinter plant: Sinter cooler exhaust gas waste heat recovery'
              },
              {
                id: 'technique5',
                label: 'Sinter plant: Sinter strand waste-gas recycling'
              },
              {
                id: 'technique6',
                label: 'Sinter plant: Use of waste fuels in sinter mixture'
              },
              {
                id: 'technique7',
                label:
                  'Blast furnace: Injection of pulverized coal, biomass or wastes'
              },
              {
                id: 'technique8',
                label: 'Blast furnace: Top recovery turbine'
              },
              {
                id: 'technique9',
                label:
                  'Blast furnace: Recuperator (air preheating) hot-blast stoves'
              },
              {
                id: 'technique10',
                label:
                  'Blast furnace: Computer aided control system for hot-blast stoves'
              },
              {
                id: 'technique11',
                label: 'Blast furnace: Slag granulation for cement industry'
              },
              {
                id: 'technique12',
                label:
                  'Basic oxygen furnace: BOF gas and sensible heat recovery'
              },
              {
                id: 'technique13',
                label: 'Basic oxygen furnace: Vessel bottom stirring'
              },
              {
                id: 'technique14',
                label: 'Basic oxygen furnace: Programmed and preheated ladles'
              },
              {
                id: 'technique15',
                label: 'Electric arc furnace: Scrap preheating'
              },
              {
                id: 'technique16',
                label: 'Electric arc furnace: Oxy-fuel burners'
              },
              {
                id: 'technique17',
                label:
                  'Electric arc furnace: Oxygen blowing for liquid steel oxidation or post combustion'
              },
              {
                id: 'technique18',
                label:
                  'Electric arc furnace: Integrated, real-time process control and monitoring systems'
              },
              {
                id: 'technique19',
                label:
                  'Casting: Absence of soaking pits and primary rolling of ingots'
              },
              {
                id: 'technique20',
                label:
                  'Casting: Near net shape casting, e.g. thin slab, thin strip, etc.'
              },
              {
                id: 'technique21',
                label: 'Hot rolling mill: Hot charging'
              },
              {
                id: 'technique22',
                label: 'Hot rolling mill: Recuperative/regenerative burners'
              },
              {
                id: 'technique23',
                label: 'Hot rolling mill: Walking beam furnace'
              },
              {
                id: 'technique24',
                label:
                  'Hot rolling mill: Variable speed drives on combustion air fans of reheat furnace'
              },
              {
                id: 'technique25',
                label:
                  'Integrated steel mill: Combined heat and power/cogeneration plant'
              },
              {
                id: 'technique26',
                label:
                  'Integrated steel mill: Energy monitoring and management system'
              },
              {
                id: 'technique27',
                label: 'Other'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q148_1_VALUE,
                  fieldLabel: '% of total plant capacity',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q148_2_VALUE,
                  fieldLabel: 'Primary reason for not having technique',
                  options: PRIMARY_REASON_FOR_NOT_HAVING_TECHNIQUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q148_3_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.RADIOGROUP,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q149_VALUE,
            fieldLabel:
              '7.66 Is your organization involved in the sequestration of CO2?',
            tooltip:
              'Carbon capture and storage/utilization (CCS/U) is often presented as one of the key technologies in tackling climate change, to the point where in the majority of climate models, CCS/U is critical to meeting decarbonization goals set by the Paris Agreement to limit global warming to well below 2 degrees by 2100.',
            heading: inputType.HEADING,
            colSpan: true,
            options: ['Yes', 'No']
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.66.1 Provide, in metric tons CO2, gross masses of CO2 transferred in and out of the reporting organization',
            tooltip:
              'CCS/U is beginning to be demonstrated across the world on a variety of sources and scales. Investors and data users are interested in CO2 transfers in and out of the organization to make useful comparisons of CCS/U projects. ',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q149_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q149_VALUE
            }
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q150_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q149_VALUE,
            showWhen: ['Yes'],
            scopeColumnTitle: 'Transfer direction',
            fixedRows: [
              {
                id: 'transferDirection1',
                label: 'CO2 transferred in'
              },
              {
                id: 'transferDirection2',
                label: 'CO2 transferred out'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q150_1_VALUE,
                  fieldLabel:
                    'CO2 transferred in the reporting year (metric tons CO2)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q150_2_VALUE,
                  fieldLabel: 'Types of CO2 transfer',
                  options: TYPES_OF_CO2_TRANSFER_OPTIONS,
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.66.2 Provide gross masses of CO2 injected and stored for the purposes of CCS during the reporting year according to the injection and storage pathway.',
            tooltip:
              'There is an increasing investor recognition that CCS/U is one of the very few ways of reducing emissions in energy-intensive industries. Understanding the quantity of CO2 injected by pathway and the expected percentage of this that is intended for long term storage provides investors with insight into the emission reduction potential of organizations CCS/U projects. ',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q149_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q149_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q151_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q149_VALUE,
            showWhen: ['Yes'],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q151_1_VALUE,
                  fieldLabel: 'Injection and storage pathway',
                  options: INJECTION_AND_STORAGE_PATHWAY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q151_2_VALUE,
                  fieldLabel:
                    'Injected CO2 in the reporting year (metric tons CO2)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q151_3_VALUE,
                  fieldLabel:
                    'Percentage of injected CO2 intended for long-term (>10,000 year) storage',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q151_4_VALUE,
                  fieldLabel:
                    'CO2 leakage in the reporting year during injection (metric tons CO2)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q151_5_VALUE,
                  fieldLabel: 'Year in which injection began',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q151_6_VALUE,
                  fieldLabel:
                    'Cumulative CO2 injected and stored (metric tons CO2)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q151_7_VALUE,
                  fieldLabel:
                    'Ongoing leakage (average estimated % of stored CO2 per year)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q151_8_VALUE,
                  fieldLabel:
                    'Describe your process for monitoring leakage and any long-term storage of the CO2',
                  colSpan: true,
                  textLimit: 2500
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.WYSIWYG,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q152_VALUE,
            fieldLabel:
              '7.66.3 Provide clarification on any other relevant information pertaining to your activities related to transfer and sequestration of CO2.',
            tooltip:
              'Investors are looking to invest in a range of companies that have developed and utilized innovative and commercially viable CCS/U technologies. This question is designed to capture additional relevant information relating to the transfer and sequestration of CO2. It requests information on the consolidation basis used to report transfers and sequestration of CO2 emissions, who owns the transferred emissions and the risk management processes in place.',
            heading: inputType.HEADING,
            colSpan: true,
            textLimit: 5000
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.SELECT,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q153_VALUE,
            fieldLabel:
              '7.67 Do you implement agriculture or forest management practices on your own land with a climate',
            tooltip:
              'This question gathers information on any management practices implemented in your farm or production unit with climate change benefits. This information is important for data users because it demonstrates that your organization is acting on either preventing, reducing, controlling, and/or adapting to the effects of climate change.',
            heading: inputType.HEADING,
            colSpan: true,
            options: [
              {value: 'Yes', label: 'Yes'},
              {
                value: 'No',
                label: 'No'
              },
              {
                value: 'Dont know',
                label: 'Dont know'
              }
            ]
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.67.1 Specify the agricultural or forest management practice(s) implemented on your own land with climate change mitigation and/or adaptation benefits and provide a corresponding emissions figure, if known.',
            tooltip:
              'This question elicits specific and detailed information about the land management practices adopted by your organization. This information provides data users with an indication of how committed you are to mitigating and adapting to the effects of climate change. Demonstrating an understanding of climate-related benefits related to agricultural/forestry practices is best practice in this sector.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q153_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q153_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q154_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q153_VALUE,
            showWhen: ['Yes'],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q154_1_VALUE,
                  fieldLabel: 'Management practice reference number',
                  options: MP_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q154_2_VALUE,
                  fieldLabel: 'Management practice',
                  options: MANAGEMENT_PRACTICE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q154_3_VALUE,
                  fieldLabel: 'Description of management practice',
                  colSpan: true,
                  textLimit: 2400
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q154_4_VALUE,
                  fieldLabel: 'Primary climate change-related benefit',
                  options: PRIMARY_CLIMATE_CHANGE_RELATED_BENEFIT_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q154_5_VALUE,
                  fieldLabel: 'Estimated CO2e savings (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q154_6_VALUE,
                  fieldLabel: 'Please explain',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.RADIOGROUP,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q155_VALUE,
            fieldLabel:
              '7.68 Do you encourage your suppliers to undertake any agricultural or forest management practices with climate change mitigation and/or adaptation benefits?',
            tooltip:
              'This question gathers information on whether you encourage your suppliers to undertake any management practice with climate change benefits. This demonstrates to data users that your organization is acting on either preventing, reducing, controlling, and/or adapting to the effects of climate change in its supply chain. By encouraging your suppliers to adopt such management practices on their land, you promote awareness of sustainable production practices and ultimately contribute to reducing climate-related risks in your supply chain.',
            heading: inputType.HEADING,
            colSpan: true,
            options: ['Yes', 'No']
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.68.1 Specify which agricultural or forest management practices with climate change mitigation and/or adaptation benefits you encourage your suppliers to undertake and describe your role in the implementation of each practice',
            tooltip:
              'This question gathers information on which management practice with climate change benefits you encourage your suppliers to undertake and your role on the implementation. This demonstrates to data users that your organization is acting on either preventing, reducing, controlling, and/or adapting to the effects of climate change in its supply chain. By encouraging your suppliers to adopt such management practices on their land, you promote awareness of sustainable production practices and ultimately contribute to reducing climaterelated risks in your supply chain.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q155_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q155_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q156_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q155_VALUE,
            showWhen: ['Yes'],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q156_1_VALUE,
                  fieldLabel: 'Management practice reference number',
                  options: MP_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q156_2_VALUE,
                  fieldLabel: 'Management practice',
                  options: MANAGEMENT_PRACTICE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q156_3_VALUE,
                  fieldLabel: 'Description of management practice',
                  colSpan: true,
                  textLimit: 2400
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q156_4_VALUE,
                  fieldLabel: 'Your role in the implementation',
                  options: YOUR_ROLE_IN_THE_IMPLEMENTATION_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q156_5_VALUE,
                  fieldLabel: 'Explanation of how you encourage implementation',
                  colSpan: true,
                  textLimit: 2400
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q156_6_VALUE,
                  fieldLabel: 'Climate change-related benefit',
                  options: PRIMARY_CLIMATE_CHANGE_RELATED_BENEFIT_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q156_7_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 1000
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.RADIOGROUP,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q157_VALUE,
            fieldLabel:
              '7.68.2 Do you collect information from your suppliers about the outcomes of any implemented agricultural/forest management practices you have encouraged?',
            tooltip:
              'This demonstrates to data users that your organization is committed to working towards reducing the impacts of climate change by not only encouraging its suppliers to adopt practices with climate change benefits but also by assessing these benefits after the practices are implemented. Data users are interested to know whether your organization assesses the impact of its actions to address climate-related risks.',
            heading: inputType.HEADING,
            colSpan: true,
            options: ['Yes', 'No']
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.68.3 Why do you not encourage your suppliers to undertake any agricultural/forest management practices with climate change mitigation and/or adaptation benefits',
            tooltip: `Data users wish to know the main reason why you do not
                      encourage your suppliers to undertake any management
                      practices with climate change benefits and any plans you
                      might have to engage with your suppliers regarding
                      managing practices in the next two years.`,
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q155_VALUE,
              showWhen: ['No'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q155_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q158_VALUE,
            allowMultipleRows: false,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q155_VALUE,
            showWhen: ['No'],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q158_1_VALUE,
                  fieldLabel: 'Primary reason',
                  options: PRIMARY_REASON_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q158_2_VALUE,
                  fieldLabel: 'Please explain',
                  colSpan: true,
                  textLimit: 4000
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.RADIOGROUP,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q159_VALUE,
            fieldLabel:
              '7.69 Do you know if any of the management practices implemented on your own land disclosed in 7.67.1 have other impacts besides climate change mitigation/adaptation?',
            tooltip:
              'Organizations are encouraged to move towards a more holistic approach regarding their land management actions. This is important due to the complex interrelationships between climate change, deforestation, and water security issues. An understanding of the implications of your management practices on other environmental aspects demonstrates a mature environmental stewardship approach to investors and other data users.',
            heading: inputType.HEADING,
            colSpan: true,
            options: ['Yes', 'No']
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.69.1 Provide details on those management practices that have other impacts besides climate change',
            tooltip:
              'This question gathers data on impacts - other climate-related - of management practices implemented in your land. Organizations are encouraged to move towards a more holistic approach regarding their land management actions. This is important due to the complex interrelationships between climate change, deforestation, and water security issues. An understanding of the implications of your management practices on other environmental aspects demonstrates a mature environmental stewardship approach to investors and other data users. ',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q159_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q159_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q160_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q159_VALUE,
            showWhen: ['Yes'],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q160_1_VALUE,
                  fieldLabel: 'Management practice reference number',
                  options: MP_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q160_2_VALUE,
                  fieldLabel: 'Overall effect',
                  options: OVERALL_EFFECT_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q160_3_VALUE,
                  fieldLabel: 'Which of the following has been impacted?',
                  options: IMPACTED_ASPECTS_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q160_4_VALUE,
                  fieldLabel: 'Description of impact',
                  colSpan: true,
                  textLimit: 2400
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q160_5_VALUE,
                  fieldLabel:
                    'Have you implemented any response to these impacts?',
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q160_6_VALUE,
                  fieldLabel: 'Description of the response',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.RADIOGROUP,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q161_VALUE,
            fieldLabel:
              '7.70 Do you know if any of the management practices mentioned in 7.68.1 that were implemented by your suppliers have other impacts besides climate change mitigation/adaptation?',
            tooltip:
              'Organizations are encouraged to adopt, as well as to promote among their suppliers, a holistic approach regarding land management actions. This is important due to the complex interrelationships between climate change, deforestation, and water security issues. Knowledge of the implications of management practices adopted across the whole value chain that impacts other environmental aspects demonstrates a mature environmental stewardship approach to investors and other data users.',
            heading: inputType.HEADING,
            colSpan: true,
            options: ['Yes', 'No']
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.70.1 Provide details of those management practices implemented by your suppliers that have other impacts besides climate change mitigation/adaptation. ',
            tooltip:
              'This question gathers data on impacts - other climate-related - of management practices implemented by your suppliers. Organizations are encouraged to move towards a more holistic approach regarding their land management actions. This is important due to the complex interrelationships between climate change, deforestation, and water security issues. An understanding of the implications of management practices on other environmental aspects demonstrates a mature environmental stewardship approach to investors and other data users.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q161_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q161_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q162_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q161_VALUE,
            showWhen: ['Yes'],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q162_1_VALUE,
                  fieldLabel: 'Management practice reference number',
                  options: MP_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q162_2_VALUE,
                  fieldLabel: 'Overall effect',
                  options: OVERALL_EFFECT_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q162_3_VALUE,
                  fieldLabel: 'Which of the following has been impacted?',
                  options: IMPACTED_ASPECTS_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q162_4_VALUE,
                  fieldLabel: 'Description of impact',
                  colSpan: true,
                  textLimit: 2400
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q162_5_VALUE,
                  fieldLabel:
                    'Have you implemented any response to these impacts?',
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q162_6_VALUE,
                  fieldLabel: 'Description of the response',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.71 Does your organization assess the life cycle emissions of any of its products or services?',
            tooltip:
              'Stakeholders are increasingly requesting companies to measure and disclose their productand service-related emissions. Emissions are linked to every stage of the product or service life cycle - from raw material acquisition to end-of-life treatment. Understanding and measuring emissions across the life cycle can help companies focus emissions reduction efforts on the most energy intensive operations across the whole life cycle, rather than just in the production process.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q163_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q163_1_VALUE,
                  fieldLabel: 'Assessment of life cycle emissions',
                  options: ASSESSMENT_OF_LIFE_CYCLE_EMISSIONS_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q163_2_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.71.1 Provide details of how your organization assesses the life cycle emissions of its products or services',
            tooltip:
              'To acquire an overall understanding of the total carbon impact of a product or service, it is necessary to assess emissions from the production process and use phase, but also emissions associated with the acquisition and disposal of the materials that make up the product. This question provides data users with information on your organization’s approach to assessing product life cycle emissions, including the life cycle stages covered and the methodologies used.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q163_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q163_1_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q164_VALUE,
            allowMultipleRows: false,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q163_1_VALUE,
            showWhen: ['Yes'],
            relatedTableKey:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q163_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q164_1_VALUE,
                  fieldLabel: 'Products/services assessed',
                  options: PRODUCT_OR_SERVICE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q164_2_VALUE,
                  fieldLabel: 'Life cycle stage(s) most commonly covered',
                  options: LIFE_CYCLE_STAGES_COVERED_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q164_3_VALUE,
                  fieldLabel: 'Methodologies/standards/tools applied',
                  options: METHODOLOGIES_STANDARDS_TOOLS_APPLIED_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q164_4_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.72 Does your organization assess the life cycle emissions of new construction or major renovation projects?',
            tooltip:
              'GHG emissions or energy consumption are linked to every stage of the life cycle of buildings – starting from extraction or manufacturing of materials and their transportation, through construction, use phase and to final demolition of buildings. Understanding and consistent measurement of life cycle emissions of built projects is important for identifying the best opportunities for reducing lifetime emissions and target setting.',
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q165_VALUE
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q165_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q165_1_VALUE,
                  fieldLabel: 'Assessment of life cycle emissions',
                  options: ASSESSMENT_OF_LIFE_CYCLE_EMISSIONS_OPTIONS_2,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q165_2_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.72.1 Provide details of how your organization assesses the life cycle emissions of new construction or major renovation projects.',
            tooltip:
              'To acquire an overall understanding of a built project’s total carbon impact, it is necessary to assess both the anticipated operational emissions and the embodied emissions. Low-carbon design practices, especially those targeting embodied carbon, are most efficient as well as most cost-effective in the early phases of a project. This question provides data users with information on how early in a project you normally assess carbon emissions, as well as life cycle stages and methodologies most commonly applied. ',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q165_VALUE,
              showWhen: [
                'Yes, quantitative assessment',
                'Yes, qualitative assessment',
                'Yes, both qualitative and quantitative assessment'
              ],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q165_1_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q166_VALUE,
            allowMultipleRows: false,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q165_1_VALUE,
            showWhen: [
              'Yes, quantitative assessment',
              'Yes, qualitative assessment',
              'Yes, both qualitative and quantitative assessment'
            ],
            relatedTableKey:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q165_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q166_1_VALUE,
                  fieldLabel: 'Projects assessed',
                  options: PROJECTS_ASSESSED_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q166_2_VALUE,
                  fieldLabel:
                    'Earliest project phase that most commonly includes an assessment',
                  options:
                    EARLIEST_PROJECT_PHASE_THAT_MOST_COMMONLY_INCLUDES_AN_ASSESSMENT_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q166_3_VALUE,
                  fieldLabel: 'Life cycle stage(s) most commonly covered',
                  options: LIFE_CYCLE_STAGES_COVERED_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q166_4_VALUE,
                  fieldLabel: 'Methodologies/standards/tools applied',
                  options: METHODOLOGIES_STANDARDS_TOOLS_APPLIED_OPTIONS_2,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q166_5_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.72.2 Can you provide embodied carbon emissions data for any of your organization’s new construction or',
            tooltip:
              'Consideration of embodied carbon at the initial design and construction stages is necessary in order to achieve the required GHG reductions. The relative significance of embodied carbon is increasing, due to the decarbonization of the grid and increased operational efficiency of buildings. This and the follow-up question provide investors and other data users with information on the embodied carbon of buildings that your organization completed in the last three years or the reasons you are not able to calculate or disclose this data. ',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q165_VALUE,
              showWhen: [
                'Yes, quantitative assessment',
                'Yes, qualitative assessment',
                'Yes, both qualitative and quantitative assessment'
              ],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q165_1_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q167_VALUE,
            allowMultipleRows: false,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q165_1_VALUE,
            showWhen: [
              'Yes, quantitative assessment',
              'Yes, qualitative assessment',
              'Yes, both qualitative and quantitative assessment'
            ],
            relatedTableKey:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q165_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q167_1_VALUE,
                  fieldLabel: 'Ability to disclose embodied carbon emissions',
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q167_2_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.72.3 Provide details of the embodied carbon emissions of new construction or major renovation projects',
            tooltip:
              'Consideration of embodied carbon at the initial design and construction stages is necessary in order to achieve the required GHG reductions. The relative significance of embodied carbon is increasing, due to the decarbonization of the grid and increased operational efficiency of buildings. This question provides investors and data users with information on the embodied carbon of buildings that you completed in the last three years or the reasons you are not able to calculate or disclose these data. ',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q167_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q167_1_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q168_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q167_1_VALUE,
            showWhen: ['Yes'],
            relatedTableKey:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q167_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q168_1_VALUE,
                  fieldLabel: 'Year of completion',
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q168_2_VALUE,
                  fieldLabel: 'Property sector',
                  options: PROPERTY_SECTOR_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q168_3_VALUE,
                  fieldLabel: 'Type of project',
                  options: TYPE_OF_PROJECT_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q168_4_VALUE,
                  fieldLabel: 'Project name/ID (optional)',
                  colSpan: true,
                  textLimit: 2400
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q168_5_VALUE,
                  fieldLabel: 'Life cycle stage(s) covered',
                  options: LIFE_CYCLE_STAGES_COVERED_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q168_6_VALUE,
                  fieldLabel: 'Normalization factor (denominator)',
                  options: NORMALIZATION_FACTOR_DENOMINATOR_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q168_7_VALUE,
                  fieldLabel: 'Denominator unit',
                  options: DENOMINATOR_UNIT_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q168_8_VALUE,
                  fieldLabel:
                    'Embodied carbon (kgCO2e per the denominator unit)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q168_9_VALUE,
                  fieldLabel:
                    '% of new construction/major renovation projects in the last three years covered by this metric (by floor area)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q168_10_VALUE,
                  fieldLabel: 'Methodologies/standards/tools applied',
                  options: METHODOLOGIES_STANDARDS_TOOLS_APPLIED_OPTIONS_2,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q168_11_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.SELECT,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q169_VALUE,
            fieldLabel:
              '7.73 Are you providing product level data for your organization’s goods or services?',
            tooltip:
              'CDP Supply Chain members are interested in the granularity of data that their suppliers can provide regarding the emissions intensities, lifecycle emissions, and emissions reduction initiatives. This type of data can allow all parties involved to observe product/service resource intensities, track changes in this Supply Chain-specific data, and progress being made via initiatives. ',
            heading: inputType.HEADING,
            colSpan: true,
            options:
              ARE_YOU_PROVIDING_PRODUCT_LEVEL_DATA_FOR_YOUR_ORGANIZATION_S_GOODS_OR_SERVICES_OPTIONS
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q170_VALUE,
            fieldLabel:
              '7.73.1 Give the overall percentage of total emissions, for all Scopes, that are covered by these products.',
            tooltip:
              'This question aims to assess the GHG relevance of the products you are disclosing information on.',
            heading: inputType.HEADING,
            colSpan: true,
            roundTo: 2
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.73.2 Complete the following table for the goods/services for which you want to provide data.',
            tooltip:
              'CDP Supply Chain members are interested in the emissions intensities associated with the goods/services they are purchasing. This question allows your organization to provide these details, while outlining the methodologies used by your organization to estimate these for your goods/services.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q169_VALUE,
              showWhen: [
                'Yes I will provide data through the CDP questionnaire',
                'Yes I will provide data through the CDP x CO2 AI Product Ecosystem tool'
              ],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q169_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q171_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q169_VALUE,
            showWhen: [
              'Yes I will provide data through the CDP questionnaire',
              'Yes I will provide data through the CDP x CO2 AI Product Ecosystem tool'
            ],
            formList: {
              formFields: [
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q171_1_VALUE,
                  fieldLabel: 'Requesting member',
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q171_2_VALUE,
                  fieldLabel: 'Name of good/service',
                  colSpan: true,
                  textLimit: 2400
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q171_3_VALUE,
                  fieldLabel: 'Description of good/service',
                  colSpan: true,
                  textLimit: 2400
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q171_4_VALUE,
                  fieldLabel: 'Type of product',
                  options: TYPE_OF_PRODUCT_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q171_5_VALUE,
                  fieldLabel: 'Unique product identifier',
                  colSpan: true,
                  textLimit: 50
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q171_6_VALUE,
                  fieldLabel: 'Total emissions (kg CO2e per unit)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q171_7_VALUE,
                  fieldLabel: '± % change from previous figure supplied',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q171_8_VALUE,
                  fieldLabel: 'Date of previous figure supplied',
                  colSpan: true,
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q171_9_VALUE,
                  fieldLabel: 'Explanation of change',
                  colSpan: true,
                  textLimit: 2400
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q171_10_VALUE,
                  fieldLabel: 'Methods used to estimate lifecycle emissions',
                  options: METHODOLOGIES_STANDARDS_TOOLS_APPLIED_OPTIONS,
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.73.3 Complete the following table with data for lifecycle stages of your goods and/or services.',
            tooltip:
              'This question only appears if you select “Yes, I will provide data through the CDP Questionnaire”, or “Yes, I will provide data through the CDP x CO2 AI Product Ecosystem tool” in response to 7.73. No change CDP Supply Chain members are interested in the lifecycle emissions of the goods/services they are purchasing. This question allows your organization to provide these details, while outlining the lifecycle stages considered by your organization for these goods/services.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q169_VALUE,
              showWhen: [
                'Yes I will provide data through the CDP questionnaire',
                'Yes I will provide data through the CDP x CO2 AI Product Ecosystem tool'
              ],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q169_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q172_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q169_VALUE,
            showWhen: [
              'Yes I will provide data through the CDP questionnaire',
              'Yes I will provide data through the CDP x CO2 AI Product Ecosystem tool'
            ],
            formList: {
              formFields: [
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q172_1_VALUE,
                  fieldLabel: 'Requesting member',
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q172_2_VALUE,
                  fieldLabel: 'Name of good/service',
                  colSpan: true,
                  textLimit: 2500
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q172_3_VALUE,
                  fieldLabel: 'Scope',
                  options: SCOPE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q172_4_VALUE,
                  fieldLabel: 'Lifecycle stage',
                  options: LIFECYCLE_STAGE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q172_5_VALUE,
                  fieldLabel:
                    'Emissions at the lifecycle stage (kg CO2e per unit)',
                  colSpan: true,
                  roundTo: 10
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q172_6_VALUE,
                  fieldLabel: 'Lifecycle stage under your ownership or control',
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q172_7_VALUE,
                  fieldLabel: 'Type of data used',
                  options: TYPE_OF_DATA_USED_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q172_8_VALUE,
                  fieldLabel: 'Data quality',
                  colSpan: true,
                  textLimit: 2500
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q172_9_VALUE,
                  fieldLabel:
                    'If applicable, describe the verification/assurance of the product emissions data',
                  colSpan: true,
                  textLimit: 5000
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.73.4 Please detail emissions reduction initiatives completed or planned for this product.',
            tooltip:
              'CDP supply chain members are interested in emissions reduction initiatives completed or planned for the goods/services they are purchasing. This question allows your organization to provide these details, while outlining the emissions reductions achieved or projected.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q169_VALUE,
              showWhen: [
                'Yes I will provide data through the CDP questionnaire',
                'Yes I will provide data through the CDP x CO2 AI Product Ecosystem tool'
              ],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q169_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q173_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q169_VALUE,
            showWhen: [
              'Yes I will provide data through the CDP questionnaire',
              'Yes I will provide data through the CDP x CO2 AI Product Ecosystem tool'
            ],
            formList: {
              formFields: [
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q173_1_VALUE,
                  fieldLabel: 'Name of good/service',
                  colSpan: true,
                  textLimit: 2500
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q173_2_VALUE,
                  fieldLabel: 'Initiative ID',
                  options: INITIATIVE_ID_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q173_3_VALUE,
                  fieldLabel: 'Description of initiative',
                  colSpan: true,
                  textLimit: 2500
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q173_4_VALUE,
                  fieldLabel: 'Completed or planned',
                  options: COMPLETED_OR_PLANNED_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q173_5_VALUE,
                  fieldLabel: 'Emissions reductions (kg CO2e per unit)',
                  colSpan: true,
                  roundTo: 2
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.RADIOGROUP,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q174_VALUE,
            fieldLabel:
              '7.73.5 Have any of the initiatives described in 7.73.4 been driven by requesting CDP Supply Chain members?',
            tooltip:
              'Data users are interested in understanding the extent to which the initiatives you engage in (as disclosed in 7.73.4), have been driven by your requesting Supply Chain member. This can help provide an insight to the extent that organizations engage to improve resource efficiency and reduce their impact on the resource intensity of goods/services provided.',
            heading: inputType.HEADING,
            colSpan: true,
            options: ['Yes', 'No']
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.73.6 Explain which initiatives have been driven by requesting members.',
            tooltip:
              'Data users are interested in understanding the extent to which the initiatives you engage in (as disclosed in 7.73.4), have been driven by your requesting Supply Chain member. This can help provide an insight to the extent that organizations engage to improve resource efficiency and reduce their impact on the resource intensity of goods/services provided.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q174_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q174_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q175_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q174_VALUE,
            showWhen: ['Yes'],
            formList: {
              formFields: [
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q175_1_VALUE,
                  fieldLabel: 'Requesting member',
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q175_2_VALUE,
                  fieldLabel: 'Name of good/service',
                  colSpan: true,
                  textLimit: 2500
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q175_3_VALUE,
                  fieldLabel: 'Initiative ID',
                  options: INITIATIVE_ID_OPTIONS,
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.RADIOGROUP,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q176_VALUE,
            fieldLabel:
              '7.74 Do you classify any of your existing goods and/or services as low-carbon products?',
            tooltip:
              'This question provides valuable information to investors who are seeking to increase their investment in companies providing low-carbon goods and services.',
            heading: inputType.HEADING,
            colSpan: true,
            options: ['Yes', 'No']
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.74.1 Provide details of your products and/or services that you classify as low-carbon products.',
            tooltip:
              'This question provides valuable information to investors who are seeking to increase their investment in companies providing low-carbon goods and services.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q176_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q176_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q176_VALUE,
            showWhen: ['Yes'],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_1_VALUE,
                  fieldLabel: 'Level of aggregation',
                  options: LEVEL_OF_AGGREGATION_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_2_VALUE,
                  fieldLabel:
                    'Taxonomy used to classify product(s) or service(s) as low-carbon',
                  options:
                    TAXONOMY_USED_TO_CLASSIFY_PRODUCTS_OR_SERVICES_AS_LOW_CARBON_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_3_VALUE,
                  fieldLabel: 'Type of product(s) or service(s)',
                  options: TYPES_OF_PRODUCTS_OR_SERVICES_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_4_VALUE,
                  fieldLabel: 'Description of product(s) or service(s)',
                  colSpan: true,
                  textLimit: 1500
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_5_VALUE,
                  fieldLabel:
                    'Have you estimated the avoided emissions of this low-carbon product(s) or service(s)?',
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_6_VALUE,
                  fieldLabel: 'Methodology used to calculate avoided emissions',
                  options: METHOD_USED_TO_CALCULATE_AVOIDED_EMISSIONS_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_5_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_5_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Yes'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_5_VALUE
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_7_VALUE,
                  fieldLabel:
                    'Life cycle stage(s) covered for the low-carbon product(s) or service(s)',
                  options: LIFE_CYCLE_STAGES_COVERED_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_5_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_5_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Yes'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_5_VALUE
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_8_VALUE,
                  fieldLabel: 'Functional unit used',
                  colSpan: true,
                  textLimit: 500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_5_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_5_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Yes'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_5_VALUE
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_9_VALUE,
                  fieldLabel:
                    'Reference product/service or baseline scenario used',
                  colSpan: true,
                  textLimit: 500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_5_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_5_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Yes'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_5_VALUE
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_10_VALUE,
                  fieldLabel:
                    'Life cycle stage(s) covered for the reference product/service or baseline scenario',
                  options: LIFE_CYCLE_STAGES_COVERED_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_5_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_5_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Yes'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_5_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_11_VALUE,
                  fieldLabel:
                    'Estimated avoided emissions (metric tons CO2e per functional unit) compared to reference product/service or baseline scenario',
                  colSpan: true,
                  roundTo: 10,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_5_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_5_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Yes'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_5_VALUE
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_12_VALUE,
                  fieldLabel:
                    'Explain your calculation of avoided emissions, including any assumptions',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_5_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_5_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Yes'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_5_VALUE
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q177_13_VALUE,
                  fieldLabel:
                    'Revenue generated from low-carbon product(s) or service(s) as % of total revenue in the reporting year',
                  colSpan: true,
                  roundTo: 3
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.75 Provide tracking metrics for the implementation of low-carbon transport technology over the reporting year',
            tooltip:
              'This question seeks to understand how low-carbon transport technologies are being implemented by analyzing the level of proliferation and market penetration of alternative drive train and engine technologies. This is mostly relevant for LDV and HDV, for which alternative technologies are available or being piloted. This is also relevant for aviation, rail and marine companies who can use this as a more open-ended question to indicate what they are doing in the low-carbon technology field. '
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q178_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q178_1_VALUE,
                  fieldLabel: 'Activity',
                  options: TRANSPORT_MODE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q178_2_VALUE,
                  fieldLabel: 'Metric',
                  options: METRIC_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q178_3_VALUE,
                  fieldLabel: 'Technology',
                  options: TECHNOLOGY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q178_4_VALUE,
                  fieldLabel: 'Metric figure',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q178_5_VALUE,
                  fieldLabel: 'Metric unit',
                  options: METRIC_UNIT_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q178_6_VALUE,
                  fieldLabel: 'Explanation',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.SELECT,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q179_VALUE,
            fieldLabel:
              '7.76 Does your organization manage net zero carbon buildings?',
            tooltip: `In line with the TCFD recommendations, regulatory measures such as a transition to lowcarbon properties may affect the financial viability of existing properties. Understanding the
percentage of net zero carbon buildings provides investors with an indication of the potential impact of regulatory measures on your portfolio/ buildings you deliver.`,
            heading: inputType.HEADING,
            colSpan: true,
            options: FURTURE_PLANS_OPTIONS
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.76.1 Provide details of the net zero carbon buildings under your organization’s management in the reporting year',
            tooltip:
              'In line with the TCFD’s recommendations, regulatory measures such as a transition to lowcarbon properties may affect the financial viability of existing properties. Understanding the percentage of net zero carbon buildings provides investors with an indication of the potential impact of regulatory measures on your portfolio. It is acknowledged that certification schemes for net zero carbon buildings are not yet widely available, but where they are, they provide additional credibility to self-evaluated and reported statements regarding net zero carbon. ',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q179_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q179_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q180_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q179_VALUE,
            showWhen: ['Yes'],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q180_1_VALUE,
                  fieldLabel: 'Property sector',
                  options: PROPERTY_SECTOR_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q180_2_VALUE,
                  fieldLabel: 'Definition(s) of net zero carbon applied',
                  options: DEFINITION_OF_NET_ZERO_CARBON_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q180_3_VALUE,
                  fieldLabel:
                    '% of net zero carbon buildings in the total portfolio (by floor area)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q180_4_VALUE,
                  fieldLabel:
                    'Have any of the buildings been certified as net zero carbon?',
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q180_5_VALUE,
                  fieldLabel:
                    '% of buildings certified as net zero carbon in the total portfolio (by floor area)',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q180_4_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q180_4_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Yes'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q180_4_VALUE
                  }
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q180_6_VALUE,
                  fieldLabel: 'Certification scheme(s)',
                  options: CERTIFICATION_SCHEME_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q180_7_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.SELECT,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q181_VALUE,
            fieldLabel:
              '7.77 Did your organization complete new construction or major renovations projects designed as net zero carbon in the last three years?',
            tooltip:
              'In line with TCFD recommendations, regulatory measures such as a transition to low-carbon properties may affect the financial viability of existing properties. Understanding the percentage of net zero carbon buildings provides investors with an indication of the potential impact of regulatory measures on buildings you deliver. ',
            heading: inputType.HEADING,
            colSpan: true,
            options: FURTURE_PLANS_OPTIONS
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.77.1 Provide details of new construction or major renovations projects completed in the last 3 years that',
            tooltip:
              'Understanding the percentage of your organizations’ new construction or major renovations projects that were designed as net zero carbon provides investors with an indication of the potential impact of regulatory measures on your business. It is acknowledged that certification schemes for net zero carbon buildings are not yet widely available, but where they are, they provide additional credibility to self-evaluated and reported statements regarding net zero carbon.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q181_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q181_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q182_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q181_VALUE,
            showWhen: ['Yes'],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q182_1_VALUE,
                  fieldLabel: 'Property sector',
                  options: PROPERTY_SECTOR_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q182_2_VALUE,
                  fieldLabel: 'Definition(s) of net zero carbon applied',
                  options: DEFINITION_OF_NET_ZERO_CARBON_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q182_3_VALUE,
                  fieldLabel:
                    '% of net zero carbon buildings in the total number of buildings completed in the last 3 years',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q182_4_VALUE,
                  fieldLabel:
                    'Have any of the buildings been certified as net zero carbon?',
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q182_5_VALUE,
                  fieldLabel:
                    '% of buildings certified as net zero carbon in the total number of buildings completed in the last 3 years',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q182_4_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q182_4_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Yes'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q182_4_VALUE
                  }
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q182_6_VALUE,
                  fieldLabel: 'Certification scheme(s)',
                  options: CERTIFICATION_SCHEME_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q182_7_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 2400
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.WYSIWYG,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q183_VALUE,
            fieldLabel:
              '7.78 Explain your organization’s plan to manage, develop or construct net zero carbon buildings, or explain',
            tooltip:
              'This question helps CDP data users to understand the anticipated pace and extent of the transition to net zero carbon buildings and barriers that organizations are experiencing in delivering and operating them.',
            heading: inputType.HEADING,
            colSpan: true,
            textLimit: 5000
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.RADIOGROUP,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q184_VALUE,
            fieldLabel:
              '7.79 Has your organization retired any project-based carbon credits within the reporting year?',
            tooltip:
              'Carbon credits are used by organizations for the purposes of compliance or as voluntary carbon offsets and can support the transition to a low carbon future. Information about carbon credits helps data users understand the extent to which companies are meeting their climate commitments through emission reductions or offsets.',
            heading: inputType.HEADING,
            options: ['Yes', 'No'],
            colSpan: true
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '7.79.1 Provide details of the project-based carbon credits retired by your organization in the reporting year.',
            tooltip:
              'Carbon credits can be originated from a variety of projects and are verified to a number of standards. Data users are interested in learning about the quality of projects, scope of project types, the objectives of organizations who have canceled carbon credits and the extent to which the credits are used to achieve these objectives. ',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q184_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q184_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_VALUE,
            dependsOn:
              CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q184_VALUE,
            showWhen: ['Yes'],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_1_VALUE,
                  fieldLabel: 'Project type',
                  options: PROJECT_TYPE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_2_VALUE,
                  fieldLabel: 'Type of mitigation activity',
                  options: TYPE_OF_MITIGATION_ACTIVITY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_3_VALUE,
                  fieldLabel: 'Project description',
                  colSpan: true,
                  textLimit: 2500
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_4_VALUE,
                  fieldLabel:
                    'Credits retired by your organization from this project in the reporting year (metric tons CO2e)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_5_VALUE,
                  fieldLabel: 'Purpose of retirement',
                  options: PURPOSE_OF_RETIREMENT_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_6_VALUE,
                  fieldLabel:
                    'Are you able to report the vintage of the credits at retirement?',
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_7_VALUE,
                  fieldLabel: 'Vintage of the credits at retirement',
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_6_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_6_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Yes'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_6_VALUE
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_8_VALUE,
                  fieldLabel:
                    'Were these credits issued to or purchased by your organization?',
                  options:
                    WERE_THESE_CREDITS_ISSUED_OR_PURCHASED_BY_YOUR_ORGANIZATION_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_9_VALUE,
                  fieldLabel:
                    'Carbon-crediting program by which the credits were issued',
                  options:
                    CARBON_CREDITING_PROGRAM_BY_WHICH_THE_CREDITS_WERE_ISSUED_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_10_VALUE,
                  fieldLabel:
                    'Methods the program uses to assess additionality for this project',
                  options:
                    METHODS_THE_PROGRAM_USES_TO_ASSESS_ADDITIONALITY_FOR_THIS_PROJECT_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_9_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Not issued by a program']
                  },
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_9_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Not issued by a program'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_9_VALUE
                  }
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_11_VALUE,
                  fieldLabel:
                    'Approaches by which the selected program requires this project to address reversal risk',
                  options:
                    APPROACHES_BY_WHICH_THE_SELECTED_PROGRAM_REQUIRES_THIS_PROJECT_TO_ADDRESS_REVERSAL_RISK_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_12_VALUE,
                  fieldLabel:
                    'Potential sources of leakage the selected program requires this project to have assessed',
                  options:
                    POTENTIAL_SOURCES_OF_LEAKAGE_THE_SELECTED_PROGRAM_REQUIRES_THIS_PROJECT_TO_HAVE_ASSESSED_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_13_VALUE,
                  fieldLabel:
                    'Provide details of other issues the selected program requires projects to address',
                  colSpan: true,
                  textLimit: 2500
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CLIMATE_CHANGE_FIELD_NAMES.CORPORATE_PERFORMANCE_CLIMATE_CHANGE_Q185_14_VALUE,
                  fieldLabel: 'Please explain',
                  colSpan: true,
                  textLimit: 2500
                }
              ]
            }
          }
        ]
      }
    ]
  }
];
